import type { Dict } from '../types';

export const zhCN: Dict = {
  'chat.amrCard.switchTitle': '模型调用失败，当前任务已暂停',
  'chat.amrCard.switchBody': '可切换到 Open Design 官方 AMR 模型服务，无需配置 API Key。完成登录、授权和充值后，将自动重试当前任务。',
  'chat.amrCard.chipOfficial': '官方托管',
  'chat.amrCard.chipNoKey': '无需 API Key',
  'chat.amrCard.chipAutoRetry': '授权后自动重试',
  'chat.amrCard.switchCta': '切换到 AMR 并重试',
  'chat.amrError.authMessage': 'AMR 账号尚未授权。完成授权后将自动重试当前任务。',
  'chat.amrError.balanceMessage': 'AMR 账户余额不足。充值后可继续运行当前任务。',
  'chat.amrError.authorizeCta': '授权并重试',
  'chat.amrError.rechargeCta': '为 AMR 充值',
  'chat.antigravityError.launchTerminalCta': '在终端中登录',
  'chat.antigravityError.launchSwitchModelCta': '在终端中切换模型',
  'chat.connectionDropped': '与模型服务的连接在响应完成前中断了——通常是网络或代理不稳定。请重试。',
  'common.cancel': '取消',
  'common.save': '保存',
  'common.close': '关闭',
  'common.clear': '清除',
  'common.delete': '删除',
  'common.rename': '重命名',
  'common.edit': '编辑',
  'common.preview': '预览',
  'common.share': '分享',
  'common.search': '搜索',
  'common.searchEllipsis': '搜索…',
  'common.loading': '加载中…',
  'common.all': '全部',
  'common.none': '无',
  'common.default': '默认',
  'common.installed': '已安装',
  'common.notInstalled': '未安装',
  'common.active': '使用中',
  'common.offline': '未运行',
  'common.selected': '已选',
  'common.create': '创建',
  'common.openPreview': '打开预览',
  'common.exitFullscreen': '退出全屏',
  'common.fullscreen': '全屏',
  'common.openInNewTab': '在新标签页中打开',
  'common.exportPdf': '导出为 PDF',
  'common.exportZip': '下载为 .zip',
  'common.exportHtml': '导出为独立 HTML',
  'common.exportImage': '导出为图片',
  'common.exportImageFailed': '图片截图失败，请重试或使用浏览器的截图工具。',
  'common.justNow': '刚刚',
  'common.minutesAgo': '{n} 分钟前',
  'common.hoursAgo': '{n} 小时前',
  'common.daysAgo': '{n} 天前',
  'common.weeksAgo': '{n} 周前',
  'common.now': '刚刚',
  'common.minutesShort': '{n}分',
  'common.hoursShort': '{n}时',
  'common.daysShort': '{n}天',
  'common.untitled': '未命名',
  'plugins.availableDetails.provenance': '来源',
  'plugins.availableDetails.provenanceLine': '来自 {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': '来自 {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': '安装',
  'plugins.availableDetails.version': '版本',
  'plugins.availableDetails.pluginVersion': '插件版本',
  'plugins.availableDetails.copyInstallCommand': '复制安装命令',
  'plugins.availableDetails.copied': '已复制',
  'plugins.availableDetails.deprecatedPrefix': '已弃用：{message}',
  'plugins.availableDetails.deprecatedFallback': '此版本已标记为弃用。',
  'plugins.availableDetails.yanked': '已撤回。',
  'plugins.availableDetails.yankedWithReason': '已撤回：{reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': '（已弃用）',
  'plugins.availableDetails.versionYankedSuffix': '（已撤回）',
  'plugins.availableDetails.ref': '引用',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': '权限',
  'plugins.availableDetails.capabilitySummary': '能力摘要',
  'plugins.actions.copyInstallCommand': '复制安装命令',
  'plugins.actions.copyPluginId': '复制插件 ID',
  'plugins.actions.copyReadmeBadge': '复制 README 徽章',
  'plugins.actions.openSourceGithub': '在 GitHub 打开源码',
  'plugins.actions.openSource': '打开源码',
  'plugins.actions.openHomepage': '打开项目主页',
  'plugins.actions.openMarketplace': '在插件市场打开',
  'app.brand': 'Open Design',
  'app.brandPill': '研究预览版',
  'app.brandSubtitle': '由 Nexu Labs 出品',
  'app.welcomeLoading': '正在加载工作区…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': '欢迎',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': '从一句需求开始',
  'settings.onboardingCreateBody': '描述你想做的网站、应用、Deck、图片或视频，Open Design 会创建项目，并保留可继续编辑的产物。',
  'settings.onboardingMemoryTitle': '保存工作上下文',
  'settings.onboardingMemoryBody': '把偏好、项目事实和长期规则写入 Memory，后续对话会自动带上正确背景。',
  'settings.onboardingSystemsTitle': '接入你的设计系统',
  'settings.onboardingSystemsBody': '选择或创建品牌系统，让生成结果跟随真实的颜色、字体和产品语言。',
  'settings.onboardingExecutionTitle': '选择生成方式',
  'settings.onboardingExecutionBody': '官方 CLI，一键配置、开箱即用。一个 Key 自由选择海量模型，价格更优惠。',
  'settings.onboardingAmrCloudBenefitOfficial': '官方推荐',
  'settings.onboardingAmrCloudBenefitReady': '免部署即用',
  'settings.onboardingAmrCloudBenefitModels': '支持 Claude Opus 4.8',
  'settings.onboardingAmrCloudBenefitPricing': 'SOTA Harness',
  'settings.onboardingAmrCloudUpcomingLabel': '即将支持',
  'settings.onboardingAmrCloudUpcomingImageVideo': '生图/视频',
  'settings.onboardingAmrCloudUpcomingSkills': '海量 Skills',
  'settings.onboardingAmrCloudUpcomingRouting': '智能路由',
  'settings.onboardingAmrModelSourceLabel': 'AMR CLI',
  'settings.onboardingAmrCloudAuthorizeAction': '授权 AMR',
  'settings.onboardingAmrCloudAuthorizedAction': '已授权',
  'settings.onboardingStepConnect': '连接',
  'settings.onboardingStepDesignSystem': '设计系统',
  'settings.onboardingStepProfile': '了解你',
  'settings.onboardingStepNewsletter': '获取最新动态',
  'settings.onboardingNewsletterTitle': '获取最新动态',
  'settings.onboardingNewsletterBody': '留下邮箱，接收产品更新、新模板、设计系统资源和社区活动。',
  'settings.onboardingConnectTitle': '选择运行方式',
  'settings.onboardingConnectBody': '',
  'settings.onboardingGateTooltipNoRuntime': '后续流程由 AI 运行，请先选择一种运行方式。',
  'settings.onboardingGateTooltipAmr': '后续流程由 AI 运行，请先登录 Open Design AMR。',
  'settings.onboardingGateTooltipLocal': '后续流程由 AI 运行，请先选择一个可用的本地 CLI。',
  'settings.onboardingGateTooltipByok': '后续流程由 AI 运行，请先填写并测试通过你的模型 Key。',
  'settings.onboardingRecommended': '推荐',
  'settings.onboardingAmrCloudOfficialBadge': '官方',
  'settings.onboardingLocalTitle': '本地 Coding Agent',
  'settings.onboardingLocalBody': '使用已安装的 CLI，如 Claude Code、Codex、Cursor、Gemini 或 OpenCode。',
  'settings.onboardingLocalAction': '打开 CLI 设置',
  'settings.onboardingCliScanHint': '通常 5 到 10 秒内完成扫描。',
  'settings.onboardingByokTitle': '自己的模型 Key',
  'settings.onboardingByokBody': '使用你自己的模型服务凭证。',
  'settings.onboardingByokAction': '打开 BYOK 设置',
  'settings.onboardingDesignTitle': '设计系统',
  'settings.onboardingDesignBody': '生成一次，后续复用。',
  'settings.onboardingDesignIntroGenerateTitle': '用已有内容生成',
  'settings.onboardingDesignIntroGenerateBody': '从 GitHub、本地代码仓库、Figma 文件，或现成图片等内容资产中上传你的设计系统。',
  'settings.onboardingDesignIntroReuseTitle': '后续产物直接复用',
  'settings.onboardingDesignIntroReuseBody': '后续生成原型、Slide 和其他内容时，都可以参考现有的字体、间距、Logo 样式、色调等。',
  'settings.onboardingDesignIntroSkipTitle': '也可以先跳过',
  'settings.onboardingDesignIntroSkipBody': '现在不想生成也没关系，可以直接进入产品。',
  'settings.onboardingGithubTitle': '从 GitHub 导入',
  'settings.onboardingGithubBody': '使用前端仓库。',
  'settings.onboardingUploadTitle': '上传本地文件',
  'settings.onboardingUploadBody': '添加项目文件、截图、CSS、文档或素材。',
  'settings.onboardingPromptTitle': '用一句话生成',
  'settings.onboardingPromptBody': '描述产品或品牌。',
  'settings.onboardingProfileTitle': '关于你',
  'settings.onboardingProfileBody': '可选信息，用于优化默认配置。',
  'settings.onboardingRoleLabel': '你的身份',
  'settings.onboardingOrgSizeLabel': '组织规模',
  'settings.onboardingUseCaseLabel': '使用场景',
  'settings.onboardingSourceLabel': '从哪里听说的',
  'settings.onboardingSelectPlaceholder': '请选择',
  'settings.onboardingSelectMultiplePlaceholder': '可选择多个',
  'settings.onboardingOrgSolo': '个人使用（1 人）',
  'settings.onboardingOrgTeam': '小团队（2-10 人）',
  'settings.onboardingOrgStartup': '初创 / 中小企业（11-50 人）',
  'settings.onboardingOrgGrowth': '成长期公司（51-200 人）',
  'settings.onboardingOrgMidMarket': '中大型公司（201-1000 人）',
  'settings.onboardingOrgEnterprise': '大型企业（1000+ 人）',
  'settings.onboardingRolePm': '📋 产品经理',
  'settings.onboardingRoleDesigner': '🎨 设计师',
  'settings.onboardingRoleEngineer': '💻 研发',
  'settings.onboardingRoleMarketing': '📣 营销',
  'settings.onboardingRoleGrowth': '📈 增长',
  'settings.onboardingRoleOps': '⚙️ 运营',
  'settings.onboardingRoleFounder': '🚀 创始人 / 管理者',
  'settings.onboardingRoleStudent': '🎓 学生 / 教育者',
  'settings.onboardingRoleOther': '✨ 其他',
  'settings.onboardingUseProduct': '🎨 产品设计',
  'settings.onboardingUseDesignSystem': '🧩 设计系统',
  'settings.onboardingUsePrototype': '📱 原型 / 应用界面',
  'settings.onboardingUseLanding': '🌐 落地页',
  'settings.onboardingUseAds': '📣 广告 / 社媒内容',
  'settings.onboardingUseDashboard': '📊 仪表盘 / 内部工具',
  'settings.onboardingUseDeck': '🖥️ 演示文稿 / 提案',
  'settings.onboardingUseMarketing': '📈 营销 / 增长',
  'settings.onboardingUseEngineering': '🤝 工程交付',
  'settings.onboardingUseAgency': '💼 代理商 / 客户项目',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceFriend': '👥 朋友或同事',
  'settings.onboardingSourceSocial': '📱 社交媒体',
  'settings.onboardingSourceProductHunt': '🅿️ Product Hunt',
  'settings.onboardingSourceCommunity': '💬 设计 / AI 社区',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceBlog': '📰 博客或 Newsletter',
  'settings.onboardingSourceAiTool': '✨ AI 工具推荐',
  'settings.onboardingSourceSearch': '🔍 搜索',
  'settings.onboardingSourceEvent': '🎤 活动或社区',
  'settings.onboardingBack': '上一步',
  'settings.onboardingContinue': '继续',
  'settings.onboardingFinish': '完成',
  'settings.kicker': '设置',
  'settings.title': '执行模式',
  'settings.subtitle': '在本机 CLI 与 BYOK 之间选择。',
  'settings.modeAria': '执行模式',
  'settings.protocolAria': 'API 协议',
  'settings.modeDaemon': '本机 CLI',
  'settings.modeDaemonHelp': '通过本机的代码代理 CLI 执行',
  'settings.modeDaemonOffline': '后台守护进程未运行',
  'settings.modeDaemonOfflineMeta': '守护进程未运行',
  'settings.modeDaemonInstalledMeta': '已安装 {count} 个',
  'settings.modeApi': 'API 提供方',
  'settings.modeApiMeta': 'BYOK',
  'settings.byokNoFileToolsNotice': 'BYOK 无法读写或修改项目文件；需要改代码时请使用本机 CLI。',
  'settings.codeAgent': '代码代理',
  'settings.codeAgentHint': '选择用来运行提示词的 CLI。',
  'settings.rescan': '↻ 重新扫描',
  'settings.rescanTitle': '重新扫描 PATH',
  'settings.rescanRunning': '扫描中...',
  'settings.rescanSuccess': '扫描完成，{count} 个可用。',
  'settings.designSystemRenameFailed': '重命名失败，请检查后台守护进程后重试。',
  'settings.rescanFailed': '扫描失败，请检查后台守护进程后重试。',
  'settings.test': '测试',
  'settings.testTitle': '发送极小的测试提示词以验证连接',
  'settings.testRunning': '正在测试连接…',
  'settings.byokReadyToTest': '可测试连接',
  'settings.testCancel': '取消',
  'settings.testRetry': '重新测试',
  'settings.required': '必填',
  'settings.testMissingFields': '请填写 {fields} 后再测试连接。',
  'settings.testSuccessApi': '已连接。{ms} 毫秒响应 — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} 在 {ms} 毫秒内响应 — \'{sample}\'',
  'settings.testAuthFailed': '鉴权失败，请检查 API 密钥。',
  'settings.testForbidden': '访问被拒绝。请检查账号、地区或组织。',
  'settings.testNotFoundModel': '未在此端点找到模型 \'{model}\'。',
  'settings.testInvalidModelId': '模型 ID \'{model}\' 格式无效。自定义 ID 必须以字母或数字开头，且不能包含空格。',
  'settings.testInvalidBaseUrl': 'Base URL 无效或不可达。',
  'settings.testRateLimited': '提供商对测试进行了限流，配置看起来有效。',
  'settings.testUpstream': '提供商返回 {status}，请稍后再试。',
  'settings.testTimeout': '测试在 {ms} 毫秒后超时。',
  'settings.testAgentMissing': '{agentName} 未安装，或不在 PATH 中。',
  'settings.testAgentSpawn': '无法启动 {agentName}：{detail}。',
  'settings.testUnknown': '测试失败：{detail}',
  'settings.agentInstall.install': '安装',
  'settings.agentInstall.docs': '文档',
  'settings.agentInstall.pathHint': '如果你通过 npm 或 Homebrew 安装了 CLI，但仍显示为未安装，请确认该工具的 bin 目录已加入 Open Design daemon 继承的 PATH（在 macOS 上，Terminal 与 GUI 应用的 PATH 可能不同）。请参阅 QUICKSTART.md（“Local agent CLI and PATH” 章节）。',
  'settings.agentInstall.stepOpenLinks': '在目标代理卡片上打开“安装”或“文档”链接。',
  'settings.agentInstall.stepAuth': '返回 Open Design 之前，请先在对应 CLI 中完成认证（登录或添加 API 凭据）。',
  'settings.agentInstall.stepRescan': '在此区域点击“重新扫描”。',
  'settings.agentInstall.stepSelect': '当代理显示为已安装后，选择该代理卡片。',
  'settings.noAgentsDetected': '尚未检测到任何代理。请安装 Claude Code、Codex、Gemini CLI、OpenCode、Cursor Agent、Qwen 或 GitHub Copilot CLI 中的一个，然后点击「重新扫描」。',
  'settings.agentInstalledGroup': '你的 CLI（{count}）',
  'settings.agentInstallGroup': '可安装（{count}）',
  'settings.agentAuthRequired': '需要认证',
  'settings.agentAuthUnknown': '认证状态未知',
  'settings.amrCloud': 'Open Design AMR',
  'settings.amrAuthorize': '授权',
  'settings.amrBenefitOfficial': '官方推荐',
  'settings.amrBenefitLowerPrice': '免部署即用',
  'settings.amrBenefitManyModels': '多种模型',
  'settings.amrPromoBonus': '限时充值赠 100%',
  'settings.amrSignInToContinue': '授权后继续',
  'settings.amrSignIn': '登录',
  'settings.amrSignedIn': '已登录',
  'settings.amrNotSignedIn': '未授权',
  'settings.amrSigningIn': '登录中…',
  'settings.amrActivationHint': '正在打开浏览器…没有弹出?用下面的链接完成登录。',
  'settings.amrActivationBrowserFailed': '没能自动打开浏览器,请打开下面的登录页继续。',
  'settings.amrActivationOpen': '打开登录页',
  'settings.amrActivationCopyCode': '复制验证码',
  'settings.amrActivationCopy': '复制',
  'settings.amrActivationCopied': '已复制',
  'settings.amrCancelSignIn': '取消登录',
  'settings.amrAccountStatus': 'AMR 账户状态',
  'settings.amrConsole': 'AMR 控制台',
  'settings.amrLoginErrorCompact': 'AMR 登录失败。',
  'settings.advanced': '高级设置',
  'settings.amrLogin': '登录',
  'settings.amrLogout': '登出',
  'settings.amrLoggingIn': '登录中…',
  'settings.amrLoggingOut': '退出中…',
  'settings.amrLoggedInAs': '已登录 {email}',
  'settings.amrLoggedInWithPlan': '已登录 {email} · {plan}',
  'settings.amrLoggedInPill': '已登录',
  'settings.amrNotLoggedIn': '未授权',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': '快速填充提供方',
  'settings.providerPreset': '网关预设',
  'settings.protocolGroupProtocols': '协议',
  'settings.protocolGroupGateways': '网关',
  'settings.customProvider': '自定义提供方',
  'settings.apiKey': 'API Key',
  'settings.apiKeyGetLink': '获取 key ↗',
  'settings.showKey': '显示 Key',
  'settings.hideKey': '隐藏 Key',
  'settings.show': '显示',
  'settings.hide': '隐藏',
  'settings.model': '模型',
  'settings.apiKeyInvalid': 'API key 无效。',
  'settings.apiKeyCleaned': '已移除 API key 中多余的空白字符。',
  'settings.modelsLoadedFromAccount': '✓ 已从你的账号加载 {count} 个模型。',
  'settings.modelsLoadedCount': '✓ 已加载 {count} 个模型。',
  'settings.modelSourceAccount': '来自你的账号',
  'settings.modelSourceSuggested': '建议',
  'settings.fetchModels': '拉取模型',
  'settings.fetchModelsTitle': '从当前提供方拉取可用模型',
  'settings.fetchModelsRunning': '正在拉取模型…',
  'settings.fetchModelsMissingFields': '请填写 {fields} 后再拉取模型。',
  'settings.fetchModelsInvalidBaseUrl': '请输入有效的 Base URL 后再拉取模型。',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI 使用部署名称，此处不支持自动发现模型。',
  'settings.fetchModelsUnsupportedOllama': 'Ollama Cloud 暂不支持自动发现模型，请选择或输入模型。',
  'settings.fetchModelsSuccess': '已拉取 {count} 个模型。',
  'settings.fetchModelsEmpty': '未返回可兼容的文本模型。',
  'settings.fetchModelsUnsupported': '此协议暂不支持自动发现模型。',
  'settings.fetchModelsFailed': '无法拉取模型：{detail}',
  'settings.suggestedModelsHint': '这些是此协议的建议模型。你的提供方可能支持不同的模型。',
  'settings.baseUrl': 'Base URL',
  'settings.baseUrlInvalid': '使用公网 http:// 或 https:// URL。',
  'settings.baseUrlCustomize': '自定义',
  'settings.baseUrlDefaultHint': '默认接口地址，通常不需要修改。',
  'settings.azureBaseUrlPlaceholder': '粘贴 Azure endpoint URL',
  'settings.azureBaseUrlHint': '在 Azure portal → 你的 resource → Endpoint 中找到。',
  'settings.azureDeploymentModel': '部署名称',
  'settings.azureCustomDeploymentName': '自定义部署名称',
  'settings.azureDeploymentModelHint': '对于 Azure OpenAI，此字段会作为 /openai/deployments/<model> 中的部署名称使用。请填写你在 Azure 中创建的部署名称。',
  'settings.azureModelFetchHint': '填写 Azure resource 里的部署名称。Azure deployment 目前无法自动拉取。',
  'settings.apiVersion': 'API 版本',
  'settings.byokImageModel': '图片生成模型',
  'settings.byokVideoModel': '视频生成模型',
  'settings.byokVideoI2vHint': '图生视频模型:需要参考图(不指定时自动使用项目中最新的图片)',
  'settings.byokSpeechModel': '语音生成模型',
  'settings.byokSpeechVoice': '音色',
  'settings.byokModelDefaultOption': '默认',
  'settings.maxTokens': '最大 tokens（可选）',
  'settings.maxTokensHint': '响应长度上限。每个 model 有调优过的默认值（在 placeholder 里显示），留空即使用，输入数字则覆盖。',
  'settings.apiHint': '仅保存在本浏览器。',
  'settings.skipForNow': '暂时跳过',
  'settings.getStarted': '开始使用',
  'settings.envConfigure': '执行模式',
  'settings.localCli': '本机 CLI',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': '尚未选择代理',
  'settings.language': '界面语言',
  'settings.languageHint': '切换界面语言，设置仅保存在当前浏览器。',
  'settings.appearance': '外观',
  'settings.appearanceHint': '选择浅色、深色或跟随系统设置。',
  'settings.themeSystem': '系统',
  'settings.themeLight': '浅色',
  'settings.themeDark': '深色',
  'settings.agentModelHead': '模型：',
  'settings.modelPicker': '模型',
  'settings.modelSourceLive': '来自 CLI 的实时列表',
  'settings.modelSourceFallback': '内置列表',
  'settings.reasoningPicker': '推理强度',
  'settings.modelPickerHint': '当 CLI 提供 `models` 命令时会自动拉取。选择「默认」则沿用 CLI 自身的配置；选择「自定义」可手动输入任何 CLI 支持的模型 id。',
  'settings.modelPickerLiveHint': '模型列表来自这个 CLI；选“默认”会沿用 CLI 自己的设置。',
  'settings.modelPickerLiveCatalogOnlyHint': '模型列表来自这个 CLI。',
  'settings.modelPickerFallbackHint': '正在显示内置默认值。点击“重新扫描”可从 CLI 拉取实时模型。',
  'settings.cliEnvTitle': '高级：代理与自定义路径',
  'settings.cliEnvHint': '用于覆盖所选 CLI 的底层环境变量：API key、代理 base URL、自定义 home 或非标准可执行文件路径。不填 base URL 时，CLI 会使用自己的默认接口地址。密钥只保存在本地应用配置中，并且只传给所选 CLI。',
  'settings.cliEnvClaudeConfigDir': 'Claude Code 配置目录',
  'settings.cliEnvClaudeBaseUrl': 'Claude proxy base URL',
  'settings.cliEnvClaudeApiKey': 'Claude CLI API key',
  'settings.cliEnvCodexHome': 'Codex home',
  'settings.cliEnvCodexBin': 'Codex 可执行文件路径',
  'settings.cliEnvCodexBaseUrl': 'Codex/OpenAI proxy base URL',
  'settings.cliEnvCodexApiKey': 'Codex/OpenAI CLI API key',
  'settings.modelCustom': '自定义（在下方填写）…',
  'settings.modelCustomLabel': '自定义模型 id',
  'settings.modelCustomPlaceholder': '例如 anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': '媒体生成提供商',
  'settings.mediaProvidersHint': '图片、视频、音频生成的 API key。存于本机并同步到本地守护进程。',
  'settings.mcpServerTitle': 'MCP 服务器',
  'settings.mcpServerHint': '将 Open Design 作为 MCP 服务器暴露给你的编码代理。',
  'settings.externalMcpTitle': '外部 MCP',
  'settings.externalMcpHint': '接入外部服务的 MCP 工具（Higgsfield、GitHub 等）。',
  'settings.mediaProviderApiKey': 'API key',
  'settings.mediaProviderBaseUrl': 'Base URL',
  'settings.mediaProviderConfigured': '已配置',
  'settings.mediaProviderUnset': '未配置',
  'settings.mediaProviderClear': '清除',
  'settings.mediaProviderClearConfirm': '清除已保存的 {name} 设置？您需要再次输入才能使用 {name}。',
  'settings.mediaProviderPlaceholder': '粘贴 API key',
  'settings.mediaProviderBaseUrlPlaceholder': '覆盖默认 Base URL',
  'settings.mediaProviderReload': '从本地守护进程重新加载',
  'settings.mediaProviderReloadError': '无法从本地守护进程重新加载媒体提供方设置。',
  'settings.mediaProviderReloadSuccess': '已从本地守护进程重新加载媒体提供方设置。',
  'settings.mediaProviderLoadError': '无法从本地守护进程加载媒体提供方设置。当前将使用浏览器中保存的设置。',
  'settings.mediaProviderComingSoonHint': '我们在路线图中跟踪这些提供方；守护进程尚未提供客户端，因此暂无可配置项。',
  'settings.mediaProvidersTabProviders': 'Providers',
  'settings.mediaProvidersTabPolza': 'Polza',
  'settings.polzaTabHint': 'Configure Polza.ai for image, video, audio, and upscale generation. Test your API key to unlock model selection and pricing.',
  'settings.polzaKeyTest': 'Test key',
  'settings.polzaKeyTestRetry': 'Retry test',
  'settings.polzaKeyTestRunning': 'Testing…',
  'settings.polzaKeyTestReady': 'Enter an API key to test',
  'settings.polzaKeyTestTitle': 'Test Polza API key',
  'settings.polzaKeyTestSuccess': 'API key is valid',
  'settings.polzaKeyTestFailed': 'API key test failed',
  'settings.polzaModelsLocked': 'Test your API key to enable models and see prices.',
  'settings.polzaModelSettings': 'Model settings',
  'settings.polzaCategoryImage': 'Image',
  'settings.polzaCategoryVideo': 'Video',
  'settings.polzaCategoryAudio': 'Audio',
  'settings.polzaCategoryUpscale': 'Upscale',
  'settings.polzaPriceFromRequest': 'from {price} RUB / request',
  'settings.polzaPriceFromSecond': 'from {price} RUB / second',
  'settings.polzaPriceFromMillionChars': 'from {price} RUB / 1M chars',
  'settings.polzaPriceUnknown': 'Price unavailable',
  'settings.polzaPricesRefresh': 'Refresh prices',
  'settings.polzaPricesRefreshing': 'Refreshing prices…',
  'settings.polzaPricesFailed': 'Could not load prices from Polza',
  'settings.privacy': '隐私',
  'settings.privacyHint': '与 Open Design 团队共享哪些数据',
  'settings.privacyConsentKicker': '帮助我们改进 Open Design',
  'settings.privacyConsentLead': 'Open Design 可以将使用数据共享给我们的团队以协助改进。包括:',
  'settings.privacyConsentFooter': '你可以随时在 设置 → 隐私 中修改这些选项。',
  'settings.privacyConsentShare': '分享使用数据',
  'settings.privacyConsentDecline': '不分享',
  'settings.privacyConsentAccept': '我知道了',
  'settings.privacyConsentBannerFooter': '默认开启数据分享。你可以随时在 设置 → 隐私 中关闭。',
  'settings.privacyConsentPolicyLink': '阅读隐私政策',
  'settings.privacyMetrics': '匿名指标',
  'settings.privacyMetricsHint': '运行次数、token 用量、错误率、时长。不包含 prompt,不包含项目数据。',
  'settings.privacyContent': '对话和工具内容',
  'settings.privacyContentHint': 'prompt、助手回复、工具输入/输出，以及质量回看所需的完整上下文文件。发送前会剥离密钥等敏感信息。',
  'settings.privacyInstallationId': '匿名 ID',
  'settings.privacyOptedOut': '已退出',
  'settings.privacyDataDeletion': '删除我的数据',
  'settings.privacyDataDeletionHint': '轮换你的匿名 ID 并停止发送。已有数据按我们的留存策略自然过期。',
  'settings.about': '关于',
  'settings.aboutHint': '版本和运行时详情',
  'settings.appVersion': '版本',
  'settings.appChannel': '渠道',
  'settings.appRuntime': '运行时',
  'settings.appPlatform': '平台',
  'settings.appArchitecture': '架构',
  'settings.runtimePackaged': '已打包应用',
  'settings.runtimeDevelopment': '开发环境',
  'settings.versionUnavailable': '守护进程离线时无法获取版本详情。',
  'settings.installLatest': '安装最新版本',
  'settings.alreadyLatest': '当前为最新版本',
  'settings.mcpTitle': 'MCP 服务器',
  'settings.mcpHint': '让其他仓库中的编码助手（Claude Code、Cursor、VS Code、Antigravity、Zed、Windsurf）读取你的 Open Design 项目。无需先导出 zip，即可将设计拉取到你的应用中。',
  'settings.mcpDaemonError': '无法连接到本地守护进程以解析安装路径（{error}）。请确保 Open Design 正在运行，然后重新打开此面板。',
  'settings.mcpBuildDaemon': '请先构建守护进程。',
  'settings.mcpNodeMissing': 'Node 二进制文件缺失。',
  'settings.mcpBuildHint': 'apps/daemon/dist/cli.js 缺失。请运行 `pnpm --filter @open-design/daemon build` 并刷新。',
  'settings.mcpMethodCli': 'CLI 命令',
  'settings.mcpInstructionCli': '在你的终端中运行此命令。',
  'settings.mcpMethodToml': 'TOML 配置',
  'settings.mcpInstructionCodex': '将以下配置追加到 {path}。Codex CLI 与 Codex IDE 扩展共享同一配置。',
  'settings.mcpMethodOneClick': '一键安装',
  'settings.mcpInstructionCursor': '点击"在 Cursor 中安装"以通过确认对话框安装，或将此 JSON 合并到 {path}。',
  'settings.mcpDeeplinkInstallCursor': '在 Cursor 中安装',
  'settings.mcpMethodJson': 'JSON 配置',
  'settings.mcpInstructionCopilot': '打开命令面板（{shortcut}），运行 "MCP: Open User Configuration"，然后合并此 JSON。Copilot Chat 必须处于 Agent 模式，工具才会显示。',
  'settings.mcpInstructionAntigravity': '在 Antigravity 中：Agent 面板 "..." 菜单 → MCP Servers → Manage MCP Servers → View raw config。合并此 JSON。',
  'settings.mcpInstructionZed': '打开 Zed Settings（{shortcut}），然后将此配置合并到顶层对象中。Zed 使用 "context_servers"，而非 "mcpServers"。',
  'settings.mcpInstructionWindsurf': '打开 {path}（或在 Cascade 中使用 MCPs 图标 → Configure）并合并：',
  'settings.mcpCopyAria': '复制 MCP 配置片段',
  'settings.mcpResolvingFailed': '# 解析路径失败，请查看上方错误',
  'settings.mcpLoadingPaths': '# 正在从本地守护进程加载安装路径…',
  'settings.mcpCopied': '已复制',
  'settings.mcpCopy': '复制',
  'settings.mcpCursorApproval': 'Cursor 会在写入配置前弹出确认对话框。',
  'settings.mcpCodexOneClickInstall': '配置到 Codex',
  'settings.mcpCodexOneClickUninstall': '取消配置',
  'settings.mcpCodexOneClickUnavailable': '未在 PATH 中找到 codex CLI——请先安装 Codex 或手动复制片段。',
  'settings.mcpCodexInstallSuccess': '已配置。请重启 Codex 以加载新 server。',
  'settings.mcpCodexUninstallSuccess': '已从 Codex 取消配置。',
  'settings.mcpCodexBusy': '处理中…',
  'settings.mcpCodexInstallError': '操作失败：{error}',
  'settings.mcpRestartNote': '重启客户端以加载新 server。',
  'settings.mcpRestartDetail': '大多数编辑器仅在启动时加载 MCP server。在 Cursor / VS Code / Antigravity / Windsurf 中，你可以在命令面板中运行 `Developer: Reload Window`，无需完全重启。Zed 和 Claude Code 需要退出并重新打开。',
  'settings.mcpCapabilitiesTitle': '你的助手可以做什么',
  'settings.mcpCapabilityRead': '读取或搜索项目中的任意文件（HTML、JSX、CSS、JSON、SVG、Markdown）。',
  'settings.mcpCapabilityPull': '一次调用拉取设计包：入口文件及其引用的所有 CSS 变量、组件和字体。',
  'settings.mcpCapabilityDefault': '默认使用你在 Open Design 中打开的项目和文件，因此你可以直接说"在我的应用中构建这个"，无需重复说明是哪个设计。',
  'settings.mcpRunningNote': 'Open Design 必须处于运行状态，MCP 工具调用才能成功。如果你在打开 Open Design 之前启动了编码助手，请重启助手以便它能连接到正在运行的守护进程。',
  'entry.tabDesigns': '我的设计',
  'entry.tabTemplates': '模板',
  'entry.tabDesignSystems': '设计体系',
  'entry.tabConnectors': '连接器',
  'entry.openSettingsTitle': '设置',
  'entry.openSettingsAria': '打开设置',
  'entry.discordLabel': '加入 Discord',
  'entry.discordAria': '加入 Open Design Discord',
  'entry.discordAriaWithOnline': '加入 Open Design Discord - {online}',
  'entry.discordOnlineLabel': '{count} 在线',
  'entry.followXLabel': '在 X 上关注 @nexudotio',
  'entry.resizeAria': '调整侧边栏宽度',
  'entry.loadingWorkspace': '正在加载工作区…',
  'entry.useEverywhereTitle': '随处使用',
  'entry.useEverywhereAria': '打开「随处使用」指南（CLI、MCP、HTTP、Skills）',
  'entry.navExpand': '展开侧栏',
  'entry.navCollapse': '收起侧栏',
  'entry.navNewProject': '新建项目',
  'entry.navHome': '主页',
  'entry.navProjects': '项目',
  'entry.navTasks': '自动化',
  'entry.navPlugins': '插件',
  'entry.navDesignSystems': '设计体系',
  'entry.navIntegrations': '集成',
  'workspaceTabs.project': '项目',
  'workspaceTabs.pluginDetails': '插件详情',
  'workspaceTabs.marketplace': '插件市场',
  'homeHero.title': '你想设计什么？',
  'homeHero.templatesScrollHint': '向上滑动探索更多模板',
  'homeHero.templatesCollapse': '收起模板',
  'homeHero.subtitlePrefix': 'Claude Design 的开源替代方案。',
  'homeHero.placeholder': '描述你想生成的内容…',
  'homeHero.placeholderActive': '编辑示例请求，或写下你自己的需求…',
  'homeHero.skills': '技能',
  'homeHero.addMenu': '添加',
  'homeHero.addPlugin': '添加插件',
  'homeHero.addConnectors': '添加连接器',
  'homeHero.addMcp': '添加 MCP 服务',
  'homeHero.noPlugins': '暂无已安装的插件',
  'homeHero.noMcp': '暂无 MCP 服务',
  'homeHero.noConnectors': '暂无已连接的连接器',
  'homeHero.applying': '正在应用…',
  'homeHero.pluginTitle': '插件：{title}',
  'homeHero.pluginPrefix': '插件：{title}',
  'homeHero.skillPrefix': '技能：{title}',
  'homeHero.removePlugin': '移除插件',
  'homeHero.removePluginAria': '移除插件 {title}',
  'homeHero.clearActivePlugin': '清除当前插件',
  'homeHero.clearActiveSkill': '清除当前技能',
  'homeHero.contextItemsResolved': '已解析 {n} 个上下文项',
  'homeHero.removeFile': '移除文件',
  'homeHero.contextSearchResults': '上下文搜索结果',
  'homeHero.contextSurfaces': '上下文来源',
  'homeHero.loadingContext': '正在加载上下文…',
  'homeHero.noResults': '没有找到“{query}”的结果。',
  'homeHero.searchPrompt': '搜索文件、插件、技能、MCP 服务器和连接器。',
  'homeHero.parameters': '{n} 个参数',
  'homeHero.details': '详情',
  'homeHero.toRun': '运行',
  'homeHero.forNewLine': '换行',
  'homeHero.run': '运行',
  'homeHero.typeSomethingToRun': '输入内容后运行',
  'homeHero.promptExamples': '示例提示词',
  'homeHero.footer.designSystem': '风格',
  'homeHero.footer.autoDesignSystem': '自动',
  'homeHero.footer.autoDesignSystemSummary': '根据当前 Prompt 自动匹配合适的设计体系和视觉风格。',
  'homeHero.footer.ratio': '比例',
  'homeHero.footer.duration': '时长',
  'homeHero.footer.resolution': '分辨率',
  'homeHero.footer.speakerNotes': '备注',
  'homeHero.footer.noSpeakerNotes': '无备注',
  'homeHero.footer.availableCount': '{n} 个可用',
  'homeHero.footer.noMatches': '无匹配结果',
  'homeHero.moreShortcuts': '更多',
  'homeHero.railAria': '选择项目类别或启动入口',
  'homeHero.subTypeAria': '选择子类型',
  'homeHero.confirmReplaceTitle': '替换当前 Prompt？',
  'homeHero.confirmReplaceBody': '使用 {title} 会替换输入框中的现有文本。',
  'homeHero.confirmReplace': '替换',
  'homeHero.chip.prototype': '原型',
  'homeHero.chip.liveArtifact': '实时看板',
  'homeHero.chip.deck': '幻灯片',
  'homeHero.chip.image': '图片',
  'homeHero.chip.video': '视频',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.audio': '音频',
  'homeHero.chip.createPlugin': '创建插件',
  'homeHero.chip.figma': '来自 Figma',
  'homeHero.chip.folder': '来自文件夹',
  'homeHero.chip.template': '来自模板',
  'homeHero.chip.liveArtifactHint': '构建可实时预览的交互式 HTML/CSS/JS 制品。',
  'homeHero.chip.hyperframesHint': '创作基于 HTML 的动态内容：字幕、音频响应视觉和场景转场。',
  'homeHero.chip.createPluginHint': '创作可复用的 Open Design 插件，并添加到我的插件。',
  'homeHero.chip.figmaHint': '将 Figma 画框迁移到当前设计体系。',
  'homeHero.chip.folderHint': '导入本地文件夹并继续编辑。',
  'homeHero.chip.templateHint': '从内置模板开始。',
  'homeWorkingDir.trigger': '选择工作目录',
  'homeWorkingDir.pick': '选择目录',
  'homeWorkingDir.replace': '修改工作目录',
  'homeWorkingDir.recent': '最近使用的目录',
  'homeWorkingDir.recentEmpty': '暂无最近使用的目录',
  'homeWorkingDir.clear': '移除工作目录',
  'homeWorkingDir.hint': '让 Agent 可读取该本地目录（不会导入到 Design Files）',
  'homeWorkingDir.missing': '该工作目录已不存在，请重新选择',
  'homeWorkingDir.applyFailed': '无法设置工作目录，该文件夹可能已不存在',
  'workingDirPicker.title': '目录',
  'workingDirPicker.homeTitle': '默认存在本地存储，点击可选择文件夹',
  'workingDirPicker.processing': '处理中…',
  'workingDirPicker.select': '本地存储',
  'workingDirPicker.clearAria': '清除工作目录',
  'workingDirPicker.replaceFailed': '替换工作目录失败',
  'workingDirPicker.unavailable': '未选择目录 — 启动桌面版以使用原生选择器',
  'workingDirPicker.openUnavailable': '请在桌面版中打开此项目以显示文件夹。',
  'workingDirPicker.openFailed': '无法显示此文件夹',
  'workingDirPicker.showInFileManager': '在文件管理器中显示',
  'workingDirPicker.replace': '选择文件夹…',
  'workingDirPicker.recent': '最近使用的目录',
  'workingDirPicker.defaultLabel': '本地存储',
  'handoff.toTarget': '交付给 {target}',
  'handoff.openInTarget': '在 {target} 中打开',
  'handoff.openAction': '打开',
  'handoff.menuTitle': '在哪个编辑器中打开？',
  'handoff.action': '交付',
  'handoff.fallbackTitle': '未找到编辑器 - 使用 {target} 打开',
  'handoff.chooseTargetAria': '选择交付目标',
  'handoff.optionsAria': '交付选项',
  'handoff.editorSection': '通过编辑器打开',
  'handoff.cliSection': '复制给 CLI',
  'handoff.clickOpen': '点击打开',
  'handoff.framework': '代码框架',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': '原生 JavaScript、HTML 和 CSS',
  'handoff.amrWebsite': '打开 AMR 官网',
  'handoff.copyPrompt': '复制提示词',
  'handoff.copyPromptForTarget': '复制给 {target} 的提示词',
  'handoff.copied': '已复制',
  'handoff.projectPathUnavailable': '还没有拿到项目本地路径，请稍后再试。',
  'handoff.copyFailed': '浏览器拒绝写入剪贴板，请稍后再试。',
  'handoff.promptIntro': '请基于这个 Open Design 项目的本地文件夹继续实现：',
  'handoff.promptTarget': '目标',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': '你现在是在 {cli} 中接手，请：',
  'handoff.promptReadFiles': '先进入或读取这个目录，优先阅读 DESIGN.md、README、现有 HTML/CSS/JS、素材和 package.json（如果存在）。',
  'handoff.promptKeepDesign': '保持现有视觉、布局、交互和素材，不要只描述方案。',
  'handoff.promptProduceCode': '生成或修改真实可运行的 {framework} 代码；如果项目已有更明确的工程栈，先说明冲突并优先保持可运行。',
  'handoff.promptVerify': '完成后告诉我运行、预览和验证命令。',
  'handoff.promptCommandHint': '如果要先切到项目目录，可以用：',
  'handoff.promptProject': '项目',
  'handoff.promptProjectId': '项目 ID',
  'handoff.notInstalled': '未安装',
  'handoff.notDetectedTitle': '{target} - 未在 $PATH 中检测到',
  'designSystemPicker.select': '选择设计系统',
  'designSystemPicker.loading': '正在加载设计系统…',
  'designSystemPicker.searchPlaceholder': '搜索设计系统（标题 / 分类 / 摘要）',
  'designSystemPicker.searchCompactPlaceholder': '搜索设计系统',
  'designSystemPicker.noneTitle': '不指定设计系统',
  'designSystemPicker.noneSummary': '不指定设计系统，模型会根据你的 Prompt 自由发挥视觉风格。',
  'designSystemPicker.empty': '没有匹配的设计系统',
  'designSystemPicker.openPreview': '打开预览',
  'designSystemPicker.loadingPreview': '正在加载预览…',
  'designSystemPicker.noPreview': '无预览页面 — 在「设计系统」中查看完整预览',
  'designSystemPicker.previewHint': '将鼠标悬停在左侧条目上查看预览',
  'designSystemPicker.fullscreenAria': '{title} 全屏预览',
  'designSystemPicker.closeFullscreen': '关闭全屏预览',
  'designSystemPicker.closeEsc': '关闭 (Esc)',
  'designSystemPicker.previewFrameTitle': '{title} 预览',
  'designSystemPicker.fullscreenFrameTitle': '{title} 全屏预览',
  'designSystem.projectPptxTitle': '从演示文稿导入',
  'designSystem.projectPptxHint': '上传 .pptx 文件，根据幻灯片内容生成或替换此设计系统。',
  'designSystem.projectPptxChoose': '选择 .pptx 文件',
  'designSystem.projectPptxImporting': '正在导入演示文稿…',
  'designSystem.projectPptxFailed': 'PPTX 导入失败',
  'designSystem.projectPptxSuccess': '已从演示文稿导入设计系统',
  'recentProjects.title': '最近项目',
  'recentProjects.viewAll': '查看全部',
  'recentProjects.empty': '还没有项目 — 输入 Prompt 即可开始。',
  'pluginsHome.title': 'Community',
  'pluginsHome.subtitle': '当前运行环境内置的 Open Design 工作流。选择一个加载 starter prompt，或浏览插件市场查看更多。',
  'pluginsHome.browseRegistry': '浏览插件市场',
  'pluginsHome.count': '{filtered} / {total}',
  'pluginsHome.loadingCatalog': '正在加载目录…',
  'pluginsHome.emptyCatalog': '目录为空。Open Design 会随附内置插件，如果这里一直为空，请尝试重启 daemon。',
  'pluginsHome.emptyFiltered': '没有插件匹配当前筛选条件。',
  'pluginsHome.clearFilters': '清除筛选',
  'pluginsHome.modeAria': '插件模式',
  'pluginsHome.featured': '已保存',
  'pluginsHome.totalInCatalog': '目录中共 {n} 个',
  'pluginsHome.categoryFilterAria': '类别筛选',
  'pluginsHome.subcategoryFilterAria': '{label} 子类别筛选',
  'pluginsHome.allCategory': '全部 {label}',
  'pluginsHome.searchPlaceholder': '搜索插件…',
  'pluginsHome.searchAria': '搜索插件',
  'pluginsHome.clearSearch': '清除搜索',
  'pluginsHome.facet.import': '导入',
  'pluginsHome.facet.create': '创建',
  'pluginsHome.facet.export': '导出',
  'pluginsHome.facet.share': '分享',
  'pluginsHome.facet.deploy': '部署',
  'pluginsHome.facet.refine': '优化',
  'pluginsHome.facet.extend': '扩展',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': '代码 / 文件夹',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': '截图',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': '幻灯片',
  'pluginsHome.facet.publicLink': '公开链接',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': '数据看板',
  'pluginsHome.subfacet.app-prototypes': '应用',
  'pluginsHome.subfacet.landing-marketing': '落地页 / 营销',
  'pluginsHome.subfacet.developer-tools': '开发者工具',
  'pluginsHome.subfacet.docs-reports': '文档 / 报告',
  'pluginsHome.subfacet.brand-design': '品牌 / 设计',
  'pluginsHome.subfacet.pitch-business': '路演 / 商务',
  'pluginsHome.subfacet.course-training': '课程 / 培训',
  'pluginsHome.subfacet.reports-briefings': '报告 / 简报',
  'pluginsHome.subfacet.product-sales': '产品 / 销售',
  'pluginsHome.subfacet.engineering-talks': '技术分享',
  'pluginsHome.subfacet.creative-decks': '创意幻灯片',
  'pluginsHome.subfacet.ui-product-mockups': 'UI / 产品样机',
  'pluginsHome.subfacet.brand-visuals': '品牌 / Logo',
  'pluginsHome.subfacet.storyboards-motion-refs': '分镜',
  'pluginsHome.subfacet.social-content': '社交 / 内容',
  'pluginsHome.subfacet.avatar-portrait': '头像 / 人像',
  'pluginsHome.subfacet.illustration-style': '插画 / 风格',
  'pluginsHome.subfacet.motion-effects': '动效 / 特效',
  'pluginsHome.subfacet.social-short-form': '社交 / 短视频',
  'pluginsHome.subfacet.marketing-product': '营销 / 产品',
  'pluginsHome.subfacet.data-explainers': '数据 / 解说',
  'pluginsHome.subfacet.cinematic-story': '电影感 / 叙事',
  'pluginsView.lede': '浏览已安装工作流，发现插件市场条目，管理来源，并为团队分发准备插件。',
  'pluginsView.importPlugin': '导入插件',
  'pluginsView.agentContext': '智能体上下文',
  'pluginsView.summaryAria': '插件概览',
  'pluginsView.areasAria': '插件区域',
  'pluginsView.loading': '正在加载插件…',
  'pluginsView.tab.installed': '已安装',
  'pluginsView.tab.available': '可用',
  'pluginsView.tab.sources': '来源',
  'pluginsView.tab.team': '团队',
  'pluginsView.tabHint.installed': '你的插件',
  'pluginsView.tabHint.available': '来自来源',
  'pluginsView.tabHint.sources': '目录',
  'pluginsView.tabHint.team': '企业',
  'pluginsView.installedTitle': '已安装插件',
  'pluginsView.installedSubtitle': '你导入或从插件市场来源安装的插件。',
  'pluginsView.installedEmpty': '还没有已安装的用户插件。可使用创建 / 导入，或安装一个可用条目。',
  'pluginsView.availableTitle': '来源中的可用插件',
  'pluginsView.availableSubtitle': '从已配置插件市场发现的目录条目。',
  'pluginsView.availableFiltersAria': '可用插件筛选',
  'pluginsView.searchAvailableAria': '搜索可用插件',
  'pluginsView.searchAvailablePlaceholder': '搜索可用插件',
  'pluginsView.clearAvailableSearch': '清除可用插件搜索',
  'pluginsView.source': '来源',
  'pluginsView.availableEmptyInstalled': '暂无可用条目。已安装的目录条目会从“可用”中移除；卸载后会再次出现。',
  'pluginsView.availableEmptyFiltered': '没有可用条目匹配当前筛选条件。',
  'pluginsView.availableEmptyNoSources': '暂无可用条目。请在“来源”标签页添加来源。',
  'pluginsView.installing': '正在安装…',
  'pluginsView.install': '安装',
  'pluginsView.sourcesTitle': 'Registry 来源',
  'pluginsView.sourcesSubtitle': '为“可用插件”提供条目的插件市场目录。',
  'pluginsView.sourceUrl': '来源 URL',
  'pluginsView.defaultTrust': '默认信任级别',
  'pluginsView.trust.restricted': '受限',
  'pluginsView.trust.trusted': '可信',
  'pluginsView.trust.official': '官方',
  'pluginsView.adding': '正在添加…',
  'pluginsView.addSource': '添加来源',
  'pluginsView.sourcesEmpty': '还没有配置 registry 来源。',
  'pluginsView.pluginsCount': '{n} 个插件',
  'pluginsView.catalogVersion': '目录 v{version}',
  'pluginsView.trustFor': '{name} 的信任级别',
  'pluginsView.refreshing': '正在刷新…',
  'pluginsView.removing': '正在移除…',
  'pluginsView.teamTitle': '私有团队插件市场',
  'pluginsView.teamBody': '此区域预留给企业和团队目录、私有信任策略，以及共享插件生命周期控制。',
  'pluginCard.details': '详情',
  'pluginCard.use': '使用',
  'pluginCard.useWithQuery': '带查询使用',
  'pluginCard.applying': '正在应用…',
  'pluginCard.publish': '发布',
  'pluginCard.contribute': '贡献',
  'pluginCard.starting': '正在启动…',
  'pluginCard.detailsAria': '查看 {title} 的详情',
  'pluginCard.chooseUseAria': '选择 {title} 的使用方式',
  'pluginCard.useOptionsAria': '{title} 的使用选项',
  'pluginCard.shareAria': '分享 {title}',
  'pluginCard.publishAria': '将 {title} 发布为 GitHub 仓库',
  'pluginCard.publishTitle': '将插件发布为 GitHub 仓库',
  'pluginCard.contributeAria': '将 {title} 贡献到 Open Design',
  'pluginCard.contributeTitle': '通过 pull request 将插件贡献到 Open Design',
  'skillPluginCandidate.createForMe': '创建插件/模板',
  'skillPluginCandidate.contributeToMain': '贡献到 open-design',
  'skillPluginCandidate.repoDescription': '这个仓库看起来可以做成插件。',
  'integrations.kicker': '集成',
  'integrations.lede': '连接外部系统，把 MCP 工具带入智能体循环，并在其它 IDE、脚本和自动化中使用 Open Design。',
  'integrations.agentReady': '智能体就绪',
  'integrations.areasAria': '集成区域',
  'integrations.tabLabel.mcp': 'MCP 服务器',
  'integrations.tabLabel.skills': '技能',
  'integrations.tabHint.mcp': '外部工具',
  'integrations.tabHint.connectors': '账号和 API',
  'integrations.tabHint.useEverywhere': 'CLI、HTTP、MCP',
  'integrations.skillsTitle': '技能集成',
  'integrations.skillsBody': '技能级集成管理正在从另一个分支迁移过来。此标签页预留给 MCP、连接器和未来技能设置，使它们位于同一个集成路由中。',
  'mcpClient.title': '外部 MCP 服务器',
  'mcpClient.subtitle': '供编码智能体使用的第三方工具。',
  'mcpClient.addServer': '添加服务器',
  'mcpClient.emptyTitle': '尚未配置 MCP 服务器。',
  'mcpClient.emptyBody': '点击“添加服务器”开始 — 选择模板（Higgsfield OpenClaw、Pollinations、Allyson、Imagician、EdgeOne Pages、GitHub、Filesystem…），或配置自定义 stdio / HTTP 服务器。',
  'mcpClient.saveChanges': '保存更改',
  'mcpClient.storedAt': '存储于',
  'mcpClient.daemonError': '无法连接本地 daemon。请确认 Open Design 正在运行，然后重新打开此面板。',
  'mcpClient.saveFailed': '保存失败。请检查 daemon 是否正在运行后重试。',
  'useEverywhere.modalAria': '随处使用 Open Design',
  'useEverywhere.modalTitle': '随处使用 Open Design',
  'useEverywhere.modalSubtitle': '把 Open Design 接入任何 IDE、智能体或脚本：CLI、HTTP、MCP 和 Skills。使用“复制智能体指南”，粘贴到 Claude Code、Codex、Cursor、openclaw 或 hermes 中即可完成配置。',
  'useEverywhere.closeAria': '关闭随处使用',
  'useEverywhere.closeTitle': '关闭 (Esc)',
  'useEverywhere.tabsAria': '集成入口',
  'useEverywhere.footStrong': '一键交接。',
  'useEverywhere.footBody': '复制一份结构化 Markdown 指南，智能体可以立即按步骤安装、验证并使用。',
  'useEverywhere.configureMcp': '配置 MCP 服务器',
  'useEverywhere.copyGuide': '复制智能体指南',
  'useEverywhere.copy': '复制',
  'useEverywhere.copied': '已复制',
  'useEverywhere.copyFailed': '复制失败',
  'useEverywhere.copySnippetAria': '复制代码片段：{label}',
  'useEverywhere.section.overview.tab': '概览',
  'useEverywhere.section.overview.heading': 'Open Design 可在智能体工作的任何地方运行',
  'useEverywhere.section.overview.intro': 'Open Design 不只是一个窗口；它包含本地特权 daemon（`od`），以及 Skills + Design Systems + Atoms registry。它在你的机器上运行后，任何代码智能体（Claude Code、Codex、Cursor、OpenCode/openclaw、Hermes 或你自己的脚本）都可以通过四种可互换入口驱动生成、检查项目并产出设计制品。',
  'useEverywhere.section.overview.bullet1': 'CLI — 使用 `od <command>` 支持无头脚本、CI 和 shell 自动化。',
  'useEverywhere.section.overview.bullet2': 'MCP 服务器 — 将 Open Design 作为 Model Context Protocol 服务器接入，使任何支持 MCP 的智能体都能列出技能、运行场景并读取制品。',
  'useEverywhere.section.overview.bullet3': 'HTTP API — `http://127.0.0.1:7456/api/*` REST + SSE 端点；与 Web UI 使用同一套接口。',
  'useEverywhere.section.overview.bullet4': 'Skills — 可直接放入的 `SKILL.md` 包（兼容 Claude），任何已在 PATH 中的智能体都能调用，甚至不需要打开 Open Design。',
  'useEverywhere.section.overview.bullet5': '标准制品 — 在 daemon 启动前，从 Skills、内置默认插件和社区插件示例中种子生成真实 HTML 项目。',
  'useEverywhere.section.overview.snippet1': '本地启动 daemon（和 Web UI）',
  'useEverywhere.section.overview.snippet2': '确认服务可访问',
  'useEverywhere.section.overview.snippet3': '启动前导入标准制品',
  'useEverywhere.section.overview.footer': 'daemon 默认写入项目本地的 `./.od/`。设置 `OD_DATA_DIR=~/.open-design` 可在多个项目间共享数据。',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': '从任意 shell 驱动 Open Design',
  'useEverywhere.section.cli.intro': '`od` 命令随 daemon 一起发布，也是 Claude Code / Codex 运行生成时使用的同一个二进制。多数子命令都是向本地 daemon 发送 POST 的轻量客户端，因此无论你通过 `pnpm tools-dev` 启动，还是通过打包应用启动，行为都一致。',
  'useEverywhere.section.cli.bullet1': '`od`（无参数）— 启动 daemon 并打开 Web UI。',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — 通过统一媒体协议生成图片 / 视频 / 音频字节。',
  'useEverywhere.section.cli.bullet3': '`od run ...` — 从 prompt + skill 启动一次项目运行。',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — 安装并应用社区插件。',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — 查看本地可用内容。',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — 验证 daemon 健康状态并检测 PATH 中的智能体 CLI。',
  'useEverywhere.section.cli.snippet1': '生成图片（委托给已配置的媒体提供方）',
  'useEverywhere.section.cli.snippet2': '无头运行场景插件，并以 JSON Lines 流式输出事件',
  'useEverywhere.section.cli.snippet3': '清点本地可用的 skills 和 design systems',
  'useEverywhere.section.cli.snippet4': '通过 CLI 检查种子制品',
  'useEverywhere.section.cli.snippet5': '验证环境和已检测到的智能体（Claude、Codex、Cursor 等）',
  'useEverywhere.section.cli.footer': '所有子命令都支持 `--daemon-url http://127.0.0.1:<port>`，用于指定某个运行中的 daemon；在测试中运行第二个隔离实例时很有用。',
  'useEverywhere.section.mcp.tab': 'MCP 服务器',
  'useEverywhere.section.mcp.heading': '把 Open Design 暴露为任意代码智能体可用的 MCP 服务器',
  'useEverywhere.section.mcp.intro': 'Open Design 内置 Model Context Protocol 服务器（`od mcp`），让任何支持 MCP 的客户端（Cursor、Claude Code、Antigravity、VS Code Copilot Chat、openclaw、hermes）都能发现 Open Design 工具（列出技能、渲染预览、生成媒体、运行插件），无需手动 shell 调用。daemon 会通过 `GET /api/mcp/install-info` 为主流客户端发布可直接粘贴的安装片段。',
  'useEverywhere.section.mcp.bullet1': 'Stdio 传输 — 无需额外端口，客户端直接启动 `od mcp`。',
  'useEverywhere.section.mcp.bullet2': '作为 sidecar 启动时，会通过本地 IPC 状态 socket 自动发现实时 daemon URL。',
  'useEverywhere.section.mcp.bullet3': '普通安装会回退到 `--daemon-url http://127.0.0.1:<port>`，确保 MCP 进程总能找到运行中的 daemon。',
  'useEverywhere.section.mcp.bullet4': '固定 `OD_DATA_DIR`，让派生的 MCP 进程写入 daemon 已使用的位置，避免打包 macOS app bundle 中的 EPERM 问题。',
  'useEverywhere.section.mcp.snippet1': '通用 MCP 客户端配置（适用于 Cursor、Claude Code、Codex 等）',
  'useEverywhere.section.mcp.snippet2': '或者：让 daemon 返回与你安装方式匹配的片段',
  'useEverywhere.section.mcp.snippet3': '实时看板 MCP 变体（读取并刷新仪表盘）',
  'useEverywhere.section.mcp.footer': '在 Open Design 应用中，打开“设置 → 集成”即可复制特定客户端的安装命令（Cursor、Claude Code、Antigravity、VS Code），无需手写 JSON。',
  'useEverywhere.section.http.tab': 'HTTP API',
  'useEverywhere.section.http.heading': '与 Web UI 相同的 REST + SSE 接口',
  'useEverywhere.section.http.intro': '本地 daemon 在 `http://127.0.0.1:7456` 提供 HTTP API（端口可配置）。Web UI 调用的每个端点也都可以供你的脚本使用。流式端点（聊天回合、项目运行）会发出 Server-Sent Events，事件类型定义在 `@open-design/contracts` 中。',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — daemon 存活检查。',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` 和 `GET /api/design-systems` — 可用 registry。',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` 和 `POST /api/projects` — 列出和创建项目（POST 返回项目和首个会话）。',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — 某个会话的智能体事件 SSE 流。',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — 绑定已安装插件，并获得其渲染后的示例查询和输入。',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — 检测 PATH 中的代码智能体 CLI。',
  'useEverywhere.section.http.snippet1': '列出已安装的 skills（智能体会把它们作为模板使用）',
  'useEverywhere.section.http.snippet2': '从 prompt 创建项目（完整服务端流程）',
  'useEverywhere.section.http.snippet3': '流式读取聊天回合（SSE，每行兼容 JSON Lines）',
  'useEverywhere.section.http.footer': '每个请求 / 响应的纯 TypeScript 类型都在 `@open-design/contracts` 中；脚本中导入即可获得完整自动补全，无需接入生成器。',
  'useEverywhere.section.skills.tab': 'Skills 和无头模式',
  'useEverywhere.section.skills.heading': '任意智能体可直接使用的 Skills，即使 Open Design 未运行',
  'useEverywhere.section.skills.intro': 'Skill 是一个包含 Claude 兼容 `SKILL.md`（YAML front matter + 正文）的目录。Open Design 通过 `od:` 命名空间（`mode`、`preview`、`design_system`、`inputs` 等）扩展该格式，使同一个制品既能在 Open Design 内使用，也能被 Claude Code、Codex、openclaw 或 hermes 这类普通智能体使用。发现逻辑遵循优先级链，因此项目可以覆盖自己的 skills。',
  'useEverywhere.section.skills.bullet1': '发现顺序：`./.claude/skills/` → `./skills/` → `~/.claude/skills/`（项目优先）。',
  'useEverywhere.section.skills.bullet2': '把同一个 skill 符号链接到多个项目，无需复制即可共享。',
  'useEverywhere.section.skills.bullet3': '每个 skill 都可以声明 connectors、atoms、design-system 要求，以及用于 gallery 的 `preview` 示例输出。',
  'useEverywhere.section.skills.bullet4': '无头模式：PATH 中有 `od` 的智能体可以调用 `od skills list` 后运行任意 skill；只读流程不强制需要 daemon。',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` 会用默认插件示例和社区插件示例演练同一制品形态，并把生成的 `index.html` 项目保存为可复用测试数据。',
  'useEverywhere.section.skills.snippet1': '最小 SKILL.md（Claude 兼容 front matter + Open Design 扩展）',
  'useEverywhere.section.skills.snippet2': '把共享 skill 符号链接到项目中（cc-switch 风格）',
  'useEverywhere.section.skills.snippet3': '无头模式：列出 daemon 当前看到的 skills',
  'useEverywhere.section.skills.snippet4': '无头制品夹具包',
  'useEverywhere.section.skills.footer': '规范：`docs/skills-protocol.md` 和 `docs/agent-adapters.md` 覆盖完整适配器表面（Claude Code、Codex、Cursor、MCP-capable agents、BYOK API fallback）以及每种适配器的 skill 注入策略。',
  'tasks.kicker': '自动化工作区',
  'tasks.comingSoon': '即将上线',
  'tasks.lede': '自动化会把 Prompt 变成可持续运行的工作：Orbit 负责执行，例程负责保留，计划决定触发时间，实时看板展示变化。',
  'tasks.newAutomation': '新建自动化',
  'tasks.previewNote': '当前仅为预览界面。Orbit 设置已可用；例程、计划和实时看板接线会随后端分支合并后上线。',
  'tasks.primitivesAria': '自动化基础能力',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': '用于长期或周期性智能体工作的持久运行时。',
  'tasks.primitive.orbit.enabled': '每日摘要已启用',
  'tasks.primitive.orbit.manualOnly': '仅手动',
  'tasks.primitive.routines.title': '例程',
  'tasks.primitive.routines.body': '单次聊天结束后仍能保留的持久任务定义。',
  'tasks.primitive.routines.meta': '产品外壳已就绪',
  'tasks.primitive.schedules.title': '计划',
  'tasks.primitive.schedules.body': '按时间或事件触发，决定例程何时运行。',
  'tasks.primitive.schedules.meta': '分支待合并',
  'tasks.primitive.liveArtifacts.title': '实时看板',
  'tasks.primitive.liveArtifacts.body': '智能体工作时持续更新的报告和笔记。',
  'tasks.primitive.liveArtifacts.meta': '预览模型',
  'tasks.listAria': '自动化列表',
  'tasks.routinesAndRuns': '{n} 个例程和运行',
  'tasks.filtersAria': '自动化筛选',
  'tasks.filter.scheduled': '已计划',
  'tasks.filter.running': '运行中',
  'tasks.filter.done': '已完成',
  'tasks.configurationAria': '自动化配置',
  'tasks.slot.trigger': '触发器',
  'tasks.slot.pattern': '模式',
  'tasks.slot.runtime': '运行时',
  'tasks.slot.output': '输出',
  'tasks.liveArtifact': '实时看板',
  'tasks.viewProgress': '查看进度',
  'tasks.pause': '暂停',
  'tasks.runNow': '立即运行',
  'tasks.openArtifact': '打开制品',
  'tasks.status.dailyAt': '每日 · {time}',
  'tasks.status.pausedManual': '已暂停 · 仅手动',
  'tasks.sample.orbit.title': 'Orbit 每日连接器摘要',
  'tasks.sample.orbit.metaEnabled': '连接器摘要已计划运行',
  'tasks.sample.orbit.metaDisabled': '打开 Orbit 设置以启用',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · 实时看板',
  'tasks.sample.orbit.previewDisabled': '尚未计划运行',
  'tasks.sample.orbit.triggerEnabled': '计划 · 每日 {time}',
  'tasks.sample.orbit.triggerDisabled': '手动 · 按需运行',
  'tasks.sample.orbit.pattern': '例程 · 连接器摘要',
  'tasks.sample.orbit.runtime': 'Orbit · daemon 计划任务',
  'tasks.sample.orbit.output': '实时看板 · 可刷新报告',
  'tasks.sample.orbit.artifactMetaEnabled': '每次运行后刷新',
  'tasks.sample.orbit.artifactMetaDisabled': '等待计划',
  'tasks.sample.orbit.body1': '# Orbit 每日活动摘要',
  'tasks.sample.orbit.body2': '已检查连接器 · 成功、跳过和失败',
  'tasks.sample.orbit.body3': '重点内容会变成可刷新的实时看板。',
  'tasks.sample.mcp.title': 'MCP 替代方案研究',
  'tasks.sample.mcp.status': '正在 Orbit 中运行 · 2 小时 14 分',
  'tasks.sample.mcp.meta': '已处理 14 / 30 个来源',
  'tasks.sample.mcp.preview': 'research_notes.md · 实时',
  'tasks.sample.mcp.trigger': '手动 · 一次性',
  'tasks.sample.mcp.pattern': '深度研究 Prompt',
  'tasks.sample.mcp.runtime': '远程 · 持久',
  'tasks.sample.mcp.output': '实时报告 · 自动更新',
  'tasks.sample.mcp.artifactMeta': '12 秒前更新',
  'tasks.sample.mcp.body1': '# MCP 替代方案 - 阶段性发现',
  'tasks.sample.mcp.body2': '已审阅 14 个来源 · 入围 3 个候选',
  'tasks.sample.mcp.body3': '## 入围清单',
  'tasks.sample.mcp.body4': '- 基于 JSON-RPC 的工具调用 schema...',
  'tasks.sample.mcp.body5': '- 基于 gRPC 的智能体协议...',
  'tasks.sample.weekly.title': '团队周报摘要',
  'tasks.sample.weekly.status': '下次：周一 9:00 AM',
  'tasks.sample.weekly.meta': '更新团队周报文档',
  'tasks.sample.weekly.preview': 'team_weekly.md · 下一个制品',
  'tasks.sample.weekly.trigger': '计划 · 每周',
  'tasks.sample.weekly.pattern': '例程 · 团队摘要',
  'tasks.sample.weekly.runtime': '远程 · 周期性',
  'tasks.sample.weekly.output': '实时看板 · Markdown',
  'tasks.sample.weekly.artifactMeta': '4 天前更新',
  'tasks.sample.weekly.body1': '# 团队周报',
  'tasks.sample.weekly.body2': '## 进行中',
  'tasks.sample.weekly.body3': '- 设计体系集成梳理',
  'tasks.sample.weekly.body4': '- 连接器质量清理',
  'tasks.sample.weekly.body5': '## 风险',
  'tasks.sample.pr.title': 'PR 评审提醒',
  'tasks.sample.pr.status': '新 PR 触发 · 23 分钟前已发送',
  'tasks.sample.pr.meta': '发送 Slack 私信',
  'tasks.sample.pr.preview': '上次发送成功',
  'tasks.sample.pr.trigger': '事件 · 新 PR',
  'tasks.sample.pr.pattern': '例程 · 通知',
  'tasks.sample.pr.runtime': '本地 · 快速运行',
  'tasks.sample.pr.output': '消息 · Slack 私信',
  'tasks.sample.pr.artifactMeta': '23 分钟前触发',
  'tasks.sample.pr.body1': '已打开 PR #184 等待评审',
  'tasks.sample.pr.body2': '匹配评审者：design-platform、web-runtime',
  'tasks.sample.pr.body3': '发送结果：Slack 私信已发送',
  'tasks.sample.meeting.title': '会前准备',
  'tasks.sample.meeting.status': '明天 · 10:00 AM',
  'tasks.sample.meeting.meta': '一次性 · 发送摘要',
  'tasks.sample.meeting.preview': 'meeting_brief.md · 已排队',
  'tasks.sample.meeting.trigger': '计划 · 一次性',
  'tasks.sample.meeting.pattern': '简报 Prompt',
  'tasks.sample.meeting.runtime': '远程 · 有边界',
  'tasks.sample.meeting.output': '制品 + 消息',
  'tasks.sample.meeting.artifactMeta': '已排队等待生成',
  'tasks.sample.meeting.body1': '# 会议简报',
  'tasks.sample.meeting.body2': '议程来源：日历事件 + 关联文档',
  'tasks.sample.meeting.body3': '输出将包含决策、阻塞点和问题。',
  'tasks.sample.candidate.title': '候选人跟踪',
  'tasks.sample.candidate.status': '失败 · 需要处理',
  'tasks.sample.candidate.meta': '授权已过期',
  'tasks.sample.candidate.preview': '重新连接 Greenhouse 以继续',
  'tasks.sample.candidate.trigger': '计划 · 每日',
  'tasks.sample.candidate.pattern': '例程 · 申请人同步',
  'tasks.sample.candidate.runtime': '远程 · 周期性',
  'tasks.sample.candidate.output': '实时看板 · 表格',
  'tasks.sample.candidate.artifactMeta': '授权恢复前已暂停',
  'tasks.sample.candidate.body1': '# 候选人管道',
  'tasks.sample.candidate.body2': '上次成功同步：2 天前',
  'tasks.sample.candidate.body3': '需要操作：重新连接来源账号。',
  'routines.title': '自动化',
  'routines.subtitle': '无需值守、按计划运行的自动化任务。',
  'routines.newAutomation': '新建自动化',
  'routines.loading': '加载中…',
  'routines.empty': '还没有自动化任务。',
  'routines.emptyHint': '点击“新建自动化”即可安排一次无人值守的智能体运行。',
  'routines.runHistoryLoading': '正在加载运行记录…',
  'routines.runHistoryEmpty': '还没有运行记录。',
  'routines.fieldName': '名称',
  'routines.fieldNamePlaceholder': '晨间简报',
  'routines.fieldPrompt': '提示词',
  'routines.fieldPromptPlaceholder': '拉取昨天的 GitHub 与 Linear 活动并总结有哪些变化。',
  'routines.fieldSchedule': '计划',
  'routines.fieldMinute': '每小时的第几分钟',
  'routines.fieldTime': '时间',
  'routines.fieldTimezone': '时区',
  'routines.fieldsetProject': '项目',
  'routines.kind.hourly': '每小时',
  'routines.kind.daily': '每天',
  'routines.kind.weekdays': '工作日',
  'routines.kind.weekly': '每周',
  'routines.weekday.short.0': '周日',
  'routines.weekday.short.1': '周一',
  'routines.weekday.short.2': '周二',
  'routines.weekday.short.3': '周三',
  'routines.weekday.short.4': '周四',
  'routines.weekday.short.5': '周五',
  'routines.weekday.short.6': '周六',
  'routines.weekday.long.0': '周日',
  'routines.weekday.long.1': '周一',
  'routines.weekday.long.2': '周二',
  'routines.weekday.long.3': '周三',
  'routines.weekday.long.4': '周四',
  'routines.weekday.long.5': '周五',
  'routines.weekday.long.6': '周六',
  'routines.timeAm': '上午',
  'routines.timePm': '下午',
  'routines.describe.hourly': '每小时的第 {minute} 分运行',
  'routines.describe.daily': '每天 {time}（{tz}）运行',
  'routines.describe.weekdays': '周一至周五 {time}（{tz}）运行',
  'routines.describe.weekly': '每{day} {time}（{tz}）运行',
  'routines.modeCreate': '每次运行新建项目',
  'routines.modeCreateHint': '每次触发都使用一个全新且隔离的工作区。',
  'routines.modeReuse': '复用现有项目',
  'routines.modeReuseHint': '每次运行作为该项目中的一次新对话。',
  'routines.pickProject': '— 选择一个项目 —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '→ 每次运行新建项目',
  'routines.tagPaused': '已暂停',
  'routines.metaNext': '下次：{when}',
  'routines.metaLast': '上次：',
  'routines.triggerManual': '手动',
  'routines.triggerScheduled': '计划',
  'routines.openProject': '打开项目',
  'routines.openProjectTitle': '打开本次运行写入的项目',
  'routines.runNow': '立即运行',
  'routines.edit': '编辑',
  'routines.pause': '暂停',
  'routines.resume': '恢复',
  'routines.history': '历史记录',
  'routines.hideHistory': '隐藏历史记录',
  'routines.delete': '删除',
  'routines.deleteTitle': '删除此自动化',
  'routines.cancel': '取消',
  'routines.save': '保存',
  'routines.saving': '保存中…',
  'routines.create': '创建',
  'routines.creating': '创建中…',
  'routines.status.queued': '排队中',
  'routines.status.running': '运行中',
  'routines.status.succeeded': '成功',
  'routines.status.failed': '失败',
  'routines.status.canceled': '已取消',
  'routines.confirmDelete': '删除此自动化？过往运行记录及其项目将予以保留。',
  'routines.errorPickProject': '请选择要复用的项目，或切换为“每次运行新建项目”。',
  'routines.errorAgentEmptyOutput': '代理已完成运行但未产生任何输出。模型或提供商可能返回了空响应，请检查代理日志中的上游错误。',
  'entry.helpAria': '帮助',
  'entry.helpMenuAria': '帮助菜单',
  'entry.helpGetHelp': '在 GitHub 上获取帮助',
  'entry.helpSubmitFeature': '提交功能建议',
  'entry.helpWhatsNew': '最新动态',
  'entry.helpDownloadDesktop': '下载桌面端',
  'entry.githubStarLabel': 'Star',
  'entry.githubStarTitle': '为我们在 GitHub 点亮 Star',
  'entry.githubStarAria': '在 GitHub 上为 Open Design 点亮 Star',
  'entry.tabImageTemplates': '图片模板',
  'entry.tabVideoTemplates': '视频模板',
  'promptTemplates.searchPlaceholder': '搜索模板…',
  'promptTemplates.countLabel': '{n} 个结果',
  'promptTemplates.emptyImage': '还没有安装图片 Prompt 模板。',
  'promptTemplates.emptyVideo': '还没有安装视频 Prompt 模板。',
  'promptTemplates.emptyNoMatch': '没有匹配的模板。',
  'promptTemplates.attributionFooter': '改编自公开 Prompt 库，每张卡片都链接到原作者。',
  'promptTemplates.openPreviewTitle': '打开 Prompt 与预览',
  'promptTemplates.sourcePrefix': '来源：',
  'promptTemplates.fetchError': '无法加载此模板正文。',
  'promptTemplates.promptLabel': 'Prompt 正文',
  'promptTemplates.copyPrompt': '复制 Prompt',
  'promptTemplates.copyDone': '已复制！',
  'promptTemplates.modelHint': '建议模型：{model}',
  'promptTemplates.openSource': '查看原始来源',
  'promptTemplates.openFullscreen': '打开全屏预览',
  'promptTemplates.closeFullscreen': '关闭全屏预览',
  'promptTemplates.allSources': '所有来源',
  'promptTemplates.sourceFilterAria': '按来源筛选',
  'promptTemplates.retry': '重试',
  'connectors.title': '连接器',
  'connectors.subtitle': '可为实时看板提供数据的本地和未来数据源。',
  'connectors.account': '账号',
  'connectors.noAccount': '未连接',
  'connectors.tools': '工具',
  'connectors.connect': '连接',
  'connectors.disconnect': '断开连接',
  'connectors.authorizationPending': '等待授权中...',
  'connectors.authorizationPendingHint': '请在已打开的窗口中完成授权。',
  'connectors.cancelAuthorization': '取消',
  'connectors.configure': '配置',
  'connectors.unavailable': '不可用',
  'connectors.phaseStubTitle': '连接器 API 将在 Phase 3 提供；这里是预览入口。',
  'connectors.statusAvailable': '可用',
  'connectors.statusConnected': '已连接',
  'connectors.statusError': '错误',
  'connectors.statusDisabled': '已停用',
  'connectors.gateTitle': '添加 Composio API 密钥以继续',
  'connectors.gateBody': '在上方粘贴密钥并点击“保存密钥”，即可加载可用集成。',
  'connectors.aboutLabel': '简介',
  'connectors.detailsLabel': '详情',
  'connectors.statusLabel': '状态',
  'connectors.category.aiAgents': 'AI 代理',
  'connectors.category.aiInfrastructure': 'AI 基础设施',
  'connectors.category.accounting': '会计',
  'connectors.category.admin': '管理',
  'connectors.category.advertising': '广告',
  'connectors.category.analytics': '分析',
  'connectors.category.automation': '自动化',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': '日历',
  'connectors.category.commerce': '电商',
  'connectors.category.communication': '沟通',
  'connectors.category.contacts': '联系人',
  'connectors.category.dataPlatform': '数据平台',
  'connectors.category.database': '数据库',
  'connectors.category.design': '设计',
  'connectors.category.developer': '开发者工具',
  'connectors.category.documentation': '文档',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': '教育',
  'connectors.category.email': '邮件',
  'connectors.category.events': '活动',
  'connectors.category.fieldService': '现场服务',
  'connectors.category.finance': '财务',
  'connectors.category.fitness': '健身',
  'connectors.category.forms': '表单',
  'connectors.category.gaming': '游戏',
  'connectors.category.hr': '人力资源',
  'connectors.category.hospitality': '酒店与款待',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': '集成',
  'connectors.category.localization': '本地化',
  'connectors.category.logistics': '物流',
  'connectors.category.maps': '地图',
  'connectors.category.marketing': '营销',
  'connectors.category.media': '媒体',
  'connectors.category.meetings': '会议',
  'connectors.category.nonprofit': '非营利',
  'connectors.category.observability': '可观测性',
  'connectors.category.payments': '支付',
  'connectors.category.personal': '个人',
  'connectors.category.presentations': '演示文稿',
  'connectors.category.procurement': '采购',
  'connectors.category.product': '产品',
  'connectors.category.productivity': '生产力',
  'connectors.category.projectManagement': '项目管理',
  'connectors.category.recruiting': '招聘',
  'connectors.category.research': '研究',
  'connectors.category.salesIntelligence': '销售情报',
  'connectors.category.scheduling': '日程安排',
  'connectors.category.search': '搜索',
  'connectors.category.security': '安全',
  'connectors.category.signing': '签署',
  'connectors.category.social': '社交',
  'connectors.category.spreadsheets': '电子表格',
  'connectors.category.storage': '存储',
  'connectors.category.support': '支持',
  'connectors.category.surveys': '问卷',
  'connectors.category.tasks': '任务',
  'connectors.category.timeTracking': '时间追踪',
  'connectors.category.video': '视频',
  'connectors.category.whiteboard': '白板',
  'connectors.categoryLabel': '类别',
  'connectors.providerLabel': '提供方',
  'connectors.toolsSection': '工具',
  'connectors.toolsLoading': '正在加载工具…',
  'connectors.noToolsAvailable': '暂无可用工具，连接后即可发现此集成提供的能力。',
  'connectors.toolDetailsUnavailable': '无法获取工具详情,但此连接器报告了 {n} 个工具。',
  'connectors.loadMoreTools': '加载更多工具',
  'connectors.openDetailsAria': '查看 {name} 详情',
  'connectors.toolsBadgeNone': '暂无工具',
  'connectors.toolsBadgeOne': '{n} 个工具',
  'connectors.toolsBadgeMany': '{n} 个工具',
  'connectors.searchPlaceholder': '搜索连接器…',
  'connectors.searchAriaLabel': '按名称、提供方或工具搜索连接器',
  'connectors.searchClear': '清除搜索',
  'connectors.emptyNoMatchTitle': '没有匹配“{query}”的连接器',
  'connectors.emptyNoMatchBody': '换个关键词试试，或清除搜索以浏览完整目录。',
  'connectors.emptyNoMatchAction': '清除搜索',
  'newproj.tabPrototype': '原型',
  'newproj.tabLiveArtifact': '实时看板',
  'newproj.tabDeck': '幻灯片',
  'newproj.tabTemplate': '从模板',
  'newproj.tabMedia': '媒体',
  'newproj.tabOther': '其它',
  'newproj.titlePrototype': '新建原型',
  'newproj.titleLiveArtifact': '新建实时看板',
  'newproj.titleDeck': '新建幻灯片',
  'newproj.titleTemplate': '从模板开始',
  'newproj.titleImage': '新建图片',
  'newproj.titleVideo': '新建视频',
  'newproj.titleAudio': '新建音频',
  'newproj.titleMedia': '新建媒体',
  'newproj.titleOther': '新建项目',
  'newproj.namePlaceholder': '项目名称',
  'newproj.fidelityLabel': '精度',
  'newproj.fidelityWireframe': '线框图',
  'newproj.fidelityHigh': '高保真',
  'newproj.toggleSpeakerNotes': '使用演讲备注',
  'newproj.toggleSpeakerNotesHint': '减少幻灯片上的文字，要点放到备注中。',
  'newproj.toggleAnimations': '加入动效',
  'newproj.toggleAnimationsHint': '在模板基础上叠加动效（入场、悬停、过渡）。',
  'newproj.targetPlatformsLabel': '目标平台',
  'newproj.targetPlatformsHint': '可多选。响应式 Web 仅覆盖浏览器断点；如需原生跨平台版本，请加入 iOS、Android、平板应用或桌面应用。',
  'newproj.platform.responsive.label': '响应式 Web',
  'newproj.platform.responsive.hint': '一套 Web 体验，适配桌面、平板和移动浏览器',
  'newproj.platform.webDesktop.label': '桌面 Web',
  'newproj.platform.webDesktop.hint': '浏览器优先的产品或落地页',
  'newproj.platform.mobileIos.label': 'iOS 应用',
  'newproj.platform.mobileIos.hint': 'iPhone 画框与 iOS 交互规范',
  'newproj.platform.mobileAndroid.label': 'Android 应用',
  'newproj.platform.mobileAndroid.hint': 'Pixel 画框与 Material 交互规范',
  'newproj.platform.tablet.label': '平板应用',
  'newproj.platform.tablet.hint': '原生风格的平板体验，支持分屏视图',
  'newproj.platform.desktopApp.label': '桌面应用',
  'newproj.platform.desktopApp.hint': 'macOS/Windows 应用外观',
  'newproj.surfaceOptionsLabel': '配套界面',
  'newproj.includeLandingPage': '包含落地页',
  'newproj.includeLandingPageHint': '为广告、候补名单、发布活动、应用下载或产品说明添加一个响应式营销页面。',
  'newproj.includeOsWidgets': '包含系统小部件',
  'newproj.includeOsWidgetsHint': '为移动/平板应用添加平台原生的主屏幕、锁屏或快捷小部件。',
  'newproj.includeOsWidgetsDisabledHint': '选择 iOS、Android 或平板应用作为目标平台时可用。',
  'newproj.templateLabel': '模板',
  'newproj.noTemplatesTitle': '还没有模板',
  'newproj.noTemplatesBody': '打开任意项目，在文件查看器内的「分享」菜单将其保存为模板，模板将出现在这里。',
  'newproj.savedTemplate': '已保存的模板',
  'newproj.fileSingular': '个文件',
  'newproj.filePlural': '个文件',
  'newproj.create': '创建',
  'newproj.locationLabel': '保存到',
  'newproj.locationDefault': 'Open Design 项目',
  'newproj.locationExternalBase': '外部基目录',
  'newproj.createLiveArtifact': '创建实时看板',
  'newproj.createFromTemplate': '基于模板创建',
  'newproj.createDisabledTitle': '请先在任意项目内通过「分享」菜单将其保存为模板。',
  'newproj.importClaudeZip': '导入 Claude Design ZIP',
  'newproj.importClaudeZipTitle': '导入 Claude Design 导出的 .zip 文件',
  'newproj.importingClaudeZip': '正在导入…',
  'newproj.privacyFooter': '默认情况下只有你能看到自己的项目。',
  'newproj.designSystem': '设计体系',
  'newproj.dsNoneFreeform': '不指定 — 自由发挥',
  'newproj.dsNoneSubtitleEmpty': '不使用体系 token，由你决定整体配色',
  'newproj.dsNoneSubtitleSelected': '跳过体系 token，由代理自行选择配色。',
  'newproj.dsCategoryFallback': '设计体系',
  'newproj.dsSearch': '搜索设计体系…',
  'newproj.dsModeAria': '选择模式',
  'newproj.dsModeSingle': '单选',
  'newproj.dsModeMulti': '多选',
  'newproj.dsNoneTitle': '不指定 — 自由发挥',
  'newproj.dsNoneSub': '跳过体系 token，由代理自行选择配色。',
  'newproj.dsEmpty': '没有匹配「{query}」的设计体系。',
  'newproj.dsFootSingular': '只作为灵感参考。',
  'newproj.dsFootPlural': '只作为灵感参考。',
  'newproj.dsFootClear': '清除',
  'newproj.dsBadgeDefault': '默认',
  'newproj.dsPrimaryFallback': '主体系',
  'newproj.surfaceImage': '图片',
  'newproj.surfaceVideo': '视频',
  'newproj.surfaceAudio': '音频',
  'newproj.modelLabel': '模型',
  'newproj.modelSearch': '搜索模型…',
  'newproj.modelEmpty': '没有匹配的模型。',
  'newproj.modelRecommended': '推荐',
  'newproj.modelMissingTitle': '选择模型',
  'newproj.modelMissingSub': '为此场景选一个模型。',
  'newproj.aspectLabel': '比例',
  'newproj.videoLengthLabel': '时长',
  'newproj.videoLengthSeconds': '{n} 秒',
  'newproj.audioKindLabel': '音频类型',
  'newproj.audioKindMusic': '音乐',
  'newproj.audioKindSpeech': '配音 / TTS',
  'newproj.audioKindSfx': '音效',
  'newproj.audioDurationLabel': '时长',
  'newproj.audioDurationSeconds': '{n} 秒',
  'newproj.voiceLabel': '声音',
  'newproj.voicePlaceholder': '提供商 voice id，可选',
  'newproj.connectorsLabel': '连接器',
  'newproj.connectorsHint': '实时看板可以从这些数据源拉取信息。',
  'newproj.connectorsEmptyTitle': '尚未配置连接器',
  'newproj.connectorsEmptyBody': '连接一个数据源，让实时看板加载真实数据而非占位内容。',
  'newproj.connectorsEmptyCta': '去配置连接器 →',
  'newproj.connectorsLoading': '正在加载连接器…',
  'newproj.connectorsCountOne': '已连接 {n} 个',
  'newproj.connectorsCountMany': '已连接 {n} 个',
  'newproj.connectorsManage': '管理',
  'newproj.promptTemplateLabel': '参考模板',
  'newproj.promptTemplateNoneTitle': '不指定 — 自由发挥',
  'newproj.promptTemplateNoneSub': '跳过模板库，自己描述需求',
  'newproj.promptTemplateRefSub': '参考模板',
  'newproj.promptTemplateSearch': '搜索模板…',
  'newproj.promptTemplateEmpty': '当前还没有此类型的模板。',
  'newproj.promptTemplateBodyLabel': 'Prompt（可继续优化）',
  'newproj.promptTemplateOptimizeHint': '可以任意编辑 — 修改后的内容会作为 agent 生成时的参考。',
  'newproj.promptTemplateBodyEmpty': '正文为空 — agent 不会拿到模板参考。',
  'newproj.deleteTemplateTitle': '删除模板',
  'newproj.deleteTemplateConfirm': '确定删除「{name}」？此操作无法撤销。',
  'newproj.deleteTemplateConfirmCta': '删除模板',
  'newproj.deleteTemplateError': '无法删除该模板，请重试。',
  'designs.subRecent': '最近',
  'designs.subYours': '我的设计',
  'designs.filterAria': '筛选项目',
  'designs.searchPlaceholder': '搜索…',
  'designs.emptyNoProjects': '还没有项目。',
  'designs.emptyNoMatch': '没有匹配的项目。',
  'designs.deleteTitle': '删除项目',
  'designs.deleteConfirm': '确定删除「{name}」？',
  'designs.cardFreeform': '自由设计',
  'designs.badgeLive': '实时',
  'designs.liveArtifactBadgesAria': '实时看板标记',
  'designs.liveCount': '{n} 个实时',
  'designs.statusLive': '实时看板',
  'designs.statusArchived': '已归档',
  'designs.statusError': '错误',
  'designs.statusRefreshing': '刷新中…',
  'designs.statusRefreshFailed': '刷新失败',
  'designs.statusRefreshed': '已刷新',
  'designs.status.notStarted': '未开始',
  'designs.status.queued': '等待中',
  'designs.status.running': '运行中',
  'designs.status.awaitingInput': '等待回复',
  'designs.status.succeeded': '已完成',
  'designs.status.published': '已发布',
  'designs.status.failed': '失败',
  'designs.status.canceled': '已取消',
  'designs.viewToggleAria': '视图模式',
  'designs.viewGrid': '网格视图',
  'designs.viewKanban': '看板视图',
  'designs.kanbanEmptyColumn': '暂无设计',
  'designs.deleteAria': '删除项目 {name}',
  'designs.menuMore': '更多操作',
  'designs.menuRename': '重命名',
  'designs.menuDelete': '删除',
  'designs.renamePrompt': '为「{name}」输入新名称',
  'designs.selectMode': '选择',
  'designs.cancelSelect': '取消',
  'designs.deleteSelected': '删除所选',
  'designs.selectedCount': '已选择 {n} 项',
  'designs.deleteSelectedConfirm': '确定删除选中的 {n} 个项目？',
  'designs.deleteSelectedSuccess': '已成功删除 {n} 个项目。',
  'designs.deleteSelectedPartial': '已删除 {deleted} 个项目；{failed} 个失败。',
  'designs.tagPrototype': '原型',
  'designs.tagLiveArtifact': '实时看板',
  'designs.tagSlide': '幻灯片',
  'designs.tagMedia': '媒体',
  'designs.renameTitle': '重命名项目',
  'designs.renameSave': '确定',
  'designs.renameCancel': '取消',
  'examples.typeLabel': '类型',
  'examples.surfaceLabel': '类型',
  'examples.surfaceWeb': '网页',
  'examples.surfaceImage': '图片',
  'examples.surfaceVideo': '视频',
  'examples.surfaceAudio': '音频',
  'examples.scenarioLabel': '场景',
  'examples.modeAll': '全部',
  'examples.modePrototypeDesktop': '原型 · 桌面端',
  'examples.modePrototypeMobile': '原型 · 移动端',
  'examples.modeDeck': '幻灯片',
  'examples.modeDocument': '文档与模板',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': '实时',
  'examples.scenarioGeneral': '通用',
  'examples.scenarioEngineering': '工程',
  'examples.scenarioProduct': '产品',
  'examples.scenarioDesign': '设计',
  'examples.scenarioMarketing': '市场',
  'examples.scenarioSales': '销售',
  'examples.scenarioFinance': '财务',
  'examples.scenarioHr': '人力资源',
  'examples.scenarioOperations': '运营',
  'examples.scenarioSupport': '支持',
  'examples.scenarioLegal': '法务',
  'examples.scenarioEducation': '教育',
  'examples.scenarioPersonal': '个人',
  'examples.searchPlaceholder': '搜索示例…',
  'examples.searchAria': '按名称搜索示例',
  'examples.emptyNoSkills': '没有可用的技能，守护进程是否在运行？',
  'examples.emptyNoMatch': '没有匹配当前筛选的示例。',
  'examples.openPreview': '⤢ 打开预览',
  'examples.loadingPreview': '正在加载预览…',
  'examples.hoverPreview': '将鼠标悬停以查看预览',
  'examples.usePrompt': '使用此 Prompt',
  'examples.previewModalTitle': '在弹窗中查看完整预览',
  'examples.shareTitle': '分享此示例',
  'examples.shareLoadFirst': '请先悬停以加载预览',
  'examples.unavailablePlaceholder': '此技能未附带 {kind} 预览样例 — 打开查看详情',
  'examples.shareUnavailable': '此技能未附带 {kind} 预览样例可分享',
  'examples.shareMenu': '分享 ▾',
  'examples.exportPdfAllSlides': '导出为 PDF（全部幻灯片）',
  'examples.exportPptxLocked': '导出为 PPTX…（请先打开模板）',
  'examples.tagSlideDeck': '幻灯片',
  'examples.tagTemplate': '模板',
  'examples.tagDesignSystem': '设计体系',
  'examples.tagMobilePrototype': '移动端原型',
  'examples.tagDesktopPrototype': '桌面端原型',
  'examples.tagImage': '图片',
  'examples.tagVideo': '视频',
  'examples.tagAudio': '音频',
  'examples.previewLabel': '预览',
  'ds.surfaceLabel': '类型',
  'ds.surfaceWeb': '网页',
  'ds.surfaceImage': '图片',
  'ds.surfaceVideo': '视频',
  'ds.surfaceAudio': '音频',
  'ds.searchPlaceholder': '搜索设计体系…',
  'ds.emptyNoMatch': '没有匹配的设计体系。',
  'ds.badgeDefault': '默认',
  'ds.preview': '预览',
  'ds.previewTitle': '预览设计体系',
  'ds.categoryAll': '全部',
  'ds.categoryUncategorized': '未分类',
  'ds.showcase': '展示',
  'ds.tokens': 'Token',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': '正在加载 DESIGN.md…',
  'avatar.title': '账户与设置',
  'avatar.localCli': '本机 CLI',
  'avatar.anthropicApi': 'Anthropic API',
  'avatar.useLocal': '使用本机 CLI',
  'avatar.useApi': '使用 API · BYOK',
  'avatar.codeAgent': '代码代理',
  'avatar.rescan': '重新扫描 PATH',
  'avatar.amrConsole': 'AMR 账户',
  'avatar.amrConsoleMeta': '余额与充值',
  'avatar.settings': '设置',
  'avatar.backToProjects': '返回项目列表',
  'avatar.metaActive': '使用中',
  'avatar.metaOffline': '未运行',
  'avatar.metaSelected': '已选',
  'avatar.noAgentSelected': '尚未选择代理',
  'avatar.modelSection': '模型',
  'avatar.modelLabel': '模型',
  'avatar.reasoningLabel': '推理',
  'avatar.customSuffix': '（自定义）',
  'socialShare.openDesignSection': '分享 Open Design',
  'socialShare.openDesignTitle': 'GitHub 上的 Open Design',
  'socialShare.openDesignText': 'Open Design 是开源的设计智能工作区，可以生成、编辑、部署并交付设计产物。',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': '社媒分享',
  'socialShare.publishPageTitle': '发布分享页',
  'socialShare.publishPageSubtitle': '发布当前预览，以便分享到社媒平台。',
  'socialShare.projectTitle': '{title} · Open Design',
  'socialShare.projectText': '我用 Open Design 做了 {title}。查看已部署产物，也推荐收藏仓库：{repo}',
  'socialShare.projectCopyText': '我用 Open Design 做了 {title}\n{url}\nOpen Design 仓库：{repo}',
  'socialShare.deployFirst': '先部署，再分享到社媒…',
  'socialShare.copied': '已复制',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': '微博',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': '小红书',
  'inlineSwitcher.chipTitle': '切换 CLI / 模型',
  'inlineSwitcher.chipCli': '本地 CLI',
  'inlineSwitcher.chipByok': '自带 Key',
  'inlineSwitcher.modelDefault': '默认',
  'inlineSwitcher.noAgent': '未选择',
  'inlineSwitcher.modeLabel': '模式',
  'inlineSwitcher.agentLabel': '代理',
  'inlineSwitcher.providerLabel': '服务商',
  'inlineSwitcher.modelLabel': '模型',
  'inlineSwitcher.useCli': '使用本地 CLI',
  'inlineSwitcher.useByok': '使用自带 API Key',
  'inlineSwitcher.daemonOffline': '守护进程离线 — 打开设置',
  'inlineSwitcher.noAgentsDetected': 'PATH 中未发现可用 CLI',
  'inlineSwitcher.openSettingsForModel': '在“设置”中配置该服务商',
  'inlineSwitcher.missingApiKey': '尚未填写 API Key — 在“设置”中添加。',
  'inlineSwitcher.openFullSettings': '打开执行设置',
  'inlineSwitcher.customSuffix': '（自定义）',
  'project.backToProjects': '返回项目列表',
  'project.metaFreeform': '自由设计',
  'project.customInstructions': '项目指令',
  'project.customInstructionsPlaceholder': '此项目的指令（每条消息都会注入）…',
  'project.resizeChatPanel': '调整聊天面板大小',
  'project.instructionsActive': '已生效 — 每条消息都会附带',
  'chat.tabChat': '对话',
  'chat.tabComments': '评论',
  'chat.commentsSoon': '评论 — 即将上线',
  'chat.comments.attached': '已附加到对话',
  'chat.comments.emptyAttached': '没有已附加的评论。',
  'chat.comments.saved': '已保存的评论',
  'chat.comments.emptySaved': '没有已保存的评论。',
  'chat.comments.add': '添加',
  'chat.comments.addAll': '全部添加',
  'chat.comments.remove': '移除',
  'chat.comments.placeholder': '评论此元素…',
  'chat.comments.addSend': '添加并发送',
  'chat.comments.updateSend': '更新并发送',
  'chat.comments.removeAttachment': '移除评论附件',
  'chat.comments.removeAttachmentAria': '移除 {name} 的评论附件',
  'chat.comments.comment': '评论',
  'chat.comments.sendToChat': '发送到聊天',
  'chat.comments.sending': '发送中…',
  'chat.comments.edit': '编辑',
  'chat.comments.select': '选择',
  'chat.comments.selectAll': '全选',
  'chat.comments.deselect': '取消选择',
  'chat.comments.nSelected': '已选择 {n} 个',
  'chat.comments.pin': '图钉',
  'chat.comments.addNote': '添加备注',
  'chat.comments.savedToast': '评论已保存',
  'chat.comments.pinSavedToast': '图钉已保存',
  'chat.comments.pinAtCoords': '位于 {x}, {y}',
  'chat.comments.capturedItems': '{n} 个捕获项',
  'chat.comments.clear': '清除',
  'chat.comments.targetImage': '图片',
  'chat.comments.targetControl': '控件',
  'chat.comments.targetLink': '链接',
  'chat.comments.targetText': '文本',
  'chat.comments.targetSection': '分区',
  'chat.comments.targetPage': '页面',
  'chat.comments.targetArea': '区域',
  'chat.annotationNotePlaceholder': '为这个标记添加说明',
  'chat.annotationAttachImage': '添加图片',
  'chat.annotationAttachedImages': '已添加图片',
  'chat.annotationAttachedRemove': '移除最后一张图片',
  'chat.annotationAddToInput': '发送到输入框',
  'chat.annotationAddingToInput': '正在添加...',
  'chat.annotationQueue': '加入队列',
  'chat.annotationQueueing': '加入队列中...',
  'chat.annotationSending': '发送中...',
  'chat.annotationSendDisabledReason': '当前正有任务在执行',
  'chat.annotationPreviewMissing': '无法截到下面的预览，请重试',
  'chat.annotationPreviewMissingInk': '无法截到下面的预览，请重试，避免只附带笔迹',
  'chat.annotationSentWithoutScreenshot': '未能截取预览，已发送标注（不含截图）。',
  'chat.annotationTimeout': '标注发送超时，请重试',
  'chat.annotationFailed': '标注发送失败，请重试',
  'chat.annotationProjectCreateFailed': '无法创建项目，标注未发送',
  'chat.annotationUploadFailed': '附件上传失败，请重试',
  'chat.conversationsTitle': '对话历史',
  'chat.conversationsAria': '对话历史',
  'chat.newConversation': '新建对话',
  'chat.newConversationsTitle': '新建对话',
  'chat.conversationsHeading': '对话',
  'chat.new': '新建',
  'chat.emptyConversations': '还没有对话。',
  'chat.deleteConversation': '删除对话',
  'chat.renameConversationLabel': '重命名「{title}」',
  'chat.deleteConversationConfirm': '确定删除「{title}」？该操作会删除其消息。',
  'chat.untitledConversation': '未命名对话',
  'chat.forkedConversationTitle': '{title} 分叉',
  'chat.forkConversationFailed': '无法分叉这个对话。',
  'chat.startTitle': '开始一个对话',
  'chat.startHint': '描述你想生成的内容，或从下面的示例开始：',
  'chat.fillInputTitle': '点击填充到输入框',
  'chat.jumpToLatest': '回到最新',
  'chat.scrollToLatest': '滚动到最新',
  'chat.you': '你',
  'chat.openFile': '打开 {name}',
  'chat.copyPrompt': '复制提示词',
  'chat.copyErrorDiagnostic': '复制错误诊断信息',
  'chat.copyDone': '已复制！',
  'chat.inspect.noEditableTargets': '未找到可编辑的文本或样式目标。',
  'chat.inspect.noCommentTargets': '未找到可评论的文本或视觉目标。',
  'chat.inspect.editHint': '在预览中选择文本或样式目标进行编辑。',
  'chat.inspect.commentHint': '在预览中选择文本或区域进行评论。',
  'chat.composerPlaceholder': '描述你想生成的内容…',
  'chat.activeFileEditingLabel': '编辑中',
  'chat.activeFilePlaceholder': '让 Open Design 修改 {file}...',
  'chat.designArtifactsShowMore': '再显示 {count} 个设计文件',
  'chat.mode.chat.label': '提问',
  'chat.mode.chat.title': 'Ask 模式',
  'chat.mode.chat.summary': '适合快速问答、修改建议、规划和讨论，不默认创建新的设计产物。',
  'chat.mode.chat.solves': '用来澄清想法、调试提示词、比较方案，或询问已有稿子的改进点。',
  'chat.mode.chat.query1': '总结这份稿子，并指出还缺什么。',
  'chat.mode.chat.query2': '帮我判断这个落地页应该怎么组织结构。',
  'chat.mode.chat.query3': '看一下这个设计，给我具体的改进建议。',
  'chat.mode.design.label': '设计',
  'chat.mode.design.title': '设计模式',
  'chat.mode.design.summary': '适合创建或修改具体设计产物，比如网页、原型、实时看板、幻灯片、图片、视频、HyperFrames、音频、数据看板和项目文件。',
  'chat.mode.design.solves': '当你希望 Open Design 生成文件、更新工作区，或把需求变成多模态可交付结果时使用。',
  'chat.mode.design.query1': '根据这段需求做一个产品发布落地页和 HyperFrames 原型。',
  'chat.mode.design.query2': '做一份 10 页投资人 Deck，并附上讲稿备注。',
  'chat.mode.design.query3': '为这次 campaign 生成图片、视频和音频创意。',
  'chat.mode.cardBestFor': '适合解决',
  'chat.mode.cardTry': '可以这样问',
  'chat.composerHint': '⌘/Ctrl + Enter 发送 · 说清目标、内容、风格和格式',
  'chat.cliSettingsTitle': 'CLI 与模型设置',
  'chat.cliSettingsAria': '打开 CLI 与模型设置',
  'chat.attachTitle': '附加文件（也可以粘贴/拖入）',
  'chat.addContextTitle': '添加内容',
  'chat.attachAria': '附加文件',
  'chat.importTitle': '导入素材（即将上线）',
  'chat.importLabel': '导入',
  'chat.importComingSoon': '即将上线',
  'chat.importSoon': '即将',
  'chat.importFig': '上传 .fig 文件',
  'chat.importGitHub': '连接 GitHub',
  'chat.importWeb': '抓取网页元素',
  'chat.importFolder': '关联代码目录',
  'chat.importSkills': '技能与设计体系',
  'chat.importProject': '引用其它项目',
  'chat.importDesignSystemHeader': '选择一个设计体系',
  'chat.importDesignSystemBack': '返回',
  'chat.importDesignSystemSearch': '搜索设计体系…',
  'chat.importDesignSystemEmpty': '没有匹配 "{query}" 的设计体系',
  'chat.importDesignSystemNone': '不指定 — 自由风格',
  'chat.importDesignSystemNoneSub': '本轮不锚定任何体系',
  'chat.importDesignSystemActive': '当前',
  'chat.importDesignSystemSwitched': '已切换设计体系为 {title}',
  'chat.importDesignSystemFailed': '切换设计体系失败，请重试。',
  'chat.importDesignSystemLoadFailed': '无法加载设计体系。',
  'browserUse.title': '灵感',
  'browserUse.summary': '{count} 个网页操作，优先展示素材提取、设计语言、动效、视觉校验和组件结构。',
  'browserUse.searchAria': '搜索灵感',
  'browserUse.searchPlaceholder': '搜索截图、字体、配色、a11y...',
  'browserUse.empty': '没有匹配的灵感',
  'browserUse.unavailable': '灵感暂不可用',
  'browserUse.added': '已加入输入框',
  'browserUse.category.assets': '素材提取',
  'browserUse.category.tokens': '设计语言',
  'browserUse.category.motion': '动效',
  'browserUse.category.visual': '视觉校验',
  'browserUse.category.structure': '组件结构',
  'browserUse.category.project': '项目运行',
  'browserUse.category.general': '通用操作',
  'browserUse.input.none': '无需输入',
  'browserUse.input.assetKind': '类型：images / svgs / media / fonts，最多 200',
  'browserUse.input.optionalSelector': '可选选择器',
  'browserUse.input.requirementSelector': '校验要求，可选选择器',
  'browserUse.input.selectorOptional': '可选选择器',
  'browserUse.input.scaleOne': '缩放 1x',
  'browserUse.input.selectorScaleTwo': '选择器，默认 2x',
  'browserUse.input.gridOverlay': '12 列，最大宽 1200，间距 24',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL、域名或搜索词',
  'browserUse.input.selector': '选择器',
  'browserUse.input.selectorText': '选择器和文本',
  'browserUse.input.scroll': '像素、top、bottom 或 page',
  'browserUse.input.terminalRun': '命令，超时 120 秒',
  'browserUse.input.command': '命令',
  'browserUse.input.maxChars': '最多 8000 字符',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': '从 header、nav、类名、位置、OG 图片和 favicon 中找出最可能的 Logo。',
  'browserUse.action.list_images.output': '枚举 img、srcset、source 和 CSS 背景图，并带尺寸和 alt。',
  'browserUse.action.download_assets.output': '下载素材文件夹，并生成支持 referer/cookie 的 _manifest.json。',
  'browserUse.action.extract_svgs.output': '提取内联 SVG 和外链 .svg，分别保存为 SVG 文件。',
  'browserUse.action.optimize_svgs.output': '输出优化后的 SVG 文件和压缩比例。',
  'browserUse.action.extract_colors.output': '频率加权配色板和 :root CSS 颜色变量，输出 palette.json 与 palette.html。',
  'browserUse.action.extract_fonts.output': '字体家族、字号、字重和 @font-face Top 列表，输出 typography.json。',
  'browserUse.action.extract_design_tokens.output': '圆角、阴影、间距和 CSS 变量，输出 tokens.json。',
  'browserUse.action.extract_type_scale.output': '标题、正文、按钮的字号阶梯、字重、行高和比例。',
  'browserUse.action.extract_buttons.output': '去重后的按钮样式库，输出 buttons.html 和 buttons.json。',
  'browserUse.action.extract_grid_system.output': 'Grid/Flex 容器、方向、间距、列数和最大宽度，输出 layout.json。',
  'browserUse.action.extract_breakpoints.output': '响应式媒体查询断点，输出 breakpoints.json。',
  'browserUse.action.extract_gradients.output': 'CSS 渐变，输出 gradients.css、gradients.json 和 HTML 预览。',
  'browserUse.action.extract_shadows.output': 'box-shadow、text-shadow 和 drop-shadow，输出 shadows.json 和预览。',
  'browserUse.action.extract_easings.output': '过渡和动画缓动函数，输出 easings.json。',
  'browserUse.action.export_tokens.output': '导出 tokens.css、tokens.scss、tailwind.theme.js 和 style-dictionary.tokens.json。',
  'browserUse.action.extract_animations.output': '@keyframes、transition、transform 规则和动效库检测，输出 motion.css 与 motion.json。',
  'browserUse.action.validate_view.output': '截图路径和结构化视觉/布局问题。',
  'browserUse.action.audit_layout.output': '布局缺陷检测：溢出、越界、重叠、文字裁切，输出 audit.json。',
  'browserUse.action.audit_accessibility.output': 'A11y 问题：选择器、标签、角色、焦点、对比度，以及必要截图。',
  'browserUse.action.responsive_screenshots.output': 'mobile 390、tablet 834、desktop 1440 三档截图。',
  'browserUse.action.screenshot_full.output': '超出视口的整页长截图。',
  'browserUse.action.screenshot_element.output': '单元素截图，默认 2x。',
  'browserUse.action.screenshot_with_grid.output': '带布局栅格叠加的截图。',
  'browserUse.action.screenshot_dark_mode.output': '模拟 prefers-color-scheme: dark 后截图。',
  'browserUse.action.generate_styleguide.output': '一页式样式指南，包含配色、字号阶梯、圆角和阴影。',
  'browserUse.action.extract_html.output': '清洗后的自包含 HTML，移除 script、noscript 和内联事件属性。',
  'browserUse.action.extract_component_inventory.output': '重复组件模式、选择器、数量和截图。',
  'browserUse.action.extract_copy.output': '标题、CTA、正文和描述，输出 copy.md 与 copy.json。',
  'browserUse.action.extract_nav.output': '主导航和页脚链接，输出 sitemap.md 与 nav.json。',
  'browserUse.action.extract_forms.output': '表单字段、标签、校验提示和提交动作，输出 forms.json。',
  'browserUse.action.run_project.output': '识别 dev server URL 并在 Browser 标签中打开。',
  'browserUse.action.detect_project.output': '框架、包管理器、安装命令、dev 命令和端口。',
  'browserUse.action.page_info.output': 'URL、标题、描述、OG 图片、主题色、favicon 和 viewport。',
  'browserUse.action.snapshot.output': '最多 120 个可见交互/文本元素，含 tag、label、href 和坐标。',
  'browserUse.action.navigate.output': '打开页面并返回 page_info。',
  'browserUse.action.click.output': '滚动到可见后点击第一个匹配元素。',
  'browserUse.action.type_text.output': '填写输入框，并触发 input/change 事件。',
  'browserUse.action.scroll.output': '当前和最大滚动位置。',
  'browserUse.action.extract_og_metadata.output': 'Meta 标题/描述/canonical、OG/Twitter 卡片、社交图和主题色。',
  'browserUse.action.terminal_run.output': 'stdout、stderr 和退出码。',
  'browserUse.action.terminal_run_background.output': '后台任务 id 和最近输出。',
  'browserUse.action.terminal_read.output': '共享终端最近输出。',
  'chat.designToolbox.title': '设计百宝箱',
  'chat.designToolbox.tooltip': '设计百宝箱',
  'chat.designToolbox.aria': '打开设计百宝箱',
  'chat.designToolbox.searchPlaceholder': '搜索 skills / MCP / plugins / connectors / design files…',
  'chat.designToolbox.searchAria': '搜索设计百宝箱资源',
  'chat.designToolbox.followupSection': '后续动作',
  'chat.designToolbox.resourcesSection': '全局资源',
  'chat.designToolbox.selected': '已选',
  'chat.designToolbox.noResources': '没有找到“{query}”相关资源。',
  'chat.designToolbox.badge.video': '视频',
  'chat.designToolbox.badge.image': '图像',
  'chat.designToolbox.badge.motion': '动效',
  'chat.designToolbox.badge.polish': '润色',
  'chat.designToolbox.action.auto-match.title': '智能匹配下一步',
  'chat.designToolbox.action.auto-match.badge': '匹配',
  'chat.designToolbox.action.auto-match.description': '先定义好看标准，再全局匹配 skills / MCP / plugins / connectors / files。',
  'chat.designToolbox.action.motion.title': '加动画 / 动效',
  'chat.designToolbox.action.motion.badge': '动画',
  'chat.designToolbox.action.motion.description': '给当前 HTML 或页面元素加入入场、滚动、状态切换和微交互。',
  'chat.designToolbox.action.motion-polish.title': '动效润色',
  'chat.designToolbox.action.motion-polish.badge': '节奏',
  'chat.designToolbox.action.motion-polish.description': '检查现有动效的节奏、缓动、性能和 reduced-motion 兜底。',
  'chat.designToolbox.action.anti-ai-polish.title': '反 AI 味美化',
  'chat.designToolbox.action.anti-ai-polish.badge': '去味',
  'chat.designToolbox.action.anti-ai-polish.description': '移除模板感、AI 紫蓝渐变、廉价卡片堆叠和空泛 copy。',
  'chat.designToolbox.action.visual-polish.title': '设计润色 / 可交付',
  'chat.designToolbox.action.visual-polish.badge': '润色',
  'chat.designToolbox.action.visual-polish.description': '审一次视觉层级、排版、间距、响应式、可访问性和交付状态。',
  'chat.designToolbox.action.image-gen.title': '生图 / 视觉参考',
  'chat.designToolbox.action.image-gen.badge': '生图',
  'chat.designToolbox.action.image-gen.description': '为当前页面生成分区视觉参考、素材、图标、社媒图或 moodboard。',
  'chat.designToolbox.action.video-gen.title': '生视频 / 动画脚本',
  'chat.designToolbox.action.video-gen.badge': '视频',
  'chat.designToolbox.action.video-gen.description': '把设计转成短视频、Remotion / Hyperframes 分镜或可生成视频的 prompt。',
  'chat.designToolbox.kind.skill': '技能',
  'chat.designToolbox.kind.plugin': '插件',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'MCP 模板',
  'chat.designToolbox.kind.connector': '连接器',
  'chat.designToolbox.kind.designFile': '设计文件',
  'chat.designToolbox.context.browser': '浏览器',
  'chat.designToolbox.context.designFiles': '设计文件',
  'chat.designToolbox.context.designSystem': '设计体系',
  'chat.designToolbox.context.folder': '文件夹',
  'chat.designToolbox.context.terminal': '终端',
  'chat.designToolbox.context.sideChat': '侧边对话',
  'chat.designToolbox.context.liveArtifact': '实时看板',
  'chat.designToolbox.context.file': '文件',
  'chat.designToolbox.prompt.contextGeneric': '当前目标：当前打开的 HTML / 设计文件 / 网页元素。',
  'chat.designToolbox.prompt.contextSpecific': '当前目标：{kind} · {label}。',
  'chat.designToolbox.prompt.preserveDraft': '保留我输入框里已有的意图：{draft}',
  'chat.designToolbox.prompt.selectedSkill': '已选 skill：{skill}。请把它作为本轮主要工作流。',
  'chat.designToolbox.prompt.noSkill': '如果没有匹配到具体 skill，请先从当前可用 skills / MCP / plugins / connectors / design files 中选择最合适的组合。',
  'chat.designToolbox.prompt.autoMatchIntro': '请作为 Creative Director 总调度完成一套设计流程：',
  'chat.designToolbox.prompt.autoMatchStep1': '1. 先帮我定义“什么是好看的设计”：受众、业务目标、品牌气质、风格参考、信息密度、色彩/字体/动效/素材标准，以及不能出现的 AI 味/模板感。',
  'chat.designToolbox.prompt.autoMatchStep2': '2. 搜索并匹配上面的全量资源索引，不要只看设计百宝箱推荐项；需要时组合 skills、MCP、plugins、connectors 和 design files。',
  'chat.designToolbox.prompt.autoMatchStep3': '3. 如果目标或审美标准还不够清楚，用有限选项或表单式 UI 引导我选择，并给出推荐默认项；如果已经足够清楚，直接执行下一步。',
  'chat.designToolbox.prompt.autoMatchStep4': '4. 按“诊断 -> 风格方向 -> 资源选择 -> 具体改动/生成 -> 验证”的顺序走完全程。每一步说明为什么选这些资源，以及下一步需要我确认什么。',
  'chat.designToolbox.prompt.motion': '请基于当前 HTML / 页面元素加入高质量动效：入场、滚动、状态切换或微交互任选最有效的 1-2 处。保持克制，优先 transform / opacity，并加 prefers-reduced-motion 兜底。',
  'chat.designToolbox.prompt.motionPolish': '请审查并润色现有动效的节奏、缓动、性能和可访问性。修掉突兀、廉价或影响阅读的动画；必要时改成更细腻的时间线。',
  'chat.designToolbox.prompt.antiAiPolish': '请做一次反 AI 味美化：移除模板化布局、廉价渐变/光晕、无意义卡片堆叠和空泛文案；保持信息不丢失，直接改到更像真实设计师交付。',
  'chat.designToolbox.prompt.visualPolish': '请把这个设计打磨到可交付：检查视觉层级、排版、间距、响应式、按钮状态、空/加载/错误状态和可访问性，并直接完成最重要的修正。',
  'chat.designToolbox.prompt.imageGen': '请为当前设计生成下一步视觉资产方案：可以是分区参考图、hero 素材、插画、icon、社媒图或 moodboard。先判断最缺哪类图，再给可执行的生成 prompt / 文件计划。',
  'chat.designToolbox.prompt.videoGen': '请把当前设计转成视频方向：生成短视频分镜、Hyperframes / Remotion 帧结构或 Sora/fal 可用 prompt。优先让现有 HTML / 页面内容自然变成镜头。',
  'chat.designToolbox.prompt.useSkill': '使用 {skill} 处理当前设计。',
  'chat.designToolbox.prompt.skillInstruction': '请先判断最合适的加工目标，再直接完成一轮具体改动；如果它依赖外部素材或 API，请给出可运行的替代方案或明确需要我补充什么。',
  'chat.designToolbox.prompt.selectedResource': '已选资源：{kind} · {title}（{id}）。',
  'chat.designToolbox.prompt.resourceDescription': '资源说明：{description}',
  'chat.designToolbox.prompt.pluginResource': '请把这个 plugin 当作当前设计流程的主要上下文。如果它暴露输入项或 GenUI，请在需要时引导我选择；如果不适合当前目标，请改选更合适的全局资源并说明原因。',
  'chat.designToolbox.prompt.mcpResource': '请优先使用这个 MCP 能力完成当前设计下一步。需要外部素材、网页截图、图像/视频生成或数据时，先判断它能否完成，再给出可执行计划。',
  'chat.designToolbox.prompt.mcpTemplateResource': '这个 MCP 是可配置模板。如果它是完成当前设计最需要的工具，请先引导我完成配置；如果已有替代资源可用，请先用替代资源继续。',
  'chat.designToolbox.prompt.connectorResource': '请在需要真实数据、素材、账号内容或外部工作流时使用这个 connector；使用前先说明会读取/写入什么，必要时让我确认。',
  'chat.designToolbox.prompt.fileResource': '请把这个 design file 作为当前设计对象或参考资产，基于它完成下一步加工；如果需要同时比较其他文件，请从全量 design files 中继续搜索。',
  'chat.designToolbox.prompt.resourceIndex': '全局资源索引：skills({skills})、plugins({plugins})、MCP({mcpEnabled} enabled / {mcpTemplates} templates)、connectors({connectors} connected)、design files({files})。',
  'chat.designToolbox.prompt.searchableSkills': '可搜索 skills',
  'chat.designToolbox.prompt.searchablePlugins': '可搜索 plugins',
  'chat.designToolbox.prompt.availableMcp': '可用 MCP',
  'chat.designToolbox.prompt.connectedConnectors': '已连接 connectors',
  'chat.designToolbox.prompt.referenceDesignFiles': '可参考 design files',
  'chat.designToolbox.prompt.mcpTemplateName': '{name} template',
  'chat.designToolbox.prompt.processRule': '流程规则：先定义审美目标和约束，再搜索/匹配资源；需要用户选择时生成有限选项 UI，引导确认后继续执行。',
  'chat.designToolbox.prompt.moreSuffix': '，+{count} more',
  'chat.designToolbox.prompt.compactLine': '{label}：{values}{suffix}。',
  'chat.mentionTabsAria': '提及来源',
  'chat.mentionTabAll': '全部',
  'chat.mentionTabTabs': '标签页',
  'chat.mentionTabPlugins': '插件',
  'chat.mentionTabSkills': '技能',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': '连接器',
  'chat.mentionTabFiles': '设计文件',
  'chat.mentionNoResults': '没有找到“{query}”的结果。',
  'chat.mentionSearchPrompt': '搜索设计文件、标签页、插件、技能、MCP 服务器和连接器。',
  'chat.mentionSectionTabs': '标签页',
  'chat.mentionSectionPlugins': '插件',
  'chat.mentionSectionSkills': '技能',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': '连接器',
  'chat.mentionSectionFiles': '设计文件',
  'chat.mentionActiveSkill': '已启用',
  'chat.mentionUseMcpTitle': '使用 {name}',
  'chat.mentionUseConnectorTitle': '使用 {name}',
  'chat.mentionPluginOfficial': '官方',
  'chat.mentionPluginMine': '我的插件',
  'chat.linkedFolderRemoveAria': '移除关联文件夹 {path}',
  'chat.linkedFolderNotFound': '文件夹不存在',
  'chat.linkedFolderAlready': '该文件夹已关联',
  'chat.linkedFolderPickError': '无法打开文件夹选择器',
  'chat.queuedHeader': '已排队',
  'chat.queuedToSend': '待发送',
  'chat.queuedEditQueuedTaskAria': '编辑排队任务',
  'chat.queuedSave': '保存',
  'chat.queuedCancel': '取消',
  'chat.queuedReorder': '拖动调整顺序',
  'chat.queuedEdit': '编辑',
  'chat.queuedMore': '个排队',
  'chat.queuedFollowUpFallback': '已排队的后续任务',
  'chat.send': '发送',
  'chat.stop': '停止',
  'chat.removeAria': '移除 {name}',
  'chat.example1Title': '编辑风路演 PPT',
  'chat.example1Tag': '杂志',
  'chat.example1Prompt': '为一家正在融种子轮的设计工作室制作 10 张编辑风路演 PPT —— 瑞士网格布局，超大号衬线标题加粗体首字下沉，等宽字体的章节编号，留白充足，整页大图与文字密集页穿插出现。封面、愿景、市场、产品、增长、团队、融资诉求、联系方式。',
  'chat.example2Title': 'SaaS 分析仪表盘',
  'chat.example2Tag': '数据',
  'chat.example2Prompt': '为一款面向开发者的 SaaS 设计一份信息密度高的分析仪表盘 —— 顶部 KPI 条带（含周环比变化）、两张堆叠折线图（MRR 与活跃工作区）、全球使用热力图、留存矩阵、客户排行榜以及实时事件流。深色主题，等宽数字，迷你图作为点缀。',
  'chat.example3Title': '长滚动年度报告',
  'chat.example3Tag': '编辑',
  'chat.example3Prompt': '为一家关注气候议题的非营利机构制作互动式年度报告 —— 长滚动编辑式布局，混合大段引言区块、数据可视化（堆叠柱状图、动态计数器、项目地点分布的等值线地图）、摄影分隔页、捐赠者墙，以及最终行动号召。现代衬线正文、无衬线图表标签、大地纸张配色。',
  'preview.usePlugin': '使用插件',
  'preview.usePluginOnly': '仅使用插件',
  'preview.usePluginOnlyDesc': '套用插件结构,内容自己写',
  'preview.replicateContent': '复刻此内容',
  'preview.replicateContentDesc': '使用示例提示词,生成与预览相同的内容',
  'preview.shareMenu': '分享',
  'preview.exportMenu': '导出',
  'preview.shareTemplateBadge': '模板',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': '复制模板链接',
  'preview.copyShareText': '复制分享文案',
  'preview.shareSocialGroup': '分享到社媒',
  'preview.shareCopyGroup': '复制',
  'preview.shareExportGroup': '导出文件',
  'preview.shareCopied': '已复制',
  'preview.shareCopyFailed': '复制失败',
  'preview.shareTextDefault': 'Open Design 模板：{title}',
  'preview.openInNewTab': '在新标签页中打开',
  'preview.exit': '⤓ 退出',
  'preview.fullscreen': '⤢ 全屏',
  'preview.closeTitle': '关闭（Esc）',
  'preview.loading': '正在加载{label}…',
  'preview.errorTitle': '无法加载此示例。',
  'preview.errorBody': '示例 HTML 加载失败。请确认 Open Design 正在运行后重试。',
  'preview.retry': '重试',
  'preview.unavailableTitle': '{noun}暂未附带预览样例。',
  'preview.unavailableBody': '请在对话中运行此 Prompt 来生成 {kind} 产物。',
  'preview.nounSkill': '此技能',
  'preview.nounPlugin': '此插件',
  'preview.nounTemplate': '此模板',
  'preview.showSidebar': '展开{label}',
  'preview.hideSidebar': '收起{label}',
  'misc.savedTemplate': '已保存的模板',
  'misc.primary': '主体系',
  'misc.designSystem': '设计体系',
  'workspace.designFiles': '设计文件',
  'workspace.focusMode': '专注工作区',
  'workspace.showChat': '显示聊天',
  'workspace.closeTab': '关闭标签页',
  'workspace.deleteFileConfirm': '从项目文件夹中删除「{name}」？',
  'workspace.deleteSelectedFilesConfirm': '从项目文件夹中删除选中的 {n} 个文件？',
  'workspace.deleteSelectedFilesPartial': '有 {n} 个文件删除失败。',
  'workspace.openFromDesignFiles': '请从',
  'workspace.designFilesLink': '设计文件',
  'workspace.loadingSketch': '正在加载草图…',
  'workspace.newTab': '新建标签页',
  'workspace.searchFilesPlaceholder': '搜索标签页或文件…',
  'workspace.openTabs': '打开标签页',
  'workspace.openFile': '打开文件',
  'workspace.noFilesMatch': '没有匹配的文件',
  'workspace.allFiles': '全部',
  'workspace.createNew': '新建',
  'workspace.tabOpen': '已打开',
  'workspace.sideChatContextBanner': '已集成当前会话上下文',
  'workspace.sideChatDefaultTitle': '侧边对话',
  'workspace.newTerminal': '新建终端',
  'workspace.newTerminalDescription': '在新标签页中打开项目目录的终端',
  'workspace.newBrowser': '新建浏览器',
  'workspace.newBrowserDescription': '在新标签页中打开内置浏览器，用于参考站点和设计研究',
  'workspace.terminalStarting': '正在启动项目终端…',
  'workspace.terminalStartingDescription': '正在连接项目目录，通常只需几秒。',
  'workspace.terminalSessionEnded': '会话已结束',
  'workspace.terminalReconnecting': '正在重新连接…',
  'workspace.terminalStartFailed': '无法启动终端会话',
  'workspace.terminalRestart': '重新启动',
  'designFiles.title': '设计文件',
  'designFiles.upload': '上传文件',
  'designFiles.pasteText': '粘贴为文本文件',
  'designFiles.newSketch': '新建草图',
  'designFiles.empty': '生成的设计会出现在这里',
  'designFiles.refresh': '刷新',
  'designFiles.delete': '删除',
  'designFiles.searchPlaceholder': '搜索文件…',
  'designFiles.up': '上一级',
  'designFiles.back': '返回',
  'designFiles.crumbs': '项目',
  'designFiles.rowMenu': '行菜单',
  'designFiles.openInTab': '在标签页中打开',
  'designFiles.download': '下载',
  'designFiles.downloadSelected': '下载选中的 {n} 个文件为 ZIP',
  'designFiles.deleteSelected': '删除 {n} 个',
  'designFiles.clearSelection': '取消选择',
  'designFiles.selectPage': '全选此页',
  'designFiles.selectAll': '全选',
  'designFiles.dropTitle': '⤓ 把文件拖到这里',
  'designFiles.dropDesc': '图片、文档、参考资料或文件夹 — 智能体都会用作上下文。',
  'designFiles.dropLabel': '拖拽文件到这里',
  'designFiles.upload.title': '上传文件',
  'designFiles.paste.title': '将文本粘贴为文件',
  'designFiles.upload.label': '上传',
  'designFiles.paste.label': '粘贴',
  'designFiles.previewOpen': '打开',
  'designFiles.previewClose': '关闭预览',
  'designFiles.modified': '修改于 {time} · {size}',
  'designFiles.weeksAgo': '{n} 周前',
  'designFiles.groupBy': '分组方式',
  'designFiles.groupByKind': '类型',
  'designFiles.groupByModified': '修改时间',
  'designFiles.filterBy': '按类型筛选',
  'designFiles.filterClear': '清除',
  'designFiles.filterCount': '{n} 种类型',
  'designFiles.expandGroup': '展开',
  'designFiles.collapseGroup': '折叠',
  'designFiles.sectionPages': '页面',
  'designFiles.sectionScripts': '脚本',
  'designFiles.sectionImages': '图片',
  'designFiles.sectionSketches': '草图',
  'designFiles.sectionLiveArtifacts': '实时看板',
  'designFiles.sectionOther': '其它',
  'designFiles.modifiedToday': '今天',
  'designFiles.modifiedYesterday': '昨天',
  'designFiles.modifiedPrevious7Days': '最近 7 天',
  'designFiles.modifiedPrevious30Days': '最近 30 天',
  'designFiles.modifiedOlder': '更早',
  'designFiles.showMore': '再显示 {n} 个',
  'designFiles.kindHtml': 'HTML 页面',
  'designFiles.kindImage': '图片',
  'designFiles.kindSketch': '草图',
  'designFiles.kindText': '文本',
  'designFiles.kindCode': '脚本',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': '文档',
  'designFiles.kindPresentation': '演示文稿',
  'designFiles.kindSpreadsheet': '电子表格',
  'designFiles.kindLiveArtifact': '实时看板',
  'designFiles.kindBinary': '二进制',
  'designFiles.kindFolder': '文件夹',
  'designFiles.folderCount': '{n} 个文件',
  'designFiles.newFolderTitle': '新建文件夹',
  'designFiles.newFolderLabel': '文件夹名称',
  'designFiles.moveTitle': '移动到文件夹',
  'designFiles.moveLabel': '目标文件夹',
  'designFiles.moveRoot': '项目根目录',
  'designFiles.moveNewFolder': '新建文件夹…',
  'designFiles.move': '移动',
  'designFiles.copyPath': '复制文件地址',
  'designFiles.copiedPath': '已复制路径',
  'designFiles.deleteFolderConfirm': '删除文件夹「{name}」及其全部内容?',
  'designFiles.folderCreated': '已创建文件夹「{name}」',
  'designFiles.folderDeleted': '已删除文件夹「{name}」',
  'designFiles.filesMoved': '已移动 {n} 项到 {dest}',
  'designFiles.colName': '名称',
  'designFiles.colKind': '类型',
  'designFiles.colModified': '修改时间',
  'designFiles.perPage': '显示',
  'designFiles.all': '全部',
  'designFiles.prev': '上一页',
  'designFiles.next': '下一页',
  'designFiles.jumpToPage': '跳转到页面',
  'designFiles.pageInfo': '{start}–{end} / {total}',
  'designFiles.sectionFolders': '文件夹',
  'designFiles.sectionStylesheets': '样式表',
  'designFiles.sectionDocuments': '文档',
  'designFiles.kindStylesheet': '样式表',
  'designFiles.modifiedExt': '修改于 {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': '使用提示',
  'designFiles.usefulInfoTip': '双击任意文件可在独立标签页中打开。',
  'designFiles.usefulInfoTip2': '在聊天中输入 @ 即可把文件引用为上下文。',
  'designFiles.usefulInfoTip4': '选好设计系统再生成，结果会与品牌风格保持一致。',
  'designFiles.usefulInfoTip5': '没有想法？试试首页 Community 的插件模板，一键生成同款。',
  'designFiles.usefulInfoTip6': '遇到问题或有建议？加入 Discord 和我们聊聊。',
  'designFiles.usefulInfoTip7': '觉得好用？在 GitHub 给我们点个 Star。',
  'designFiles.usefulInfoTip8': '在 X 上关注 @nexudotio，第一时间了解新功能。',
  'designFiles.usefulInfoTip9': '把图片、文档甚至整个文件夹拖到当前面板，智能体都会用作上下文。',
  'designFiles.usefulInfoTip10': '点「新建草图」手绘一个布局，让智能体照着生成。',
  'designFiles.usefulInfoTip11': '在预览中圈选任意元素发表评论，智能体会针对性修改。',
  'designFiles.usefulInfoTip12': '生成结果不满意？直接圈选标注比重新描述更快。',
  'designFiles.usefulInfoTip13': '设计可以一键导出为 PDF、图片或独立 HTML。',
  'designFiles.usefulInfoTip14': '满意的项目可通过「分享」菜单保存为模板，下次直接复用。',
  'designFiles.usefulInfoTip15': '部署后可以直接生成社媒分享卡片。',
  'quickSwitcher.placeholder': '打开标签页或文件…',
  'quickSwitcher.empty': '此项目中没有文件',
  'quickSwitcher.noMatches': '无匹配项',
  'quickSwitcher.navigate': '导航',
  'quickSwitcher.open': '打开',
  'quickSwitcher.close': '关闭',
  'pasteDialog.title': '粘贴文本',
  'pasteDialog.hint': '将保存到项目文件夹中，名称随你定。',
  'pasteDialog.fileNameLabel': '文件名',
  'pasteDialog.namePlaceholder': 'notes.txt',
  'pasteDialog.contentLabel': '内容',
  'pasteDialog.contentPlaceholder': '在此粘贴任何内容…',
  'pasteDialog.save': '保存',
  'pasteDialog.cancel': '取消',
  'sketch.save': '保存草图',
  'sketch.cancel': '取消',
  'sketch.saving': '保存中…',
  'sketch.saved': '已保存',
  'sketch.tooltipDirty': '尚未保存',
  'sketch.tooltipClean': '已保存',
  'fileViewer.empty': '请选择一个文件查看。',
  'fileViewer.loading': '加载中…',
  'fileViewer.exportPptx': '导出为 PPTX',
  'fileViewer.openInNewTab': '在新标签页中打开',
  'fileViewer.copyPath': '复制路径',
  'fileViewer.copied': '已复制！',
  'fileViewer.share': '分享',
  'fileViewer.binaryMeta': '二进制 · {size}',
  'fileViewer.binaryNote': '二进制文件（{size} 字节）。请下载或在本地打开查看。',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': '文档',
  'fileViewer.presentationMeta': '演示文稿',
  'fileViewer.spreadsheetMeta': '电子表格',
  'fileViewer.previewUnavailable': '无法生成预览，请下载或打开文件查看。',
  'fileViewer.download': '下载',
  'fileViewer.open': '打开',
  'fileViewer.imageMeta': '图片 · {size}',
  'fileViewer.reactMeta': 'React 组件 · {size}',
  'fileViewer.sketchMeta': '草图 · {size}',
  'fileViewer.markdownStreamingMeta': '正在流式预览…',
  'fileViewer.markdownErrorMeta': '预览可能不完整（生成错误）。',
  'fileViewer.markdownStreamingStatus': '正在流式生成…显示部分 Markdown。',
  'fileViewer.markdownErrorStatus': '生成错误。正在显示最后可用内容。',
  'fileViewer.videoMeta': '视频 · {size}',
  'fileViewer.audioMeta': '音频 · {size}',
  'fileViewer.reload': '重新加载',
  'fileViewer.reloadDisk': '从磁盘重新加载',
  'fileViewer.copy': '复制',
  'fileViewer.copyTitle': '复制文件内容',
  'fileViewer.saveDisabled': '保存（只读预览）',
  'fileViewer.save': '保存',
  'fileViewer.preview': '预览',
  'fileViewer.source': '代码',
  'fileViewer.tweaks': '调整',
  'fileViewer.tweaksUnavailable': '此作品中没有调整面板',
  'fileViewer.jsxModuleTitle': '无独立预览',
  'fileViewer.jsxModuleBody': '此文件是由其他页面加载的组件模块。',
  'fileViewer.jsxModuleCta': '请打开渲染它的页面：',
  'fileViewer.comment': '注释',
  'fileViewer.edit': '编辑',
  'fileViewer.draw': '绘制',
  'fileViewer.mark': '标记',
  'fileViewer.markTool': '标记工具',
  'fileViewer.boxSelect': '框选',
  'fileViewer.screenshot': '截图',
  'manualEdit.layers': '图层',
  'manualEdit.editableCount': '{count} 个可编辑元素',
  'manualEdit.hiddenBadge': '隐藏',
  'manualEdit.title': '手动编辑器',
  'manualEdit.fallbackTitle': '编辑',
  'manualEdit.movePanel': '移动编辑面板',
  'manualEdit.editParams': '编辑参数',
  'manualEdit.closePanel': '关闭编辑面板',
  'manualEdit.selectLayer': '选择图层',
  'manualEdit.empty': '在预览中点击元素,或选择一个图层。',
  'manualEdit.noEditableLayers': '未找到可编辑图层。',
  'manualEdit.noClass': '无类名',
  'manualEdit.tabsAria': '手动编辑选项卡',
  'manualEdit.tabContent': '内容',
  'manualEdit.tabStyle': '样式',
  'manualEdit.tabAttributes': '属性',
  'manualEdit.tabHtml': 'HTML',
  'manualEdit.tabSource': '源码',
  'manualEdit.attributesJson': '属性 JSON',
  'manualEdit.selectedHtml': '选中元素的 HTML',
  'manualEdit.fullSource': '完整作品源码',
  'manualEdit.applyContent': '应用内容',
  'manualEdit.applyStyle': '应用样式',
  'manualEdit.applyAttributes': '应用属性',
  'manualEdit.applyHtml': '应用 HTML',
  'manualEdit.applySource': '应用源码',
  'manualEdit.invalidAttributes': '属性 JSON 格式无效。',
  'manualEdit.changes': '修改记录',
  'manualEdit.undo': '撤销',
  'manualEdit.redo': '重做',
  'manualEdit.noChanges': '尚未进行手动修改。',
  'manualEdit.imageUrl': '图片 URL',
  'manualEdit.altText': '替代文本',
  'manualEdit.label': '标签',
  'manualEdit.text': '文本',
  'manualEdit.href': '链接地址',
  'manualEdit.textColor': '文本颜色',
  'manualEdit.background': '背景',
  'manualEdit.fontSize': '字号',
  'manualEdit.weight': '字重',
  'manualEdit.align': '对齐方式',
  'manualEdit.padding': '内边距',
  'manualEdit.margin': '外边距',
  'manualEdit.radius': '圆角',
  'manualEdit.border': '边框',
  'manualEdit.width': '宽度',
  'manualEdit.minHeight': '最小高度',
  'manualEdit.deleteElement': '删除元素',
  'manualEdit.deleteElementConfirm': '删除选中元素？可以使用撤销恢复。',
  'manualEdit.uploadImage': '上传图片',
  'manualEdit.uploadingImage': '正在上传图片…',
  'manualEdit.uploadImageFailed': '无法上传图片。',
  'manualEdit.focusSlides': '聚焦幻灯片',
  'manualEdit.showPanels': '显示面板',
  'fileViewer.zoomOut': '缩小',
  'fileViewer.zoomIn': '放大',
  'fileViewer.resetZoom': '重置缩放',
  'fileViewer.viewportAria': '预览视口',
  'fileViewer.viewportDesktop': '桌面端',
  'fileViewer.viewportDesktopTitle': '全宽桌面预览',
  'fileViewer.viewportTablet': '平板端',
  'fileViewer.viewportTabletTitle': '平板预览 820 × 1180(现代竖屏基线)',
  'fileViewer.viewportMobile': '移动端',
  'fileViewer.viewportMobileTitle': '移动端预览 390 × 844',
  'fileViewer.reloadAria': '重新加载',
  'fileViewer.previousSlide': '上一张',
  'fileViewer.nextSlide': '下一张',
  'fileViewer.slideNavAria': '幻灯片导航',
  'fileViewer.present': '演示',
  'fileViewer.presentInTab': '在当前标签页',
  'fileViewer.presentFullscreen': '全屏',
  'fileViewer.presentNewTab': '新标签页',
  'fileViewer.exitPresentation': '退出演示',
  'fileViewer.shareLabel': '分享',
  'fileViewer.shareMenuShareLink': '分享',
  'fileViewer.shareMenuPublishOnline': '发布到线上',
  'fileViewer.shareMenuDownload': '下载',
  'fileViewer.shareMenuPresentation': '演示文稿',
  'fileViewer.shareMenuSourceFiles': '源文件',
  'fileViewer.shareMenuSave': '保存',
  'fileViewer.copyShareLink': '复制分享链接',
  'fileViewer.openSharePage': '打开分享页面',
  'fileViewer.shareLinkRequiresDeploy': '先发布到线上以获取链接',
  'fileViewer.shareLinkPublishGuide': '先发布线上，即可分享 ↑',
  'fileViewer.shareAfterGenerationComplete': '生成完成后可分享',
  'fileViewer.copyProviderLink': '复制 {provider} 链接',
  'fileViewer.copyCloudflareLink': '复制 Cloudflare 链接',
  'fileViewer.screenshotCopying': '正在复制截图…',
  'fileViewer.screenshotCopied': '截图已保存到剪贴板',
  'fileViewer.screenshotClipboardDenied': '浏览器拒绝写入剪贴板',
  'fileViewer.screenshotPreviewLoading': '预览还在加载，请稍后再试',
  'fileViewer.screenshotCaptureFailed': '无法截取预览，请重试',
  'fileViewer.exportPdf': '导出为 PDF',
  'fileViewer.exportPdfAllSlides': '导出为 PDF（全部幻灯片）',
  'fileViewer.exportPptxBusy': '请等待当前任务完成。',
  'fileViewer.exportPptxHint': '请求代理将此设计转换为 PPTX。',
  'fileViewer.exportPptxNa': '此处暂不支持导出 PPTX。',
  'fileViewer.exportZip': '下载为 .zip',
  'fileViewer.exportHtml': '导出为独立 HTML',
  'fileViewer.exportMd': '导出为 Markdown',
  'fileViewer.exportImage': '导出为图片',
  'fileViewer.exportImageFailed': '图片捕获失败，请重试或使用浏览器的截图工具。',
  'fileViewer.exportImageModalSubtitle': '选择图片格式后，将当前预览下载为图片。',
  'fileViewer.exportImageFormatLabel': '格式',
  'fileViewer.exportImageSaving': '正在保存图片…',
  'fileViewer.exportImageSaved': '图片已保存',
  'fileViewer.exportImageDownloadStarted': '已开始下载',
  'fileViewer.exportImageDownloadDetails': '如果没有弹出保存窗口，请在浏览器下载目录中查看 {filename}。',
  'fileViewer.exportJsx': '导出为 JSX',
  'fileViewer.exportReactHtml': '导出预览 HTML',
  'fileViewer.exportStarted': '已开始导出',
  'fileViewer.saveAsTemplate': '保存为模板…',
  'fileViewer.savingTemplate': '正在保存模板…',
  'fileViewer.savedTemplate': '已保存为「{name}」',
  'fileViewer.savedTemplateFail': '保存模板失败，请重试。',
  'fileViewer.templateNamePrompt': '模板名称',
  'fileViewer.templateNameDefault': '未命名模板',
  'fileViewer.templateDescPrompt': '简短描述（可选 — 这个模板用于什么场景？）',
  'liveArtifact.refresh.button': '刷新',
  'liveArtifact.refresh.buttonTitle': '刷新此实时看板',
  'liveArtifact.refresh.loadingTitle': '正在加载实时看板…',
  'liveArtifact.refresh.noSourceTitle': '暂无可刷新来源。',
  'liveArtifact.refresh.running': '刷新中…',
  'liveArtifact.refresh.runningMessage': '正在刷新数据和预览，可能需要一点时间。',
  'liveArtifact.refresh.runningAction': '刷新成功前会继续显示上一次预览。',
  'liveArtifact.refresh.successOne': '刷新完成，数据已更新。',
  'liveArtifact.refresh.successMany': '刷新完成，数据已更新。',
  'liveArtifact.refresh.successAction': '预览已使用最新提交的数据重新加载。',
  'liveArtifact.refresh.previousFailure': '上次刷新失败：{message}',
  'liveArtifact.refresh.failureAction': '请检查「刷新历史」，修复来源或权限问题后重试。',
  'liveArtifact.refresh.networkFailure': '刷新请求失败。请检查网络连接后重试。',
  'liveArtifact.refresh.genericFailure': '刷新失败。',
  'liveArtifact.refresh.statusNever': '不可刷新',
  'liveArtifact.refresh.statusReady': '可刷新',
  'liveArtifact.refresh.statusSucceeded': '已是最新',
  'liveArtifact.refresh.statusFailed': '刷新失败',
  'liveArtifact.refresh.statusRunning': '正在刷新',
  'liveArtifact.refresh.statusRunningDescription': '刷新任务正在进行中。',
  'liveArtifact.refresh.statusSucceededDescription': '上次刷新已成功完成。',
  'liveArtifact.refresh.statusFailedDescription': '上次刷新未能成功完成。',
  'liveArtifact.refresh.statusReadyDescription': '已配置可刷新的数据源，但暂无正在进行的任务。',
  'liveArtifact.refresh.statusNeverDescription': '该实时看板尚未配置刷新数据源。',
  'liveArtifact.refresh.eventStarted': '已开始',
  'liveArtifact.refresh.eventSucceeded': '已成功',
  'liveArtifact.refresh.eventFailed': '失败',
  'liveArtifact.refresh.eventStartedDetail': '刷新已开始…',
  'liveArtifact.refresh.sourcesUpdatedOne': '已更新 {n} 个数据源',
  'liveArtifact.refresh.sourcesUpdatedMany': '已更新 {n} 个数据源',
  'liveArtifact.refresh.timelineEmpty': '本次会话还没有刷新记录。点击「刷新」即可记录时间线，或等待自动任务完成。',
  'liveArtifact.refresh.heroLastRefreshedLabel': '上次刷新',
  'liveArtifact.refresh.heroLastRefreshedNever': '从未',
  'liveArtifact.refresh.justNow': '刚刚',
  'liveArtifact.refresh.factCreated': '创建时间',
  'liveArtifact.refresh.factLastUpdated': '最后更新',
  'liveArtifact.refresh.factUnknown': '未知',
  'liveArtifact.refresh.persistedTitle': '持久化刷新记录',
  'liveArtifact.refresh.persistedHint': '来自 refreshes.jsonl 的条目',
  'liveArtifact.refresh.persistedEmpty': '尚无持久化的刷新记录。',
  'liveArtifact.refresh.persistedStatusSucceeded': '成功',
  'liveArtifact.refresh.persistedStatusRunning': '进行中',
  'liveArtifact.refresh.persistedStatusFailed': '失败',
  'liveArtifact.refresh.persistedStatusCancelled': '已取消',
  'liveArtifact.refresh.persistedStatusSkipped': '已跳过',
  'liveArtifact.refresh.sessionTitle': '会话活动',
  'liveArtifact.refresh.sessionHint': '本标签页打开期间观察到的事件',
  'liveArtifact.refresh.docSourceTitle': '文档来源',
  'liveArtifact.refresh.docSourceHint': '已配置的数据源',
  'liveArtifact.refresh.docSourceType': '类型',
  'liveArtifact.refresh.docSourceTool': '工具',
  'liveArtifact.refresh.docSourceConnector': '连接器',
  'liveArtifact.refresh.debugSummary': '高级调试元数据',
  'liveArtifact.refresh.debugNote': '可能包含连接器 ID、文件名、来源元数据以及内部 artifact 路径。',
  'liveArtifact.viewer.tabPreview': '预览',
  'liveArtifact.viewer.tabCode': '代码',
  'liveArtifact.viewer.tabData': '数据',
  'liveArtifact.viewer.tabRefreshHistory': '刷新历史',
  'liveArtifact.viewer.dataEmpty': '没有可用的 data.json 缓存。',
  'liveArtifact.viewer.code.templateHeading': '模板 HTML',
  'liveArtifact.viewer.code.renderedHeading': '渲染后 HTML',
  'liveArtifact.viewer.code.templateHelp': '用于配合 data.json 生成预览的可编辑模板。',
  'liveArtifact.viewer.code.renderedHelp': 'Preview 当前加载的已生成 index.html。',
  'liveArtifact.viewer.code.variantAria': '代码版本',
  'liveArtifact.viewer.code.variantTemplate': '模板',
  'liveArtifact.viewer.code.variantRendered': '已渲染',
  'liveArtifact.viewer.code.loading': '正在加载代码…',
  'liveArtifact.viewer.code.unavailable': '代码尚不可用。',
  'liveArtifact.viewer.code.empty': '此代码文件为空。',
  'fileViewer.deployToVercel': '部署到 Vercel',
  'fileViewer.redeployToVercel': '重新部署',
  'fileViewer.deployingToVercel': '正在部署到 Vercel…',
  'fileViewer.deployProviderLabel': '部署平台',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployToProvider': '部署到 {provider}',
  'fileViewer.redeployToProvider': '重新部署到 {provider}',
  'fileViewer.deployingToProvider': '正在部署到 {provider}…',
  'fileViewer.preparingPublicLink': '正在准备公开链接…',
  'fileViewer.copyDeployLink': '复制链接',
  'fileViewer.deployModalTitle': '部署',
  'fileViewer.deployModalSubtitle': '使用所选平台账号部署当前 HTML 预览。',
  'fileViewer.vercelToken': 'Vercel 令牌',
  'fileViewer.vercelTokenGetLink': '获取 Vercel token',
  'fileViewer.vercelTokenPlaceholder': '粘贴你的 Vercel token',
  'fileViewer.vercelTokenReuseHint': '将使用已保存的令牌。输入新令牌可替换。',
  'fileViewer.vercelTokenRequired': '请先输入并保存 Vercel 令牌。',
  'fileViewer.cloudflareApiToken': 'Cloudflare API 令牌',
  'fileViewer.cloudflareApiTokenGetLink': '获取 API token',
  'fileViewer.cloudflareApiTokenPlaceholder': '粘贴你的 Cloudflare API 令牌',
  'fileViewer.cloudflareApiTokenReuseHint': '将使用已保存的 Cloudflare API 令牌。输入新令牌可替换。',
  'fileViewer.cloudflareApiTokenRequired': '请先输入并保存 Cloudflare API 令牌。',
  'fileViewer.cloudflareApiTokenScopeHint': '创建 API token 时勾选 Pages Edit；自定义域名需 Zone Read / DNS Edit。',
  'fileViewer.vercelTeamId': '团队 ID',
  'fileViewer.vercelTeamSlug': '团队标识',
  'fileViewer.cloudflareAccountId': '账户 ID',
  'fileViewer.cloudflareAccountIdHint': '可在 Cloudflare 控制台中找到账户 ID。',
  'fileViewer.cloudflareAccountIdRequired': '请先输入并保存 Cloudflare 账户 ID。',
  'fileViewer.cloudflareZoneLabel': '域名',
  'fileViewer.cloudflareZonePlaceholder': '保存 Cloudflare 设置后加载域名',
  'fileViewer.cloudflareZoneRequired': '请先选择一个 Cloudflare 域名。',
  'fileViewer.cloudflareZonesLoading': '正在加载 Cloudflare 域名…',
  'fileViewer.cloudflareZonesRefresh': '刷新域名',
  'fileViewer.cloudflareZonesLoadFailed': '无法加载 Cloudflare 域名。',
  'fileViewer.cloudflareZonesEmpty': '此账号下未找到活跃的完整 Cloudflare 域名。',
  'fileViewer.cloudflareDomainPrefixLabel': '子域名前缀',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': '请仅使用单个 DNS 标签:小写字母、数字和连字符。',
  'fileViewer.cloudflareHostnamePreview': '自定义域名预览:{hostname}',
  'fileViewer.cloudflareCustomDomainHint': '可选：绑定自定义域名。不填也会生成 pages.dev 链接。',
  'fileViewer.cloudflarePagesDevLinkLabel': 'pages.dev URL',
  'fileViewer.cloudflareCustomDomainLinkLabel': '自定义域名',
  'fileViewer.optional': '可选',
  'fileViewer.vercelPreviewOnly': '当前仅部署 Preview。',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages 使用 Direct Upload。',
  'fileViewer.savingConfig': '保存中…',
  'fileViewer.deployConfigSaveFailed': '保存 Vercel 设置失败。',
  'fileViewer.deployFailed': '部署失败，请检查 Vercel 设置后重试。',
  'fileViewer.deployProviderConfigSaveFailed': '无法保存 {provider} 设置。',
  'fileViewer.deployProviderFailed': '{provider} 部署失败。请检查设置后重试。',
  'fileViewer.deployResultLabel': '部署链接',
  'fileViewer.deployLinkReady': '已就绪',
  'fileViewer.deploySuccessToast': '部署已成功上传',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': '公开链接准备中',
  'fileViewer.deployLinkDelayed': '站点已经部署，平台仍在准备公开链接。',
  'fileViewer.deployLinkFailed': '自定义域名失败',
  'fileViewer.deployLinkProtectedLabel': '部署访问保护已开启',
  'fileViewer.deployLinkProtected': '站点已部署，但此预览链接要求登录后才能访问。请关闭 Deployment Protection 或使用自定义域名。',
  'fileViewer.retryLink': '立即重试',
  'questionForm.submit': '提交',
  'questionForm.skip': '跳过',
  'questionForm.locked': '已回答',
  'conv.switch': '切换对话',
  'conv.label': '对话',
  'conv.heading': '对话历史',
  'conv.new': '+ 新建',
  'conv.empty': '还没有对话。',
  'conv.untitled': '未命名对话',
  'conv.renameTooltip': '双击重命名',
  'conv.delete': '删除对话',
  'conv.deleteConfirm': '确定删除「{title}」？该操作会删除其消息。',
  'agentPicker.label': '代理',
  'agentPicker.modeChoose': '选择执行模式',
  'agentPicker.localCli': '本机 CLI',
  'agentPicker.daemonOff': '守护进程未运行',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': '选择已检测到的代码代理 CLI',
  'agentPicker.noAgents': 'PATH 中未发现代理',
  'agentPicker.notInstalled': '未安装',
  'agentPicker.rescan': '重新扫描 PATH 中的代理',
  'tool.openInTab': '在标签页中打开 {name}',
  'tool.open': '打开',
  'tool.todos': '待办',
  'tool.todosExpand': '展开任务',
  'tool.todosCollapse': '收起任务',
  'tool.todosDone': '完成',
  'tool.todosDismiss': '关闭任务列表',
  'tool.write': '写入',
  'tool.edit': '编辑',
  'tool.read': '读取',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': '抓取',
  'tool.search': '搜索',
  'tool.lines': '{n} 行',
  'tool.changeSingular': '处变更',
  'tool.changePlural': '处变更',
  'tool.in': '于 {path}',
  'tool.hide': '隐藏',
  'tool.output': '输出',
  'tool.running': '运行中…',
  'tool.error': '错误',
  'tool.done': '完成',
  'assistant.role': '助手',
  'assistant.workingLabel': '执行中',
  'assistant.doneLabel': '已完成',
  'assistant.copyMarkdown': '复制回复 Markdown',
  'assistant.forkConversation': '从这里分叉',
  'assistant.forkingConversation': '正在分叉…',
  'assistant.shareToOpenDesign': '分享到 Open Design',
  'assistant.shareToOpenDesignBusy': '正在准备投稿…',
  'assistant.feedbackPrompt': '反馈',
  'assistant.feedbackPositive': '有帮助',
  'assistant.feedbackNegative': '没有帮助',
  'assistant.feedbackReasonTitle': '选择原因',
  'assistant.feedbackReasonPositiveMatched': '理解了我的需求',
  'assistant.feedbackReasonPositiveVisual': '视觉效果满意',
  'assistant.feedbackReasonPositiveUseful': '结构有帮助',
  'assistant.feedbackReasonPositiveEasy': '方便继续修改',
  'assistant.feedbackReasonPositiveDesignSystem': '严格按照设计系统生成',
  'assistant.feedbackReasonNegativeMissed': '没有理解需求',
  'assistant.feedbackReasonNegativeVisual': '视觉效果不理想',
  'assistant.feedbackReasonNegativeIncomplete': '产物不完整',
  'assistant.feedbackReasonNegativeHard': '不方便使用',
  'assistant.feedbackReasonNegativeDesignSystem': '没有严格按照设计系统生成',
  'assistant.feedbackReasonOther': '其他',
  'assistant.feedbackReasonPlaceholder': '补充说明...',
  'assistant.feedbackReasonSubmit': '提交',
  'assistant.emptyResponseLabel': '无输出',
  'assistant.emptyResponseMessage': '服务商结束了请求，但没有返回文本或设计产物。请尝试更换模型或服务商、检查额度，或重试。',
  'assistant.unfinishedLabel': '已停止，仍有未完成任务',
  'assistant.unfinishedSummary': '剩余 {n} 个任务',
  'assistant.unfinishedMore': '还有 {n} 个',
  'assistant.continueRemaining': '继续剩余任务',
  'chat.resumeRunCta': '继续运行',
  'assistant.outTokens': '{n} 输出',
  'assistant.producedFiles': '本轮产出的文件',
  'assistant.openFile': '打开',
  'assistant.downloadFile': '下载',
  'nextStep.title': '下一步',
  'nextStep.more': '更多',
  'nextStep.share': '分享',
  'nextStep.download': '下载',
  'nextStep.contribute': '贡献社区',
  'assistant.thinking': '思考中',
  'assistant.thought': '思考完毕',
  'assistant.thoughtFor': '已深度思考（用时 {s} 秒）',
  'assistant.systemReminder': '系统提示',
  'assistant.possiblePromptInjection': '可能的提示词注入',
  'assistant.waitingFirstOutput': '等待首批输出中',
  'assistant.statusBootingAgent': '正在启动代理',
  'assistant.statusPreparing': '准备中…',
  'assistant.statusStarting': '启动中',
  'assistant.statusRequesting': '正在发送请求',
  'assistant.statusThinking': '思考中',
  'assistant.statusStreaming': '流式输出中',
  'assistant.slowHint': '耗时比平时更久。一般 5–10 秒内会出现表单，可以「停止」后重新表述。',
  'assistant.verbEditing': '编辑',
  'assistant.verbWriting': '写入',
  'assistant.verbReading': '读取',
  'assistant.verbSearching': '搜索',
  'assistant.verbRunning': '运行',
  'assistant.verbTodos': '待办',
  'assistant.verbFetching': '抓取',
  'assistant.verbCalling': '调用',
  'qf.answered': '已回答',
  'qf.choose': '请选择…',
  'qf.required': '必填',
  'qf.lockedSubmitted': '答案已发送，代理将在本次会话后续使用。',
  'qf.lockedPrev': '该表单来自此前的对话。',
  'qf.hint': '挑选合适的选项；可选项可以跳过，代理会使用合理的默认值。',
  'qf.submitDefault': '发送答案',
  'qf.submitDisabledTitle': '请先填写必填项',
  'qf.submitTitle': '发送答案',
  'qf.cardSelected': '已选',
  'qf.cardRefs': '参考：',
  'qf.cardSampleText': '飞燕环宇 · 0123',
  'questions.tabLabel': '问题',
  'questions.banner': '想先跟你确认几个小问题～',
  'questions.bannerAnswered': '已回答这些问题',
  'questions.continue': '继续',
  'questions.generating': '正在生成问题…',
  'questions.skipAll': '一键跳过',
  'questions.autoSkipHint': '倒计时结束后将自动继续',
  'sketch.toolSelect': '选择（占位）',
  'sketch.toolPen': '钢笔',
  'sketch.toolText': '文本',
  'sketch.toolRect': '矩形',
  'sketch.toolArrow': '箭头',
  'sketch.toolEraser': '橡皮擦',
  'sketch.color': '颜色',
  'sketch.strokeSize': '描边粗细',
  'sketch.undo': '撤销',
  'sketch.clear': '清空',
  'sketch.close': '关闭',
  'sketch.closeConfirm': '关闭草图并放弃未保存的更改吗？',
  'sketch.textPrompt': '请输入文本：',
  'sketch.textModalTitle': '添加文本',
  'critiqueTheater.userFacingName': '设计评审团',
  'critiqueTheater.roleDesigner': '设计师',
  'critiqueTheater.roleCritic': '评审',
  'critiqueTheater.roleBrand': '品牌',
  'critiqueTheater.roleA11y': '无障碍',
  'critiqueTheater.roleCopy': '文案',
  'critiqueTheater.roundLabel': '第 {n} 轮 / 共 {m} 轮',
  'critiqueTheater.mustFix': '{n} 项必改',
  'critiqueTheater.composite': '综合分',
  'critiqueTheater.threshold': '阈值',
  'critiqueTheater.consensus': '共识',
  'critiqueTheater.interrupt': '中断',
  'critiqueTheater.interrupting': '正在中断…',
  'critiqueTheater.interrupted': '已中断',
  'critiqueTheater.degradedHeading': '本次评审不可用',
  'critiqueTheater.degradedReasonMalformed': '评审块格式错误，解析器已拒绝。',
  'critiqueTheater.degradedReasonOversize': '评审输出超出了安全字节预算。',
  'critiqueTheater.degradedReasonAdapter': '适配器 {adapter} 不支持评审协议。',
  'critiqueTheater.degradedReasonProtocol': '适配器 {adapter} 使用了不支持的协议版本。',
  'critiqueTheater.degradedReasonMissingArtifact': '运行结束但未产出最终产物。',
  'critiqueTheater.replay': '回放',
  'critiqueTheater.replaySpeed': '回放速度',
  'critiqueTheater.readOnly': '只读',
  'critiqueTheater.shippedSummary': '已于第 {round} 轮发布 · 综合分 {composite}',
  'critiqueTheater.interruptedSummary': '已于第 {round} 轮中断 · 最佳综合分 {composite}',
  'critiqueTheater.shippedBadge': '已发布',
  'critiqueTheater.belowThresholdBadge': '低于阈值',
  'critiqueTheater.timedOutBadge': '已超时',
  'critiqueTheater.failedHeading': '运行失败',
  'critiqueTheater.failedReasonCliExit': '智能体 CLI 在评审完成前以非零状态退出。',
  'critiqueTheater.failedReasonPerRoundTimeout': '某一轮超出了时间预算。',
  'critiqueTheater.failedReasonTotalTimeout': '整次运行超出了总时间预算。',
  'critiqueTheater.failedReasonOrchestrator': '编排器内部错误。',
  'critiqueTheater.transcriptEmpty': '暂无可回放的会话记录。运行一次评审即可记录。',
  'critiqueTheater.transcriptLoading': '正在加载会话记录…',
  'critiqueTheater.transcriptError': '无法加载会话记录：{error}',
  'critiqueTheater.replaySpeedPaused': '暂停',
  'critiqueTheater.replaySpeedInstant': '瞬时',
  'critiqueTheater.replaySpeedLive': '实时',
  'critiqueTheater.replaySpeedFast': '快进',
  'critiqueTheater.settingsNav': '设计评审团',
  'critiqueTheater.settingsNavHint': '为代理运行启用五人设计评审',
  'critiqueTheater.settingsEnabledLabel': '在代理运行期间显示设计评审团',
  'critiqueTheater.settingsEnabledDescription': '启用后，五人评审面板会在代理生成时同时显示，并在交付前对结果评分。你可以随时中断。',
  'critiqueTheater.settingsEnabledProjectHint': '已为该项目保存。该项目的新运行将在服务端经过设计评审团。',
  'critiqueTheater.settingsEnabledNoProjectHint': '打开项目后此设置才会服务端持久化；目前仅修改浏览器本地偏好。',
  'pet.title': '宠物',
  'pet.subtitle': '「显示宠物」控制它是否出现在工作区；下方可以选择内置、自定义或社区宠物。',
  'pet.navTitle': '宠物',
  'pet.navHint': '领养与自定义',
  'pet.tabBuiltIn': '内置',
  'pet.tabBuiltInHint': 'Open Design 内置的精选宠物 — 一键领养。',
  'pet.builtInEmpty': '暂时无法加载内置宠物。等本地服务恢复后,刷新「社区」页签再试。',
  'pet.tabCustom': '自定义',
  'pet.tabCustomHint': '自己取名、选符号或上传精灵图。',
  'pet.tabCommunity': '社区',
  'pet.tabCommunityHint': '来自 Codex 的孵化宠物 — 领养或用 AI 生成新的。',
  'pet.tabsAria': '选择宠物',
  'pet.adopt': '领养',
  'pet.adoptedBadge': '已领养',
  'pet.adoptCallout': '领养一只宠物',
  'pet.changePet': '更换宠物',
  'pet.wake': '显示宠物',
  'pet.tuck': '隐藏宠物',
  'pet.wakeTitle': '在工作区显示宠物。尚未选择时，会默认使用第一只内置宠物。',
  'pet.tuckTitle': '从工作区隐藏宠物。',
  'pet.settingsTitle': '打开宠物设置',
  'pet.useCustom': '使用我的宠物',
  'pet.customTitle': '自定义你的宠物',
  'pet.customHint': '挑一个名字、表情和主题色，浮窗会即时更新。',
  'pet.customGreetingPlaceholder': '来自宠物的问候…',
  'pet.fieldName': '名字',
  'pet.fieldGlyph': '表情',
  'pet.fieldGlyphHint': '建议使用单个 emoji（例如 🐝、🦄、🐢）。',
  'pet.fieldGreeting': '问候语',
  'pet.fieldAccent': '主题色',
  'pet.fieldAccentCustom': '自定义颜色',
  'pet.fieldAccentDefault': '默认主题色',
  'pet.overlayAria': '宠物伙伴',
  'pet.spriteAria': '{name} — 拖动可移动，点击与它互动',
  'pet.spriteTitle': '{name} 来打招呼啦！点击聊天。',
  'pet.taskSummarySingle': '正在执行 {count} 个 Agent 任务。',
  'pet.taskSummaryMultiple': '正在执行 {count} 个 Agent 任务，分布在 {projects} 个项目。',
  'pet.taskSummaryRecentSingle': '最近完成 {count} 个 Agent 任务。',
  'pet.taskSummaryRecentMultiple': '最近完成 {count} 个 Agent 任务。',
  'pet.taskListAria': '执行中的 Agent 任务',
  'pet.taskOpenProject': '打开 {project}',
  'pet.taskGroup.running': '正在执行',
  'pet.taskGroup.queued': '等待中',
  'pet.taskGroup.recent': '最近完成',
  'pet.idleQuote.leonardo.text': '学习从不会使心灵疲惫。',
  'pet.idleQuote.leonardo.author': '列奥纳多·达·芬奇',
  'pet.idleQuote.michelangelo.text': '我看见天使在大理石中，于是不断雕刻，直到让他自由。',
  'pet.idleQuote.michelangelo.author': '米开朗基罗',
  'pet.idleQuote.bernini.text': '有两样东西能帮助雕塑家：光与影。',
  'pet.idleQuote.bernini.author': '吉安·洛伦佐·贝尼尼',
  'pet.idleQuote.raphael.text': '作画时，人并不思考。',
  'pet.idleQuote.raphael.author': '拉斐尔',
  'pet.idleQuote.caravaggio.text': '作品若不是从生活中来，终究只是细枝末节。',
  'pet.idleQuote.caravaggio.author': '卡拉瓦乔',
  'pet.idleQuote.rodin.text': '最重要的是被打动、去爱、去希望、去颤抖、去生活。',
  'pet.idleQuote.rodin.author': '奥古斯特·罗丹',
  'pet.composerTitle': '宠物 — 唤醒、收起或选一只',
  'pet.composerMenuTitle': '宠物',
  'pet.composerMenuHint': '小贴士：输入 /pet 即可切换',
  'pet.composerOpenSettings': '管理宠物',
  'pet.welcomeTeaserTitle': '领养一只宠物',
  'pet.welcomeTeaserBody': '一只小小的浮窗伙伴，会陪着你工作。',
  'pet.welcomeTeaserCta': '挑一只',
  'pet.imageUpload': '上传形象',
  'pet.imageReplace': '替换形象',
  'pet.imageRemove': '改用 emoji',
  'pet.imageHintIdle': '支持 PNG / JPG / WebP / GIF / SVG。要做精灵动画？传一张横向序列图并设置帧数。',
  'pet.imageHintActive': '正在使用你上传的形象。把帧数设为 > 1 即可让横向序列图动起来。',
  'pet.fieldFrames': '帧数',
  'pet.fieldFramesHint': '1 = 静态；> 1 = 横向序列图。',
  'pet.fieldFps': '速度 (fps)',
  'pet.fieldFpsHint': '控制序列图的播放速度。',
  'pet.atlasImport': '导入 Codex 精灵图',
  'pet.atlasImportTitle': '导入 hatch-pet 8x9 / 192x208 精灵图(PNG 或 WebP)。',
  'pet.atlasPickerTitle': '选择动画行',
  'pet.atlasPickerHint': 'Codex 宠物自带 9 个动画状态。默认会保留完整精灵图,这样宠物会根据悬停、拖拽方向、长时间空闲自动切换动画。也可以只保留一个循环。',
  'pet.atlasCancel': '丢弃精灵图',
  'pet.atlasAdopt': '锁定这一行',
  'pet.atlasAdoptFull': '使用完整精灵图(动态)',
  'pet.atlasAdoptFullTitle': '保留全部动画行,让宠物对悬停、拖拽方向以及长时间空闲做出反应。',
  'pet.atlasAdoptRowTitle': '只把高亮的这一行切成单循环条带。',
  'pet.atlasActiveHint': '动态精灵图已启用 — 宠物会根据你的交互(悬停、拖拽、空闲)自动切换动画。',
  'pet.atlasRow.idle': '待机',
  'pet.atlasRow.running-right': '向右跑',
  'pet.atlasRow.running-left': '向左跑',
  'pet.atlasRow.waving': '挥手',
  'pet.atlasRow.jumping': '跳跃',
  'pet.atlasRow.failed': '失败',
  'pet.atlasRow.waiting': '等待',
  'pet.atlasRow.running': '奔跑',
  'pet.atlasRow.review': '审视',
  'pet.hatchTitle': '用 AI 孵化新宠物',
  'pet.hatchHint': '通过聊天调用内置的 hatch-pet 技能生成 Codex 风格的精灵图,完成后回到这里导入。',
  'pet.hatchConcept': '宠物概念(可选)',
  'pet.hatchConceptPlaceholder': '例如:一只穿着毛衣的像素风柴犬',
  'pet.hatchCopy': '复制提示词',
  'pet.hatchCopied': '已复制!',
  'pet.hatchFoot': '技能保存好宠物后,回到这里点击「导入 Codex 精灵图」即可。',
  'pet.slashPopoverAria': '斜杠命令',
  'pet.slashPopoverTitle': '命令',
  'pet.slashPopoverHint': '↑↓ 切换 · 回车选择 · esc 关闭',
  'pet.slashPet': '切换、领养或跳转到宠物设置。',
  'pet.slashPetWake': '唤醒漂浮的宠物。',
  'pet.slashPetTuck': '把宠物收起来。',
  'pet.slashHatch': '调用 hatch-pet 技能生成一只 Codex 宠物。',
  'pet.slashHatchArg': '<概念>',
  'pet.slashSearch': '通过 OD research 命令搜索网页。',
  'pet.slashSearchArg': '<查询>',
  'pet.codexTitle': '最近孵化',
  'pet.codexSubtitle': 'hatch-pet 技能打包的宠物会出现在这里,可一键领养。',
  'pet.codexSubtitleWithDir': '正在扫描 {dir},查找 hatch-pet 技能打包的宠物。',
  'pet.codexEmpty': '还没有孵化的宠物。在聊天中输入 /hatch 来生成一只。',
  'pet.codexLoading': '正在查找已孵化的宠物…',
  'pet.codexRefresh': '刷新',
  'pet.codexAdopt': '领养',
  'pet.codexAdopting': '领养中…',
  'pet.communitySync': '下载社区宠物',
  'pet.communitySyncing': '下载中…',
  'pet.communitySyncTitle': '从 Codex Pet Share 与 j20 Hatchery 同步最新宠物到 ~/.codex/pets/。',
  'pet.communitySyncDone': '已同步 {wrote} 个新宠物（共 {total} 个）。',
  'pet.communitySyncFailed': '同步失败：{error}',
  'pet.codexBundled': '内置',
  'pet.codexBundledTitle': 'Open Design 内置宠物，无需下载。',
  'settings.notifications': '通知',
  'settings.notificationsHint': '任务完成时的声音和桌面通知',
  'settings.notifyCompletionSound': '完成提示音',
  'settings.notifyCompletionSoundHint': '一轮任务结束时播放，默认关闭',
  'settings.notifySuccessSound': '成功音色',
  'settings.notifyFailureSound': '失败音色',
  'settings.notifyDesktop': '桌面通知',
  'settings.notifyDesktopHint': '窗口不在前台时弹出系统通知',
  'settings.notifyDesktopBlocked': '浏览器已拒绝通知权限，请在站点设置中开启',
  'settings.notifyDesktopUnsupported': '当前环境不支持桌面通知',
  'settings.notifyTest': '测试通知',
  'settings.notifyTestSent': '测试通知已发送；如果没有弹窗，请检查浏览器和系统通知设置。',
  'settings.notifyTestFailed': '通知调用失败，请检查浏览器和系统通知设置。',
  'settings.notifySoundDing': '叮',
  'settings.notifySoundChime': '风铃',
  'settings.notifySoundTwoToneUp': '上行双音',
  'settings.notifySoundPluck': '拨弦',
  'settings.notifySoundBuzz': '蜂鸣',
  'settings.notifySoundTwoToneDown': '下行双音',
  'settings.notifySoundThud': '低响',
  'settings.skills': '技能',
  'settings.skillsHint': '智能体在任务中可以调用的功能技能',
  'settings.skillsNew': '新建技能',
  'settings.skillsEmpty': '请在左侧选择一个技能，或新建一个。',
  'settings.skillsEdit': '编辑',
  'settings.skillsDelete': '删除',
  'settings.skillsDeleteConfirm': '确认删除',
  'settings.skillsName': '名称',
  'settings.skillsTriggers': '触发词（逗号或换行分隔）',
  'settings.skillsDescription': '描述',
  'settings.skillsBody': 'SKILL.md 内容',
  'settings.skillsCreate': '创建',
  'settings.skillsSave': '保存',
  'settings.skillsSaving': '保存中…',
  'settings.skillsFiles': '文件',
  'settings.skillsNoFiles': '该技能目录下暂无文件。',
  'settings.skillsNameRequired': '技能名称为必填项。',
  'settings.skillsBodyRequired': '技能内容为必填项。',
  'settings.designSystems': '设计系统',
  'settings.designSystemsHint': '管理首页 Gallery 中显示的设计系统',
  'settings.designSystemsInstalled': '已安装',
  'settings.designSystemsAdd': '添加设计系统',
  'settings.designSystemsHiddenCount': '{count} 个已从首页 Gallery 隐藏',
  'settings.designSystemsShowAll': '显示全部',
  'settings.designSystemsShowHidden': '显示隐藏项',
  'settings.designSystemsSource': '来源',
  'settings.designSystemsSourceLocal': '本地',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'shadcn 注册表引用',
  'settings.designSystemsImportShadcn': '从 shadcn 导入',
  'settings.designSystemsSourcePptx': 'Presentation',
  'settings.designSystemsImportPptx': 'Import from presentation',
  'settings.designSystemsPptxFile': 'Presentation file',
  'settings.designSystemsPptxImporting': 'Importing presentation…',
  'settings.designSystemsPptxImportFailed': 'Presentation import failed',
  'settings.designSystemsStructure': '结构',
  'settings.designSystemsModeHybrid': '混合',
  'settings.designSystemsModeNormalized': '规范化',
  'settings.designSystemsModeVerbatim': '原样保留',
  'settings.designSystemsCraft': '工艺',
  'settings.designSystemsCraftColor': '颜色',
  'settings.designSystemsCraftAccessibility': '无障碍',
  'settings.designSystemsGithubUrl': 'GitHub URL',
  'settings.designSystemsProjectPath': '项目路径',
  'settings.designSystemsImportGithub': '从 GitHub 导入',
  'settings.designSystemsImportProject': '从项目导入',
  'settings.designSystemsImportedStatus': '已导入 {title}',
  'settings.designSystemsViewImported': '查看导入的设计系统',
  'settings.designSystemsCategory': '分类',
  'settings.designSystemsAllCategories': '所有分类',
  'settings.designSystemsShowInHomeGallery': '在首页 Gallery 中显示',
  'settings.projectLocations': '项目位置',
  'settings.projectLocationsHint': '工作区存储根目录',
  'settings.projectLocationsDescription': '添加可包含多个 Open Design 项目文件夹的工作基目录。新项目会作为所选基目录内的一个文件夹保存。',
  'settings.projectLocationsSaveError': '无法保存项目位置。请检查每个路径都是可访问的文件夹。',
  'settings.projectLocationsSaved': '项目位置已保存。',
  'settings.projectLocationsScanError': '无法扫描项目位置。',
  'settings.projectLocationsScanComplete': '扫描完成：已导入 {imported} 个，已有 {existing} 个。',
  'settings.projectLocationsNoFolderSelected': '未选择文件夹。',
  'settings.projectLocationsDuplicate': '这个工作基目录已添加。',
  'settings.projectLocationsWorkBaseMeta': '工作基目录 · 项目会作为子文件夹创建在这里',
  'settings.projectLocationsAddFolder': '添加文件夹…',
  'settings.projectLocationsDefaultBadge': '默认位置',
  'settings.projectLocationsMakeDefault': '设为默认',
  'settings.projectLocationsDefaultSaved': '默认项目位置已更新。',
  'settings.librarySkills': '技能',
  'settings.libraryDesignSystems': '设计系统',
  'settings.librarySearch': '搜索...',
  'settings.libraryAll': '全部',
  'settings.libraryPreview': '预览',
  'settings.libraryPreviewClose': '关闭',
  'settings.libraryLoading': '加载中...',
  'settings.libraryNoResults': '没有匹配的项目。',
  'settings.libraryEnabled': '已启用',
  'settings.libraryDisabled': '已禁用',
  'settings.connectorsNavHint': '外部系统连接',
  'settings.connectorsHint': '管理此设备的连接器和工具提供商设置。',
  'settings.connectorsComposioApiKey': 'Composio API 密钥',
  'settings.connectorsSavedTitle': '已保存到本地 daemon',
  'settings.connectorsSavedWithTail': '已保存 · ••••{tail}',
  'settings.connectorsSaved': '已保存',
  'settings.connectorsGetApiKey': '获取 API 密钥',
  'settings.connectorsReplaceKeyPlaceholder': '粘贴新密钥以替换已保存的密钥',
  'settings.connectorsApiKeyPlaceholder': '粘贴 Composio API 密钥',
  'settings.connectorsClear': '清除',
  'settings.connectorsClearConfirmTitle': '清除已保存的 Composio API 密钥？',
  'settings.connectorsClearConfirmBody': '删除密钥会断开此工作区下所有的 Composio 连接器。已连接的账号、OAuth 授权和工具访问权限都将被一并移除。',
  'settings.connectorsClearConfirmContinue': '继续',
  'settings.connectorsClearFinalTitle': '此操作会断开所有连接器',
  'settings.connectorsClearFinalBody': '该操作无法撤销。粘贴新密钥后，需要从头重新连接每个集成。',
  'settings.connectorsClearFinalConfirm': '删除密钥并断开',
  'settings.connectorsClearArming': '稍等\u2026',
  'settings.connectorsClearCancel': '取消',
  'settings.connectorsSaveKey': '保存密钥',
  'settings.connectorsSaveKeyTitle': '将此密钥发送到本地 daemon',
  'settings.connectorsKeySaving': '保存中…',
  'settings.connectorsKeySaved': '已保存 ✓',
  'settings.connectorsKeyError': '保存密钥失败。请确认本地 daemon 已启动后再试。',
  'settings.connectorsHelpSaved': '你的密钥会解锁下方目录，并保留在本地 daemon 中。粘贴新密钥可替换，或清除以移除。',
  'settings.connectorsHelpUnsaved': '尚未保存 — 点击「保存密钥」即可把它存入本地 daemon，并解锁下方目录。',
  'settings.connectorsHelpEmpty': '添加密钥以解锁下方目录。密钥会本地存储在 daemon 中，绝不会通过环境变量发送。',
  'settings.connectorsLoadingSavedKey': '正在从本地 daemon 中检查已保存的密钥…',
  'settings.autosaveSaving': '保存中…',
  'settings.autosaveSaved': '所有更改已保存',
  'settings.autosaveError': '保存更改失败。本地 daemon 可能不在线。',
  'settings.libraryToggleLabel': '切换',
  'settings.memory': '记忆',
  'settings.memoryHint': '后续对话可复用的事实和上下文',
  'settings.customInstructionsTitle': '全局规则',
  'settings.customInstructionsHint': 'OpenDesign 每次对话都应遵守的固定指令。事实、偏好和项目上下文请保存为记忆。',
  'settings.customInstructionsPlaceholder': '例如："始终使用 TypeScript。优先使用函数式组件。保持回复简洁。"',
  'settings.memoryDescription': '控制已保存的事实、偏好和项目上下文是否会在后续对话中复用。',
  'settings.memoryEnabled': '已启用',
  'settings.memoryDisabled': '已关闭',
  'settings.memoryEnableLabel': '启用记忆注入',
  'settings.memoryDisabledBanner': '记忆当前已关闭。已有的事实文件保留在磁盘上，但不会被注入到新对话，也不会从新对话中提取新事实。',
  'settings.memoryNew': '新建记忆',
  'settings.memoryEdit': '编辑',
  'settings.memoryDelete': '删除',
  'settings.memoryPreview': '预览',
  'settings.memoryEmpty': '还没有记忆。',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'I prefer dark mode',
  'settings.memoryName': '例如：UI 偏好',
  'settings.memoryDesc': '一句话 — 这条记忆是关于什么的？',
  'settings.memoryBody': '- 规则一\n- 规则二\n\n为什么：可选\n何时适用：可选',
  'settings.memoryBodyHint': '先用 bullet 列出规则，再补「为什么」和「何时适用」（可选）。支持 Markdown。也可以点上方示例直接载入。',
  'settings.memoryStartersLabel': '不知道写什么？点一下填到表单里：',
  'settings.memoryStarterUserName': '我的角色',
  'settings.memoryStarterUserDesc': '我是一名前端工程师，在做 SaaS 设计工具',
  'settings.memoryStarterUserBody': '- 角色：高级前端工程师\n- 技术栈：React、TypeScript、Vite\n- 方向：设计 / 协作工具\n- 时区：GMT+8（Asia/Shanghai）\n\n何时适用：任何对话里举例时优先用前端 / Web 场景。',
  'settings.memoryStarterFeedbackName': 'UI 偏好',
  'settings.memoryStarterFeedbackDesc': '深色主题、字号偏大、信息密度低',
  'settings.memoryStarterFeedbackBody': '- 主题：默认深色\n- 正文字号：≥ 18px\n- 信息密度：留白多一些，一屏不要塞太多东西\n\n为什么：长时间使用眼睛不容易累。\n何时适用：让你画 UI、网页、PPT 时都按这个走。',
  'settings.memoryStarterProjectName': '当前项目',
  'settings.memoryStarterProjectDesc': 'Open Design v0.5 — 聊天驱动的设计编辑器',
  'settings.memoryStarterProjectBody': '- 目标：本季度交付聊天驱动的编辑体验\n- 优先级：流式渲染、本地多模态、离线优先\n- 技术栈：Next.js 16、Express daemon、SQLite\n\n何时适用：与本项目相关的所有对话。',
  'settings.memorySaveHint': '不会自动保存 — 点击「创建」/「保存」才生效。',
  'settings.memoryIndexSaveHint': '索引不会自动保存 — 改完后点击「保存索引」才生效。',
  'settings.memoryIndexUnsaved': '有未保存的修改',
  'settings.memoryFlashCreated': '✓ 已创建',
  'settings.memoryFlashSaved': '✓ 已保存',
  'settings.memoryFlashDeleted': '✓ 已删除',
  'settings.memoryFlashIndexSaved': '✓ 索引已保存',
  'settings.memoryFlashPathCopied': '✓ 路径已复制',
  'settings.memoryNameLabel': '标题',
  'settings.memoryTypeLabel': '类型',
  'settings.memoryDescLabel': '描述',
  'settings.memoryBodyLabel': '内容',
  'settings.memoryTypeUser': '用户',
  'settings.memoryTypeFeedback': '反馈',
  'settings.memoryTypeProject': '项目',
  'settings.memoryTypeReference': '引用',
  'settings.memoryIndex': 'MEMORY.md（索引）',
  'settings.memoryIndexSave': '保存索引',
  'settings.memoryIndexReset': '重置',
  'settings.memoryToastChanged': '记忆已更新',
  'settings.memoryToastClickHint': '查看',
  'settings.memoryAll': '全部',
  'settings.memoryExtractions': '抽取历史',
  'settings.memoryExtractionsHint': '最近的 LLM 抽取记录。每次对话结束后，启发式正则会先跑，LLM 抽取在后台异步进行。',
  'settings.memoryExtractionsEmpty': '暂无抽取记录。下一次对话结束后会出现在这里。',
  'settings.memoryExtractionsRefresh': '刷新',
  'settings.memoryExtractionsRefreshing': '刷新中…',
  'settings.memoryExtractionPhaseRunning': '抽取中…',
  'settings.memoryExtractionPhaseSuccess': '成功',
  'settings.memoryExtractionPhaseSkipped': '已跳过',
  'settings.memoryExtractionPhaseFailed': '失败',
  'settings.memoryExtractionSkipNoProvider': '未配置 API key，LLM 抽取未运行。',
  'settings.memoryExtractionSkipDisabled': '记忆功能已关闭。',
  'settings.memoryExtractionSkipEmpty': '用户消息为空，没有可抽取的内容。',
  'settings.memoryExtractionSkipNoMatch': '本轮没有命中任何正则规则。',
  'settings.memoryExtractionKindHeuristic': '正则',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': '环境变量',
  'settings.memoryExtractionProviderMediaConfig': '媒体设置',
  'settings.memoryExtractionProviderOverride': '记忆设置',
  'settings.memoryExtractionProposed': '候选',
  'settings.memoryExtractionWritten': '写入',
  'settings.memoryExtractionDuration': '耗时',
  'settings.memoryExtractionDelete': '删除',
  'settings.memoryExtractionsClear': '清空',
  'settings.memoryExtractionsClearTitle': '清空整个抽取历史',
  'settings.memoryExtractionsClearConfirm': '确定要清空整个抽取历史吗？此操作无法撤销。',
  'settings.memoryNoProviderBannerTitle': 'LLM 抽取未启用',
  'settings.memoryNoProviderBannerBody': '未找到可用的 API key，LLM 抽取已跳过。可以在媒体提供商里填入 OpenAI key，或设置环境变量 ANTHROPIC_API_KEY / OPENAI_API_KEY 来启用。启发式抽取仍在运行。',
  'settings.libraryInstall': '安装',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': '本地路径',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': '安装',
  'settings.libraryUninstall': '卸载',
  'settings.libraryBuiltIn': '内置',
  'settings.libraryInstalled': '已安装',
  'notify.successTitle': '任务已完成',
  'notify.failureTitle': '任务失败',
  'notify.successBody': '一轮回答已经写完。',
  'notify.failureBody': '本轮任务出错，请查看错误信息。',
  'updater.available': '有可用更新',
  'updater.availableBody': 'Open Design {version} 可用。下载安装完成后即可打开安装器。',
  'updater.checking': '正在检查更新',
  'updater.download': '下载更新',
  'updater.downloading': '正在下载更新',
  'updater.downloadingPercent': '正在下载更新 {percent}%',
  'updater.done': '完成',
  'updater.failed': '更新失败',
  'updater.installerOpenBody': '安装器已打开。Open Design 正在退出，以便你完成更新。',
  'updater.installerOpened': '安装器已打开',
  'updater.later': '稍后',
  'updater.openFailedFallback': '无法打开安装器。',
  'updater.installRestart': '安装并重启',
  'updater.installingRestart': '正在安装并重启…',
  'updater.openInstaller': '安装更新',
  'updater.opening': '正在打开安装器…',
  'updater.payloadReadyGeneric': 'Open Design 更新已就绪。Open Design 会关闭并自动重启。',
  'updater.payloadReadyVersion': 'Open Design {version} 已就绪。Open Design 会关闭并自动重启。',
  'updater.quitButton': '退出 Open Design',
  'updater.quitFailedBody': '安装器已打开，但 Open Design 无法退出。替换应用前请先退出 Open Design。',
  'updater.quitFailedTitle': '无法退出',
  'updater.quitting': '正在退出…',
  'updater.ready': '更新已就绪',
  'updater.readyGeneric': '新版本已就绪。Open Design 会关闭并打开安装器。',
  'updater.readyVersion': 'Open Design {version} 已就绪。Open Design 会关闭并打开安装器。',
  'updater.upToDate': '您已经是最新版本啦',

  'newsletter.label': '邮箱地址（选填）',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Memory 模型',
  'settings.memoryModelInlineSameAsChat': '与聊天一致',
  'settings.memoryModelInlineSameAsChatWithModel': '与聊天一致（{model}）',
  'settings.memoryModelInlineSameAsChatWithProvider': '与聊天一致（{provider}）',
  'settings.memoryModelInlineHintCli': '可选。支持的情况下会直接使用当前 Local CLI；这里只需要在想覆盖默认模型时选择。',
  'settings.memoryModelInlineHintCliConstrained': '可选。支持时会直接使用当前 Local CLI；{provider} 只作为不支持 CLI 时的备用供应商。',
  'settings.memoryModelInlineHintByok': '可选。复用你聊天用的 API key，在同供应商上换一个（通常更便宜的）模型来跑后台 memory 提取。',
  'settings.memoryModelInlineHintByokNeutral': 'Memory 使用独立于聊天的模型，默认沿用当前聊天模型。',
  'settings.memoryModelInlineFlashSaved': '已保存',
  'settings.memoryModelInlineFlashCleared': '已清除',
  'settings.orbit.eyebrow': '自动化',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': '每日连接器摘要',
  'settings.orbit.lede': '按计划收集连接器活动，并将结果发布为可刷新的实时看板。',
  'settings.orbit.statusOnTitle': '每日计划运行已开启',
  'settings.orbit.statusOffTitle': '每日计划运行已关闭',
  'settings.orbit.statusActive': '活跃',
  'settings.orbit.statusOff': '关闭',
  'settings.orbit.runTitle': '启动一次 Orbit 运行并打开实时对话',
  'settings.orbit.running': '运行中…',
  'settings.orbit.runOpen': '立即运行',
  'settings.orbit.dailySummaryTitle': '每日摘要',
  'settings.orbit.dailySummarySub': '每天在计划的本地时间运行一次。',
  'settings.orbit.on': '开启',
  'settings.orbit.off': '关闭',
  'settings.orbit.runTimeTitle': '运行时间',
  'settings.orbit.runTimeSub': '默认 08:00。保存后应用到 daemon 计划。',
  'settings.orbit.runTimeAria': '每日 Orbit 运行时间',
  'settings.orbit.nextRun': '下次运行',
  'settings.orbit.nextRunScheduledAfterSave': '保存后计划',
  'settings.orbit.schedule': '计划',
  'settings.orbit.pausedManualOnly': '已暂停 — 仅手动运行',
  'settings.orbit.templateTitle': '提示词模板',
  'settings.orbit.templateMissing': '模板 {id} 未安装。',
  'settings.orbit.templateMissingOption': '{id}（缺失）',
  'settings.orbit.templateMissingInstall': '安装 Orbit skill 以引导提示词。',
  'settings.orbit.templateMissingPickAnother': '从下拉菜单选择另一个模板。',
  'settings.orbit.templateResetTitle': '重置为 {id}',
  'settings.orbit.templateReset': '重置',
  'settings.orbit.templateHelp': '用 skill 引导 Orbit — 所选模板的示例提示词会注入每次 Orbit 运行，让摘要遵循该模板结构。',
  'settings.orbit.templateAria': 'Orbit 提示词模板',
  'settings.orbit.templatesLoading': '正在加载模板…',
  'settings.orbit.templatesOptgroup': 'Orbit skill 模板',
  'settings.orbit.lastRun': '上次运行',
  'settings.orbit.triggerManual': '手动',
  'settings.orbit.triggerScheduled': '计划',
  'settings.orbit.meterAria': '已成功 {succeeded}，已跳过 {skipped}，失败 {failed}，共检查 {checked}',
  'settings.orbit.countChecked': '已检查',
  'settings.orbit.countSucceeded': '成功',
  'settings.orbit.countSkipped': '已跳过',
  'settings.orbit.countFailed': '失败',
  'settings.orbit.runError': '无法运行 Orbit。请确认本地 daemon 正在运行且连接器已配置。',
  'settings.orbit.gateAriaLabel': '使用 Orbit 需要先配置连接器',
  'settings.orbit.gateEyebrow': '需要先完成设置',
  'settings.orbit.gateTitle': '连接一个工具，让 Orbit 运行起来',
  'settings.orbit.gateBody': 'Orbit 会汇总你已连接服务的活动。你目前还没有任何连接 —— 至少添加一个集成，让 Orbit 有内容可以报告。',
  'settings.orbit.gateBodyNoKey': 'Orbit 会汇总连接器的活动，而连接器通过 Composio 运行。在「连接器」中填入 Composio API 密钥即可解锁目录并选择第一个集成。',
  'settings.orbit.gateAction': '打开连接器',
  'settings.orbit.gateActionNoKey': '配置 Composio',
  'settings.orbit.gateLoading': '正在检查连接器…',
  'settings.orbit.controlsLockedBadge': '已锁定',
  'settings.orbit.controlsLockedHint': '连接一个工具后即可解锁 Orbit 的排程与模板设置。',
  'settings.orbit.artifactKickerLive': '实时看板',
  'settings.orbit.artifactKickerLegacy': '旧版摘要',
  'settings.orbit.artifactTitle': '每日 Orbit 活动摘要',
  'settings.orbit.artifactMetaLive': '由连接器活动生成的可刷新 HTML artifact。',
  'settings.orbit.artifactMetaLegacy': '在启用实时看板支持之前生成 — 再次运行 Orbit 以发布一个。',
  'settings.orbit.copyMarkdownTitle': '复制 Markdown 摘要到剪贴板',
  'settings.orbit.copied': '已复制',
  'settings.orbit.copy': '复制',
  'settings.orbit.openArtifact': '打开 artifact',
  'settings.orbit.sourceMarkdown': '源 Markdown',
  'diagnostics.exportTitle': '导出诊断日志',
  'diagnostics.exportButton': '导出诊断日志',
  'diagnostics.exportHint': '将近期的应用日志和机器信息打包成 zip,方便发给我们排查问题。',
  'diagnostics.exporting': '导出中…',
  'diagnostics.exportSuccess': '诊断日志已保存到 {path}',
  'diagnostics.exportFailed': '导出诊断日志失败：{message}',
  'automations.eyebrow': '定时智能体会话',
  'automations.title': '自动化',
  'automations.lede': '为项目工作、Orbit 摘要和实时看板规划周期性会话。',
  'automations.summaryAria': '自动化概览',
  'automations.metricActive': '运行中',
  'automations.metricPaused': '已暂停',
  'automations.metricTemplates': '模板',
  'automations.newAutomation': '新建自动化',
  'automations.yourAutomations': '你的自动化',
  'automations.loading': '加载中',
  'automations.emptyTitle': '还没有自动化',
  'automations.emptyBody': '从模板创建一个，或从空白计划开始。',
  'automations.targetNewEachRun': '每次运行新建项目',
  'automations.lastRun': '上次运行 {time}',
  'automations.openResult': '打开结果',
  'automations.run': '运行',
  'automations.runNowTitle': '立即运行并打开会话',
  'automations.history': '历史记录',
  'automations.hideHistory': '隐藏历史记录',
  'automations.edit': '编辑',
  'automations.pause': '暂停',
  'automations.resume': '恢复',
  'automations.deleteAria': '删除自动化',
  'automations.deleteTitle': '删除此自动化',
  'automations.deleteConfirm': '删除此自动化？过去的运行及其项目会保留。',
  'automations.proposalsTitle': '进化提案',
  'automations.proposalsSub': '在自动化输出改动记忆、技能或设计体系之前先审阅。',
  'automations.proposalsPending': '{n} 个待处理',
  'automations.apply': '应用',
  'automations.reject': '拒绝',
  'automations.proposalsDismissReason': '在自动化中已忽略',
  'automations.templatesTitle': '模板',
  'automations.templatesSub': 'Orbit 和实时看板都是同一自动化流程中的模板。',
  'automations.templatesCount': '{total} 个中的 {filtered} 个',
  'automations.templateFiltersAria': '模板筛选',
  'automations.templatesEmptyTitle': '此分类下还没有模板。',
  'automations.templatesEmptyBody': '换一个筛选条件，或从空白自动化开始。',
  'automations.useTemplate': '使用模板',
  'automations.runHistoryLoading': '正在加载运行历史…',
  'automations.runHistoryEmpty': '还没有运行记录。',
  'automations.runHistoryTitle': '运行历史',
  'automations.runHistoryLatest': '最近 10 条',
  'automations.crystallize': '沉淀',
  'automations.crystallizing': '沉淀中',
  'automations.crystallizeTitle': '根据本次运行起草技能和记忆提案',
  'automations.openConversation': '打开会话',
  'automations.runHistoryAria': '自动化运行历史',
  'automations.proposalsAria': '自动化进化提案',
  'automations.templatesAria': '自动化模板',
  'automations.runInProgress': '进行中',
  'automations.scheduleStatusPaused': '已暂停',
  'automations.nextRunManualOnly': '仅手动',
  'automations.nextRunScheduled': '已排期',
  'automations.nextRunAt': '下次 {time}',
  'automations.statusSucceeded': '成功',
  'automations.statusFailed': '失败',
  'automations.statusRunning': '运行中',
  'automations.statusQueued': '排队中',
  'automations.statusCanceled': '已取消',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': '实时看板',
  'automations.kindAutomation': '自动化',
  'automations.proposalTargetMemory': '记忆',
  'automations.proposalTargetDesignSystem': '设计体系',
  'automations.proposalTargetSkill': '技能',
  'automations.proposalTargetTemplate': '自动化模板',
  'automations.proposalActionCreate': '创建',
  'automations.proposalActionUpdate': '更新',
  'automations.proposalActionMerge': '合并',
  'automations.proposalActionMove': '移动',
  'automations.proposalActionDelete': '删除',
  'automations.proposalActionPromote': '提升',
  'automations.filterAll': '全部',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': '实时看板',
  'automations.filterMemory': '记忆',
  'automations.filterDesignSystems': '设计体系',
  'automations.filterSkills': '技能',
  'automations.filterConnectors': '连接器',
  'automations.filterCompression': '压缩',
  'automations.filterRelease': '发布',
  'automations.filterQuality': '质量',
  'automations.tpl.memoryRefresh.title': '根据近期工作刷新项目记忆。',
  'automations.tpl.memoryRefresh.desc': '把重复的决策、偏好和反馈转化为可复用的记忆更新。',
  'automations.tpl.designSystemRefresh.title': '根据已交付的制品更新设计体系。',
  'automations.tpl.designSystemRefresh.desc': '在近期设计工作中发现可复用的 token、组件和规则。',
  'automations.tpl.liveArtifactRegistry.title': '审计实时看板并刷新过时版本。',
  'automations.tpl.liveArtifactRegistry.desc': '让持久的仪表盘、报告和预览保持最新，而不是重复创建。',
  'automations.tpl.orbitDashboard.title': '构建连接器活动仪表盘。',
  'automations.tpl.orbitDashboard.desc': '把选定的连接器聚合成 Orbit 风格的实时仪表盘。',
  'automations.tpl.releaseNotes.title': '根据已交付的设计工作起草发布说明。',
  'automations.tpl.releaseNotes.desc': '把已合并的 PR、制品和面向产品的改动整合成发布说明。',
  'automations.tpl.qualityRegressionWatch.title': '监测设计与实现的回归问题。',
  'automations.tpl.qualityRegressionWatch.desc': '把近期改动与基准、追踪记录和已采纳的参考进行对比。',
  'automations.tpl.orbitDaily.title': '每日连接器摘要。',
  'automations.tpl.orbitDaily.desc': '按计划刷新连接器活动摘要。',
  'automations.tpl.liveStatusBoard.title': '保持实时状态制品始终最新。',
  'automations.tpl.liveStatusBoard.desc': '更新同一个持久制品，而不是每次运行都新建报告。',
  'dsManager.areaAria': '设计体系区域',
  'dsManager.tabDesignSystem': '设计体系',
  'dsManager.tabTemplate': '模板',
  'dsManager.sourceAria': '设计体系来源',
  'dsManager.templateSourceAria': '模板来源',
  'dsManager.yourSystems': '你的体系',
  'dsManager.officialPresets': '官方预设',
  'dsManager.enterprise': '企业版',
  'dsManager.yourTemplates': '你的模板',
  'dsManager.yourSystemsAria': '你的设计体系',
  'dsManager.eyebrowDesignSystems': '设计体系',
  'dsManager.yourSystemsHeading': '你的体系',
  'dsManager.filterAria': '筛选设计体系',
  'dsManager.filterAll': '全部',
  'dsManager.filterPublished': '已发布',
  'dsManager.filterDraft': '草稿',
  'dsManager.createTitle': '新建设计体系',
  'dsManager.createBody': '把你的品牌、产品、代码、素材和设计参考教给 Open Design。',
  'dsManager.createAction': '创建',
  'dsManager.emptyMine': '还没有设计体系。从真实的产品上下文创建一个，审阅草稿后再发布，供以后的项目使用。',
  'dsManager.badgeDefault': '默认',
  'dsManager.rowMetaUpdated': '你 · 更新于 {date}',
  'dsManager.edit': '编辑',
  'dsManager.makeDefault': '设为默认',
  'dsManager.statusPublished': '已发布',
  'dsManager.statusDraft': '草稿',
  'dsManager.openSystemAria': '打开 {title}',
  'dsManager.deleteSystemAria': '删除 {title}',
  'dsManager.presetsAria': '官方设计体系预设',
  'dsManager.eyebrowLibrary': '库',
  'dsManager.eyebrowTemplates': '模板',
  'dsManager.yourTemplatesAria': '你的模板',
  'dsManager.emptyTemplates': '还没有模板。启用模板发布后，可通过任意已生成项目的「分享」来创建。',
  'dsManager.templateDescFallback': '从项目创建',
  'dsManager.comingSoonBadge': '敬请期待',
  'dsManager.enterpriseDsTitle': '企业设计体系',
  'dsManager.enterpriseDsBody': '团队共享的设计体系和受管控的品牌库即将推出。',
  'dsManager.enterpriseTplTitle': '企业模板',
  'dsManager.enterpriseTplBody': '团队批准的模板和组织级发布即将推出。',
  'settings.instructionsTitle': '指令 / 规则',
  'settings.instructionsSubtitle': '助手应始终遵循的固定行为',
  'settings.instructionsNavSub': '固定的助手行为',
  'settings.customInstructionsDesc': 'Open Design 在每次对话中都会遵循的固定指令。它们不是保存的记忆；事实、偏好和项目上下文请使用「记忆」。',
  'mcpClient.forwardedToLabel': '已转发给：',
  'mcpClient.notForwardedToLabel': '未转发给：',
  'mcpClient.forwardedAcpNote': '标记为 stdio only 的 ACP 适配器只会从此列表接收 stdio 类型的 MCP 服务器；HTTP 和 SSE 条目会在启动时被丢弃。',
  'mcpClient.notForwardedNote': '对于这些智能体，请在其各自的配置文件中配置 MCP 服务器（例如 ~/.codex/config.toml、~/.gemini/settings.json）；下方的服务器在那里不会生效。',
};
